/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AdvertisementDetailsDto
 */
export interface AdvertisementDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof AdvertisementDetailsDto
     */
    'objective': AdvertisementDetailsDtoObjectiveEnum;
    /**
     * 
     * @type {string}
     * @memberof AdvertisementDetailsDto
     */
    'communicationType': AdvertisementDetailsDtoCommunicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdvertisementDetailsDto
     */
    'inventory': AdvertisementDetailsDtoInventoryEnum;
    /**
     * 
     * @type {AttributionDto}
     * @memberof AdvertisementDetailsDto
     */
    'attribution': AttributionDto;
}

export const AdvertisementDetailsDtoObjectiveEnum = {
    Awareness: 'awareness',
    Consideration: 'consideration',
    Loyalty: 'loyalty'
} as const;

export type AdvertisementDetailsDtoObjectiveEnum = typeof AdvertisementDetailsDtoObjectiveEnum[keyof typeof AdvertisementDetailsDtoObjectiveEnum];
export const AdvertisementDetailsDtoCommunicationTypeEnum = {
    Crm: 'crm',
    EcommerceDisplay: 'ecommerceDisplay',
    EcommerceSearch: 'ecommerceSearch'
} as const;

export type AdvertisementDetailsDtoCommunicationTypeEnum = typeof AdvertisementDetailsDtoCommunicationTypeEnum[keyof typeof AdvertisementDetailsDtoCommunicationTypeEnum];
export const AdvertisementDetailsDtoInventoryEnum = {
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Banner: 'banner',
    Email: 'email'
} as const;

export type AdvertisementDetailsDtoInventoryEnum = typeof AdvertisementDetailsDtoInventoryEnum[keyof typeof AdvertisementDetailsDtoInventoryEnum];

/**
 * 
 * @export
 * @interface AdvertisementDetailsRequest
 */
export interface AdvertisementDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdvertisementDetailsRequest
     */
    'objective': AdvertisementDetailsRequestObjectiveEnum;
    /**
     * 
     * @type {string}
     * @memberof AdvertisementDetailsRequest
     */
    'communicationType': AdvertisementDetailsRequestCommunicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdvertisementDetailsRequest
     */
    'inventory': AdvertisementDetailsRequestInventoryEnum;
    /**
     * 
     * @type {AttributionRequest}
     * @memberof AdvertisementDetailsRequest
     */
    'attribution': AttributionRequest;
}

export const AdvertisementDetailsRequestObjectiveEnum = {
    Awareness: 'awareness',
    Consideration: 'consideration',
    Loyalty: 'loyalty'
} as const;

export type AdvertisementDetailsRequestObjectiveEnum = typeof AdvertisementDetailsRequestObjectiveEnum[keyof typeof AdvertisementDetailsRequestObjectiveEnum];
export const AdvertisementDetailsRequestCommunicationTypeEnum = {
    Crm: 'crm',
    EcommerceDisplay: 'ecommerceDisplay',
    EcommerceSearch: 'ecommerceSearch'
} as const;

export type AdvertisementDetailsRequestCommunicationTypeEnum = typeof AdvertisementDetailsRequestCommunicationTypeEnum[keyof typeof AdvertisementDetailsRequestCommunicationTypeEnum];
export const AdvertisementDetailsRequestInventoryEnum = {
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Banner: 'banner',
    Email: 'email'
} as const;

export type AdvertisementDetailsRequestInventoryEnum = typeof AdvertisementDetailsRequestInventoryEnum[keyof typeof AdvertisementDetailsRequestInventoryEnum];

/**
 * 
 * @export
 * @interface ApiDetailDto
 */
export interface ApiDetailDto {
    /**
     * 
     * @type {string}
     * @memberof ApiDetailDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiDetailDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof ApiDetailDto
     */
    'apiType': ApiDetailDtoApiTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiDetailDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ApiDetailDto
     */
    'method': ApiDetailDtoMethodEnum;
}

export const ApiDetailDtoApiTypeEnum = {
    Redeem: 'redeem',
    RedeemBack: 'redeem-back',
    Promotion: 'promotion'
} as const;

export type ApiDetailDtoApiTypeEnum = typeof ApiDetailDtoApiTypeEnum[keyof typeof ApiDetailDtoApiTypeEnum];
export const ApiDetailDtoMethodEnum = {
    Post: 'post',
    Get: 'get',
    Put: 'put',
    Delete: 'delete'
} as const;

export type ApiDetailDtoMethodEnum = typeof ApiDetailDtoMethodEnum[keyof typeof ApiDetailDtoMethodEnum];

/**
 * 
 * @export
 * @interface ApiDetailResponse
 */
export interface ApiDetailResponse {
    /**
     * 
     * @type {ApiDetailDto}
     * @memberof ApiDetailResponse
     */
    'apiDetail': ApiDetailDto;
}
/**
 * 
 * @export
 * @interface ApiDetailUpdateRequest
 */
export interface ApiDetailUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiDetailUpdateRequest
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDetailUpdateRequest
     */
    'method'?: ApiDetailUpdateRequestMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiDetailUpdateRequest
     */
    'signature'?: string;
}

export const ApiDetailUpdateRequestMethodEnum = {
    Post: 'post',
    Get: 'get',
    Put: 'put',
    Delete: 'delete'
} as const;

export type ApiDetailUpdateRequestMethodEnum = typeof ApiDetailUpdateRequestMethodEnum[keyof typeof ApiDetailUpdateRequestMethodEnum];

/**
 * 
 * @export
 * @interface ApiDetailsResponse
 */
export interface ApiDetailsResponse {
    /**
     * 
     * @type {Array<ApiDetailDto>}
     * @memberof ApiDetailsResponse
     */
    'apiDetails': Array<ApiDetailDto>;
    /**
     * 
     * @type {number}
     * @memberof ApiDetailsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AppCashbackDto
 */
export interface AppCashbackDto {
    /**
     * 
     * @type {string}
     * @memberof AppCashbackDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppCashbackDto
     */
    'app': string;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'percentage': number;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'expiry': number;
    /**
     * 
     * @type {string}
     * @memberof AppCashbackDto
     */
    'unit': AppCashbackDtoUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'minPurchaseValue': number;
    /**
     * 
     * @type {boolean}
     * @memberof AppCashbackDto
     */
    'partialRedemptionEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'validAfterNumberOfDays': number;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'multiplier': number;
    /**
     * 
     * @type {UserDataCollectionDto}
     * @memberof AppCashbackDto
     */
    'userDataCollection': UserDataCollectionDto;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'aov'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppCashbackDto
     */
    'boosterReward': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppCashbackDto
     */
    'triggerDiscountPreGeneration'?: boolean;
    /**
     * 
     * @type {PromotionCashbackDto}
     * @memberof AppCashbackDto
     */
    'promotion'?: PromotionCashbackDto;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'minimumRedemptionValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'tier'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppCashbackDto
     */
    'useCashbackPopups'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackDto
     */
    'remindsBeforeDays': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppCashbackDto
     */
    'enabled': boolean;
}

export const AppCashbackDtoUnitEnum = {
    Day: 'day',
    Month: 'month'
} as const;

export type AppCashbackDtoUnitEnum = typeof AppCashbackDtoUnitEnum[keyof typeof AppCashbackDtoUnitEnum];

/**
 * 
 * @export
 * @interface AppCashbackListResponse
 */
export interface AppCashbackListResponse {
    /**
     * 
     * @type {Array<AppCashbackDto>}
     * @memberof AppCashbackListResponse
     */
    'appCashbacks': Array<AppCashbackDto>;
    /**
     * 
     * @type {number}
     * @memberof AppCashbackListResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AppCashbackResponse
 */
export interface AppCashbackResponse {
    /**
     * 
     * @type {AppCashbackDto}
     * @memberof AppCashbackResponse
     */
    'appCashback': AppCashbackDto;
}
/**
 * 
 * @export
 * @interface AppEcommerceCreateRequest
 */
export interface AppEcommerceCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AppEcommerceCreateRequest
     */
    'productPrefix': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppEcommerceCreateRequest
     */
    'allowManualDiscount'?: boolean;
}
/**
 * 
 * @export
 * @interface AppEcommerceDto
 */
export interface AppEcommerceDto {
    /**
     * 
     * @type {string}
     * @memberof AppEcommerceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppEcommerceDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof AppEcommerceDto
     */
    'productPrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppEcommerceDto
     */
    'orderCompletedState'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppEcommerceDto
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppEcommerceDto
     */
    'allowManualDiscount'?: boolean;
}
/**
 * 
 * @export
 * @interface AppEcommerceResponse
 */
export interface AppEcommerceResponse {
    /**
     * 
     * @type {AppEcommerceDto}
     * @memberof AppEcommerceResponse
     */
    'appEcommerce': AppEcommerceDto | null;
}
/**
 * 
 * @export
 * @interface AppFreeShippingCreateRequest
 */
export interface AppFreeShippingCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AppFreeShippingCreateRequest
     */
    'tier'?: string;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingCreateRequest
     */
    'daysToExpire'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingCreateRequest
     */
    'numberOfDiscounts': number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingCreateRequest
     */
    'maximumShippingAmount': number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingCreateRequest
     */
    'minimumOrderValue'?: number;
}
/**
 * 
 * @export
 * @interface AppFreeShippingDto
 */
export interface AppFreeShippingDto {
    /**
     * 
     * @type {string}
     * @memberof AppFreeShippingDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppFreeShippingDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof AppFreeShippingDto
     */
    'tier'?: string;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingDto
     */
    'daysToExpire'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingDto
     */
    'numberOfDiscounts': number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingDto
     */
    'maximumShippingAmount': number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingDto
     */
    'minimumOrderValue'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppFreeShippingDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof AppFreeShippingDto
     */
    'promotionUtmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppFreeShippingDto
     */
    'promotionId'?: string;
}
/**
 * 
 * @export
 * @interface AppFreeShippingListResposne
 */
export interface AppFreeShippingListResposne {
    /**
     * 
     * @type {Array<AppFreeShippingDto>}
     * @memberof AppFreeShippingListResposne
     */
    'appFreeShippings': Array<AppFreeShippingDto>;
}
/**
 * 
 * @export
 * @interface AppFreeShippingResposne
 */
export interface AppFreeShippingResposne {
    /**
     * 
     * @type {AppFreeShippingDto}
     * @memberof AppFreeShippingResposne
     */
    'appFreeShipping': AppFreeShippingDto;
}
/**
 * 
 * @export
 * @interface AppFreeShippingUpdateRequest
 */
export interface AppFreeShippingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AppFreeShippingUpdateRequest
     */
    'tier'?: string;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingUpdateRequest
     */
    'daysToExpire'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingUpdateRequest
     */
    'numberOfDiscounts'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingUpdateRequest
     */
    'minimumOrderValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppFreeShippingUpdateRequest
     */
    'maximumShippingAmount'?: number;
}
/**
 * 
 * @export
 * @interface AppPurchaseCreateRequest
 */
export interface AppPurchaseCreateRequest {
    /**
     * 
     * @type {Array<PurchaseValuesModelCreateRequest>}
     * @memberof AppPurchaseCreateRequest
     */
    'values': Array<PurchaseValuesModelCreateRequest>;
    /**
     * 
     * @type {number}
     * @memberof AppPurchaseCreateRequest
     */
    'digits': number;
    /**
     * 
     * @type {number}
     * @memberof AppPurchaseCreateRequest
     */
    'minPurchaseValue'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppPurchaseCreateRequest
     */
    'autoPointsAdjustment'?: boolean;
}
/**
 * 
 * @export
 * @interface AppPurchaseDto
 */
export interface AppPurchaseDto {
    /**
     * 
     * @type {string}
     * @memberof AppPurchaseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppPurchaseDto
     */
    'app': string;
    /**
     * 
     * @type {Array<PurchaseValuesModelDto>}
     * @memberof AppPurchaseDto
     */
    'values': Array<PurchaseValuesModelDto>;
    /**
     * 
     * @type {number}
     * @memberof AppPurchaseDto
     */
    'minPurchaseValue': number;
    /**
     * 
     * @type {number}
     * @memberof AppPurchaseDto
     */
    'digits': number;
    /**
     * 
     * @type {string}
     * @memberof AppPurchaseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppPurchaseDto
     */
    'autoPointsAdjustment': boolean;
}
/**
 * 
 * @export
 * @interface AppPurchaseResponse
 */
export interface AppPurchaseResponse {
    /**
     * 
     * @type {AppPurchaseDto}
     * @memberof AppPurchaseResponse
     */
    'purchase': AppPurchaseDto;
}
/**
 * 
 * @export
 * @interface AppPurchaseUpdateRequest
 */
export interface AppPurchaseUpdateRequest {
    /**
     * 
     * @type {Array<PurchaseValuesModelCreateRequest>}
     * @memberof AppPurchaseUpdateRequest
     */
    'values'?: Array<PurchaseValuesModelCreateRequest>;
    /**
     * 
     * @type {number}
     * @memberof AppPurchaseUpdateRequest
     */
    'digits'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppPurchaseUpdateRequest
     */
    'minPurchaseValue'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppPurchaseUpdateRequest
     */
    'autoPointsAdjustment'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicableDiscount
 */
export interface ApplicableDiscount {
    /**
     * Discount Identifier
     * @type {string}
     * @memberof ApplicableDiscount
     */
    'id'?: string;
    /**
     * 
     * @type {ApplicableDiscountDiscount}
     * @memberof ApplicableDiscount
     */
    'discount'?: ApplicableDiscountDiscount | null;
    /**
     * Discount amount
     * @type {number}
     * @memberof ApplicableDiscount
     */
    'amount': number;
    /**
     * Response status message
     * @type {string}
     * @memberof ApplicableDiscount
     */
    'message': string;
}
/**
 * Discount Identifier
 * @export
 * @interface ApplicableDiscountDiscount
 */
export interface ApplicableDiscountDiscount {
    /**
     * User latest source
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'userSource'?: ApplicableDiscountDiscountUserSourceEnum;
    /**
     * User source at discount creation
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'originalUserSource'?: ApplicableDiscountDiscountOriginalUserSourceEnum;
    /**
     * User source at redeem time
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'redeemedUserSource'?: ApplicableDiscountDiscountRedeemedUserSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof ApplicableDiscountDiscount
     */
    'value': number;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicableDiscountDiscount
     */
    'used': boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'status': ApplicableDiscountDiscountStatusEnum;
    /**
     * 
     * @type {ReferenceDto}
     * @memberof ApplicableDiscountDiscount
     */
    'reference'?: ReferenceDto;
    /**
     * 
     * @type {Array<DiscountOrderDto>}
     * @memberof ApplicableDiscountDiscount
     */
    'orders'?: Array<DiscountOrderDto>;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'usedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'source': ApplicableDiscountDiscountSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'cardId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'createdByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'returnedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'returnedByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'returnedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'remindsAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'redeemedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'redeemedByGroup'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicableDiscountDiscount
     */
    'usedValue'?: number;
    /**
     * 
     * @type {CashbackConfigDto}
     * @memberof ApplicableDiscountDiscount
     */
    'cashbackConfig': CashbackConfigDto;
    /**
     * 
     * @type {DiscountSkuDto}
     * @memberof ApplicableDiscountDiscount
     */
    'skuDetails'?: DiscountSkuDto;
    /**
     * 
     * @type {BogoDto}
     * @memberof ApplicableDiscountDiscount
     */
    'bogoDetails'?: BogoDto;
    /**
     * 
     * @type {string}
     * @memberof ApplicableDiscountDiscount
     */
    'type'?: ApplicableDiscountDiscountTypeEnum;
    /**
     * 
     * @type {DiscountPointsDto}
     * @memberof ApplicableDiscountDiscount
     */
    'points'?: DiscountPointsDto;
}

export const ApplicableDiscountDiscountUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type ApplicableDiscountDiscountUserSourceEnum = typeof ApplicableDiscountDiscountUserSourceEnum[keyof typeof ApplicableDiscountDiscountUserSourceEnum];
export const ApplicableDiscountDiscountOriginalUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type ApplicableDiscountDiscountOriginalUserSourceEnum = typeof ApplicableDiscountDiscountOriginalUserSourceEnum[keyof typeof ApplicableDiscountDiscountOriginalUserSourceEnum];
export const ApplicableDiscountDiscountRedeemedUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type ApplicableDiscountDiscountRedeemedUserSourceEnum = typeof ApplicableDiscountDiscountRedeemedUserSourceEnum[keyof typeof ApplicableDiscountDiscountRedeemedUserSourceEnum];
export const ApplicableDiscountDiscountStatusEnum = {
    Used: 'used',
    Valid: 'valid',
    Expired: 'expired',
    Returned: 'returned',
    Cancelled: 'cancelled',
    Pending: 'pending'
} as const;

export type ApplicableDiscountDiscountStatusEnum = typeof ApplicableDiscountDiscountStatusEnum[keyof typeof ApplicableDiscountDiscountStatusEnum];
export const ApplicableDiscountDiscountSourceEnum = {
    OnlineOrder: 'onlineOrder',
    OfflineOrder: 'offlineOrder',
    WelcomeGift: 'WelcomeGift',
    Campaign: 'campaign',
    Points: 'points',
    Flows: 'flows'
} as const;

export type ApplicableDiscountDiscountSourceEnum = typeof ApplicableDiscountDiscountSourceEnum[keyof typeof ApplicableDiscountDiscountSourceEnum];
export const ApplicableDiscountDiscountTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type ApplicableDiscountDiscountTypeEnum = typeof ApplicableDiscountDiscountTypeEnum[keyof typeof ApplicableDiscountDiscountTypeEnum];

/**
 * 
 * @export
 * @interface ApplyDiscountRequest
 */
export interface ApplyDiscountRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyDiscountRequest
     */
    'cartId': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyDiscountRequest
     */
    'discountId': string;
}
/**
 * 
 * @export
 * @interface AttributionDto
 */
export interface AttributionDto {
    /**
     * 
     * @type {number}
     * @memberof AttributionDto
     */
    'clickThroughDays': number;
    /**
     * 
     * @type {number}
     * @memberof AttributionDto
     */
    'viewThroughDays': number;
}
/**
 * 
 * @export
 * @interface AttributionRequest
 */
export interface AttributionRequest {
    /**
     * 
     * @type {number}
     * @memberof AttributionRequest
     */
    'clickThroughDays': number;
    /**
     * 
     * @type {number}
     * @memberof AttributionRequest
     */
    'viewThroughDays': number;
}
/**
 * 
 * @export
 * @interface AuthIdentificationRequest
 */
export interface AuthIdentificationRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthIdentificationRequest
     */
    'identificationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthIdentificationRequest
     */
    'storeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthIdentificationRequest
     */
    'costumerId': string;
    /**
     * 
     * @type {string}
     * @memberof AuthIdentificationRequest
     */
    'operatorCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthIdentificationRequest
     */
    'operatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthIdentificationRequest
     */
    'customerDocument'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthIdentificationRequest
     */
    'Phone'?: string | null;
}
/**
 * 
 * @export
 * @interface AuthenticateResposne
 */
export interface AuthenticateResposne {
    /**
     * 
     * @type {boolean}
     * @memberof AuthenticateResposne
     */
    'authenticated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AuthenticateResposne
     */
    'validatedByException': boolean;
}
/**
 * 
 * @export
 * @interface AuthenticationRequest
 */
export interface AuthenticationRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequest
     */
    'externalBusinessUnitId': string;
    /**
     * 
     * @type {IdentificationSaleRequest}
     * @memberof AuthenticationRequest
     */
    'sale'?: IdentificationSaleRequest;
    /**
     * 
     * @type {AuthIdentificationRequest}
     * @memberof AuthenticationRequest
     */
    'identification': AuthIdentificationRequest;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequest
     */
    'partnerCode'?: string;
    /**
     * 
     * @type {PartnerCredentialsRequest}
     * @memberof AuthenticationRequest
     */
    'partnerCredentials'?: PartnerCredentialsRequest;
    /**
     * 
     * @type {UserAuthenticationRequest}
     * @memberof AuthenticationRequest
     */
    'authentication': UserAuthenticationRequest;
}
/**
 * 
 * @export
 * @interface BogoDto
 */
export interface BogoDto {
    /**
     * 
     * @type {Array<DiscountSkuDto>}
     * @memberof BogoDto
     */
    'listSkuBuyTogether': Array<DiscountSkuDto>;
    /**
     * 
     * @type {number}
     * @memberof BogoDto
     */
    'minimumQuantityBuyTogether': number;
    /**
     * 
     * @type {number}
     * @memberof BogoDto
     */
    'quantitySelectable': number;
    /**
     * 
     * @type {number}
     * @memberof BogoDto
     */
    'maxNumberOfAffectedItems': number;
    /**
     * 
     * @type {boolean}
     * @memberof BogoDto
     */
    'considerIdenticalItems': boolean;
}
/**
 * 
 * @export
 * @interface BogoRequest
 */
export interface BogoRequest {
    /**
     * 
     * @type {Array<SkuRequest>}
     * @memberof BogoRequest
     */
    'listSkuBuyTogether': Array<SkuRequest>;
    /**
     * 
     * @type {number}
     * @memberof BogoRequest
     */
    'minimumQuantityBuyTogether': number;
    /**
     * 
     * @type {number}
     * @memberof BogoRequest
     */
    'quantitySelectable': number;
    /**
     * 
     * @type {number}
     * @memberof BogoRequest
     */
    'maxNumberOfAffectedItems': number;
    /**
     * 
     * @type {boolean}
     * @memberof BogoRequest
     */
    'considerIdenticalItems': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BogoRequest
     */
    'giftPerEligibleItem': boolean;
}
/**
 * 
 * @export
 * @interface BonusIdentificationRequest
 */
export interface BonusIdentificationRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusIdentificationRequest
     */
    'costumerId': string;
    /**
     * 
     * @type {string}
     * @memberof BonusIdentificationRequest
     */
    'storeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BonusIdentificationRequest
     */
    'identificationCode'?: string;
}
/**
 * 
 * @export
 * @interface BonusInitialRequest
 */
export interface BonusInitialRequest {
    /**
     * 
     * @type {BonusIdentificationRequest}
     * @memberof BonusInitialRequest
     */
    'identification': BonusIdentificationRequest;
    /**
     * 
     * @type {SalesRequest}
     * @memberof BonusInitialRequest
     */
    'sale': SalesRequest;
    /**
     * 
     * @type {string}
     * @memberof BonusInitialRequest
     */
    'partnerCode': string;
    /**
     * 
     * @type {string}
     * @memberof BonusInitialRequest
     */
    'externalBusinessUnitId': string;
    /**
     * 
     * @type {PartnerCredentialsRequest}
     * @memberof BonusInitialRequest
     */
    'partnerCredentials': PartnerCredentialsRequest;
    /**
     * 
     * @type {string}
     * @memberof BonusInitialRequest
     */
    'Phone'?: string;
}
/**
 * 
 * @export
 * @interface BonusRequest
 */
export interface BonusRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusRequest
     */
    'bonusId': string;
    /**
     * 
     * @type {number}
     * @memberof BonusRequest
     */
    'bonusAmountUsed': number;
    /**
     * 
     * @type {number}
     * @memberof BonusRequest
     */
    'bonusReferenceValue': number;
}
/**
 * 
 * @export
 * @interface BonusResponse
 */
export interface BonusResponse {
    /**
     * 
     * @type {string}
     * @memberof BonusResponse
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof BonusResponse
     */
    'bonusAmount': number;
    /**
     * 
     * @type {string}
     * @memberof BonusResponse
     */
    'bonusId': string;
    /**
     * 
     * @type {string}
     * @memberof BonusResponse
     */
    'partner': string;
    /**
     * 
     * @type {string}
     * @memberof BonusResponse
     */
    'partnerCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof BonusResponse
     */
    'mandatoryUseBonuses': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BonusResponse
     */
    'canDiscountAfterBonus': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BonusResponse
     */
    'canUsePartialBonus': boolean;
    /**
     * 
     * @type {string}
     * @memberof BonusResponse
     */
    'operatorText': string;
    /**
     * 
     * @type {string}
     * @memberof BonusResponse
     */
    'customerText': string;
    /**
     * 
     * @type {number}
     * @memberof BonusResponse
     */
    'bonusReferenceValue': number;
    /**
     * 
     * @type {number}
     * @memberof BonusResponse
     */
    'bonusMax': number;
    /**
     * 
     * @type {number}
     * @memberof BonusResponse
     */
    'bonusMin': number;
}
/**
 * 
 * @export
 * @interface BoosterDto
 */
export interface BoosterDto {
    /**
     * 
     * @type {string}
     * @memberof BoosterDto
     */
    'type': BoosterDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BoosterDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoosterDto
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof BoosterDto
     */
    'expiredAfter'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoosterDto
     */
    'refereeValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoosterDto
     */
    'refereeMinPurchase'?: number;
    /**
     * 
     * @type {string}
     * @memberof BoosterDto
     */
    'refereeUrl'?: string;
}

export const BoosterDtoTypeEnum = {
    Basic: 'basic',
    Survey: 'survey',
    Referal: 'referal',
    Wheel: 'wheel',
    FreeShipping: 'freeShipping'
} as const;

export type BoosterDtoTypeEnum = typeof BoosterDtoTypeEnum[keyof typeof BoosterDtoTypeEnum];

/**
 * 
 * @export
 * @interface BoosterRequest
 */
export interface BoosterRequest {
    /**
     * 
     * @type {string}
     * @memberof BoosterRequest
     */
    'type': BoosterRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BoosterRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoosterRequest
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof BoosterRequest
     */
    'expiredAfter'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoosterRequest
     */
    'refereeValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoosterRequest
     */
    'refereeMinPurchase'?: number;
    /**
     * 
     * @type {string}
     * @memberof BoosterRequest
     */
    'refereeUrl'?: string;
}

export const BoosterRequestTypeEnum = {
    Basic: 'basic',
    Survey: 'survey',
    Referal: 'referal',
    Wheel: 'wheel',
    FreeShipping: 'freeShipping'
} as const;

export type BoosterRequestTypeEnum = typeof BoosterRequestTypeEnum[keyof typeof BoosterRequestTypeEnum];

/**
 * 
 * @export
 * @interface BudgetDto
 */
export interface BudgetDto {
    /**
     * 
     * @type {string}
     * @memberof BudgetDto
     */
    'type': BudgetDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof BudgetDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof BudgetDto
     */
    'currency': BudgetDtoCurrencyEnum;
}

export const BudgetDtoTypeEnum = {
    LifeTime: 'lifeTime',
    Daily: 'daily'
} as const;

export type BudgetDtoTypeEnum = typeof BudgetDtoTypeEnum[keyof typeof BudgetDtoTypeEnum];
export const BudgetDtoCurrencyEnum = {
    Aed: 'aed',
    Afn: 'afn',
    All: 'all',
    Amd: 'amd',
    Ang: 'ang',
    Aoa: 'aoa',
    Ars: 'ars',
    Aud: 'aud',
    Awg: 'awg',
    Azn: 'azn',
    Bam: 'bam',
    Bbd: 'bbd',
    Bdt: 'bdt',
    Bgn: 'bgn',
    Bhd: 'bhd',
    Bif: 'bif',
    Bmd: 'bmd',
    Bnd: 'bnd',
    Bob: 'bob',
    Brl: 'brl',
    Bsd: 'bsd',
    Btn: 'btn',
    Bwp: 'bwp',
    Byn: 'byn',
    Bzd: 'bzd',
    Cad: 'cad',
    Cdf: 'cdf',
    Chf: 'chf',
    Clp: 'clp',
    Cny: 'cny',
    Cop: 'cop',
    Crc: 'crc',
    Cuc: 'cuc',
    Cup: 'cup',
    Cve: 'cve',
    Czk: 'czk',
    Djf: 'djf',
    Dkk: 'dkk',
    Dop: 'dop',
    Dzd: 'dzd',
    Egp: 'egp',
    Ern: 'ern',
    Etb: 'etb',
    Eur: 'eur',
    Fjd: 'fjd',
    Fkp: 'fkp',
    Gbp: 'gbp',
    Gel: 'gel',
    Ghs: 'ghs',
    Gip: 'gip',
    Gmd: 'gmd',
    Gnf: 'gnf',
    Gtq: 'gtq',
    Gyd: 'gyd',
    Hkd: 'hkd',
    Hnl: 'hnl',
    Hrk: 'hrk',
    Htg: 'htg',
    Huf: 'huf',
    Idr: 'idr',
    Ils: 'ils',
    Inr: 'inr',
    Iqd: 'iqd',
    Irr: 'irr',
    Isk: 'isk',
    Jmd: 'jmd',
    Jod: 'jod',
    Jpy: 'jpy',
    Kes: 'kes',
    Kgs: 'kgs',
    Khr: 'khr',
    Kmf: 'kmf',
    Kpw: 'kpw',
    Krw: 'krw',
    Kwd: 'kwd',
    Kyd: 'kyd',
    Kzt: 'kzt',
    Lak: 'lak',
    Lbp: 'lbp',
    Lkr: 'lkr',
    Lrd: 'lrd',
    Lsl: 'lsl',
    Lyd: 'lyd',
    Mad: 'mad',
    Mdl: 'mdl',
    Mga: 'mga',
    Mkd: 'mkd',
    Mmk: 'mmk',
    Mnt: 'mnt',
    Mop: 'mop',
    Mru: 'mru',
    Mur: 'mur',
    Mvr: 'mvr',
    Mwk: 'mwk',
    Mxn: 'mxn',
    Myr: 'myr',
    Mzn: 'mzn',
    Nad: 'nad',
    Ngn: 'ngn',
    Nio: 'nio',
    Nok: 'nok',
    Npr: 'npr',
    Nzd: 'nzd',
    Omr: 'omr',
    Pab: 'pab',
    Pen: 'pen',
    Pgk: 'pgk',
    Php: 'php',
    Pkr: 'pkr',
    Pln: 'pln',
    Pyg: 'pyg',
    Qar: 'qar',
    Ron: 'ron',
    Rsd: 'rsd',
    Rub: 'rub',
    Rwf: 'rwf',
    Sar: 'sar',
    Sbd: 'sbd',
    Scr: 'scr',
    Sdg: 'sdg',
    Sek: 'sek',
    Sgd: 'sgd',
    Shp: 'shp',
    Sll: 'sll',
    Sos: 'sos',
    Srd: 'srd',
    Ssp: 'ssp',
    Stn: 'stn',
    Svc: 'svc',
    Syp: 'syp',
    Szl: 'szl',
    Thb: 'thb',
    Tjs: 'tjs',
    Tmt: 'tmt',
    Tnd: 'tnd',
    Top: 'top',
    Try: 'try',
    Ttd: 'ttd',
    Twd: 'twd',
    Tzs: 'tzs',
    Uah: 'uah',
    Ugx: 'ugx',
    Usd: 'usd',
    Uyu: 'uyu',
    Uzs: 'uzs',
    Ves: 'ves',
    Vnd: 'vnd',
    Vuv: 'vuv',
    Wst: 'wst',
    Xaf: 'xaf',
    Xcd: 'xcd',
    Xof: 'xof',
    Xpf: 'xpf',
    Yer: 'yer',
    Zar: 'zar',
    Zmw: 'zmw',
    Zwl: 'zwl'
} as const;

export type BudgetDtoCurrencyEnum = typeof BudgetDtoCurrencyEnum[keyof typeof BudgetDtoCurrencyEnum];

/**
 * 
 * @export
 * @interface BudgetRequest
 */
export interface BudgetRequest {
    /**
     * 
     * @type {string}
     * @memberof BudgetRequest
     */
    'type': BudgetRequestTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof BudgetRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof BudgetRequest
     */
    'currency': BudgetRequestCurrencyEnum;
}

export const BudgetRequestTypeEnum = {
    LifeTime: 'lifeTime',
    Daily: 'daily'
} as const;

export type BudgetRequestTypeEnum = typeof BudgetRequestTypeEnum[keyof typeof BudgetRequestTypeEnum];
export const BudgetRequestCurrencyEnum = {
    Aed: 'aed',
    Afn: 'afn',
    All: 'all',
    Amd: 'amd',
    Ang: 'ang',
    Aoa: 'aoa',
    Ars: 'ars',
    Aud: 'aud',
    Awg: 'awg',
    Azn: 'azn',
    Bam: 'bam',
    Bbd: 'bbd',
    Bdt: 'bdt',
    Bgn: 'bgn',
    Bhd: 'bhd',
    Bif: 'bif',
    Bmd: 'bmd',
    Bnd: 'bnd',
    Bob: 'bob',
    Brl: 'brl',
    Bsd: 'bsd',
    Btn: 'btn',
    Bwp: 'bwp',
    Byn: 'byn',
    Bzd: 'bzd',
    Cad: 'cad',
    Cdf: 'cdf',
    Chf: 'chf',
    Clp: 'clp',
    Cny: 'cny',
    Cop: 'cop',
    Crc: 'crc',
    Cuc: 'cuc',
    Cup: 'cup',
    Cve: 'cve',
    Czk: 'czk',
    Djf: 'djf',
    Dkk: 'dkk',
    Dop: 'dop',
    Dzd: 'dzd',
    Egp: 'egp',
    Ern: 'ern',
    Etb: 'etb',
    Eur: 'eur',
    Fjd: 'fjd',
    Fkp: 'fkp',
    Gbp: 'gbp',
    Gel: 'gel',
    Ghs: 'ghs',
    Gip: 'gip',
    Gmd: 'gmd',
    Gnf: 'gnf',
    Gtq: 'gtq',
    Gyd: 'gyd',
    Hkd: 'hkd',
    Hnl: 'hnl',
    Hrk: 'hrk',
    Htg: 'htg',
    Huf: 'huf',
    Idr: 'idr',
    Ils: 'ils',
    Inr: 'inr',
    Iqd: 'iqd',
    Irr: 'irr',
    Isk: 'isk',
    Jmd: 'jmd',
    Jod: 'jod',
    Jpy: 'jpy',
    Kes: 'kes',
    Kgs: 'kgs',
    Khr: 'khr',
    Kmf: 'kmf',
    Kpw: 'kpw',
    Krw: 'krw',
    Kwd: 'kwd',
    Kyd: 'kyd',
    Kzt: 'kzt',
    Lak: 'lak',
    Lbp: 'lbp',
    Lkr: 'lkr',
    Lrd: 'lrd',
    Lsl: 'lsl',
    Lyd: 'lyd',
    Mad: 'mad',
    Mdl: 'mdl',
    Mga: 'mga',
    Mkd: 'mkd',
    Mmk: 'mmk',
    Mnt: 'mnt',
    Mop: 'mop',
    Mru: 'mru',
    Mur: 'mur',
    Mvr: 'mvr',
    Mwk: 'mwk',
    Mxn: 'mxn',
    Myr: 'myr',
    Mzn: 'mzn',
    Nad: 'nad',
    Ngn: 'ngn',
    Nio: 'nio',
    Nok: 'nok',
    Npr: 'npr',
    Nzd: 'nzd',
    Omr: 'omr',
    Pab: 'pab',
    Pen: 'pen',
    Pgk: 'pgk',
    Php: 'php',
    Pkr: 'pkr',
    Pln: 'pln',
    Pyg: 'pyg',
    Qar: 'qar',
    Ron: 'ron',
    Rsd: 'rsd',
    Rub: 'rub',
    Rwf: 'rwf',
    Sar: 'sar',
    Sbd: 'sbd',
    Scr: 'scr',
    Sdg: 'sdg',
    Sek: 'sek',
    Sgd: 'sgd',
    Shp: 'shp',
    Sll: 'sll',
    Sos: 'sos',
    Srd: 'srd',
    Ssp: 'ssp',
    Stn: 'stn',
    Svc: 'svc',
    Syp: 'syp',
    Szl: 'szl',
    Thb: 'thb',
    Tjs: 'tjs',
    Tmt: 'tmt',
    Tnd: 'tnd',
    Top: 'top',
    Try: 'try',
    Ttd: 'ttd',
    Twd: 'twd',
    Tzs: 'tzs',
    Uah: 'uah',
    Ugx: 'ugx',
    Usd: 'usd',
    Uyu: 'uyu',
    Uzs: 'uzs',
    Ves: 'ves',
    Vnd: 'vnd',
    Vuv: 'vuv',
    Wst: 'wst',
    Xaf: 'xaf',
    Xcd: 'xcd',
    Xof: 'xof',
    Xpf: 'xpf',
    Yer: 'yer',
    Zar: 'zar',
    Zmw: 'zmw',
    Zwl: 'zwl'
} as const;

export type BudgetRequestCurrencyEnum = typeof BudgetRequestCurrencyEnum[keyof typeof BudgetRequestCurrencyEnum];

/**
 * 
 * @export
 * @interface CampaignConfigDto
 */
export interface CampaignConfigDto {
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'fromDate': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'type': CampaignConfigDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'estimatedToDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'status'?: CampaignConfigDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'externalId': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignConfigDto
     */
    'communicationChannels'?: Array<CampaignConfigDtoCommunicationChannelsEnum>;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'completedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignConfigDto
     */
    'whatsAppLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignConfigDto
     */
    'smartLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignConfigDto
     */
    'emailLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignConfigDto
     */
    'widgetLiked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CampaignConfigDto
     */
    'mode': CampaignConfigDtoModeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignConfigDto
     */
    'platformTarget'?: Array<CampaignConfigDtoPlatformTargetEnum>;
    /**
     * 
     * @type {number}
     * @memberof CampaignConfigDto
     */
    'targetMembers': number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignConfigDto
     */
    'processedMembers': number | null;
    /**
     * 
     * @type {TargetMembersDto}
     * @memberof CampaignConfigDto
     */
    'targetMembersConfig'?: TargetMembersDto;
    /**
     * 
     * @type {number}
     * @memberof CampaignConfigDto
     */
    'redemptionRate'?: number;
    /**
     * 
     * @type {RewardConfigDto}
     * @memberof CampaignConfigDto
     */
    'rewardConfig'?: RewardConfigDto;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignConfigDto
     */
    'published'?: boolean;
    /**
     * 
     * @type {BoosterDto}
     * @memberof CampaignConfigDto
     */
    'booster'?: BoosterDto | null;
    /**
     * 
     * @type {object}
     * @memberof CampaignConfigDto
     */
    'metadata'?: object;
    /**
     * 
     * @type {BudgetDto}
     * @memberof CampaignConfigDto
     */
    'budget'?: BudgetDto;
    /**
     * 
     * @type {ScheduleDto}
     * @memberof CampaignConfigDto
     */
    'schedule'?: ScheduleDto;
    /**
     * 
     * @type {AdvertisementDetailsDto}
     * @memberof CampaignConfigDto
     */
    'advertisementDetails'?: AdvertisementDetailsDto | null;
}

export const CampaignConfigDtoTypeEnum = {
    Standard: 'standard',
    Gamified: 'gamified'
} as const;

export type CampaignConfigDtoTypeEnum = typeof CampaignConfigDtoTypeEnum[keyof typeof CampaignConfigDtoTypeEnum];
export const CampaignConfigDtoStatusEnum = {
    Draft: 'draft',
    Live: 'live',
    Completed: 'completed',
    Scheduled: 'scheduled',
    Deleted: 'deleted',
    Ended: 'ended'
} as const;

export type CampaignConfigDtoStatusEnum = typeof CampaignConfigDtoStatusEnum[keyof typeof CampaignConfigDtoStatusEnum];
export const CampaignConfigDtoCommunicationChannelsEnum = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Widget: 'widget'
} as const;

export type CampaignConfigDtoCommunicationChannelsEnum = typeof CampaignConfigDtoCommunicationChannelsEnum[keyof typeof CampaignConfigDtoCommunicationChannelsEnum];
export const CampaignConfigDtoModeEnum = {
    Predefined: 'predefined',
    Dynamic: 'dynamic'
} as const;

export type CampaignConfigDtoModeEnum = typeof CampaignConfigDtoModeEnum[keyof typeof CampaignConfigDtoModeEnum];
export const CampaignConfigDtoPlatformTargetEnum = {
    Digital: 'digital',
    Fisico: 'fisico',
    Omni: 'omni'
} as const;

export type CampaignConfigDtoPlatformTargetEnum = typeof CampaignConfigDtoPlatformTargetEnum[keyof typeof CampaignConfigDtoPlatformTargetEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const CampaignCreateCommunicationChannels = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Widget: 'widget'
} as const;

export type CampaignCreateCommunicationChannels = typeof CampaignCreateCommunicationChannels[keyof typeof CampaignCreateCommunicationChannels];


/**
 * 
 * @export
 * @enum {string}
 */

export const CampaignCreatePlatformTargets = {
    Digital: 'digital',
    Fisico: 'fisico',
    Omni: 'omni'
} as const;

export type CampaignCreatePlatformTargets = typeof CampaignCreatePlatformTargets[keyof typeof CampaignCreatePlatformTargets];


/**
 * 
 * @export
 * @interface CampaignCreateRequest
 */
export interface CampaignCreateRequest {
    /**
     * 
     * @type {Array<CampaignCreateCommunicationChannels>}
     * @memberof CampaignCreateRequest
     */
    'communicationChannels'?: Array<CampaignCreateCommunicationChannels>;
    /**
     * 
     * @type {CampaignTypes}
     * @memberof CampaignCreateRequest
     */
    'type': CampaignTypes;
    /**
     * 
     * @type {Array<CampaignCreatePlatformTargets>}
     * @memberof CampaignCreateRequest
     */
    'platformTarget'?: Array<CampaignCreatePlatformTargets>;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'fromDate': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCreateRequest
     */
    'endDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignCreateRequest
     */
    'whatsAppLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignCreateRequest
     */
    'smartLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignCreateRequest
     */
    'emailLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignCreateRequest
     */
    'widgetLiked'?: boolean;
    /**
     * 
     * @type {TargetMembersRequest}
     * @memberof CampaignCreateRequest
     */
    'targetMembersConfig'?: TargetMembersRequest;
    /**
     * 
     * @type {BudgetRequest}
     * @memberof CampaignCreateRequest
     */
    'budget'?: BudgetRequest;
    /**
     * 
     * @type {ScheduleRequest}
     * @memberof CampaignCreateRequest
     */
    'schedule'?: ScheduleRequest;
    /**
     * 
     * @type {RewardConfigRequest}
     * @memberof CampaignCreateRequest
     */
    'rewardConfig'?: RewardConfigRequest;
    /**
     * 
     * @type {BoosterRequest}
     * @memberof CampaignCreateRequest
     */
    'booster'?: BoosterRequest | null;
    /**
     * 
     * @type {object}
     * @memberof CampaignCreateRequest
     */
    'metadata'?: object;
    /**
     * 
     * @type {AdvertisementDetailsRequest}
     * @memberof CampaignCreateRequest
     */
    'advertisementDetails'?: AdvertisementDetailsRequest;
}


/**
 * 
 * @export
 * @interface CampaignIdentificationRequest
 */
export interface CampaignIdentificationRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignIdentificationRequest
     */
    'storeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignIdentificationRequest
     */
    'costumerId': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignIdentificationRequest
     */
    'identificationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignIdentificationRequest
     */
    'Phone'?: string | null;
}
/**
 * 
 * @export
 * @interface CampaignNotificationCreateRequest
 */
export interface CampaignNotificationCreateRequest {
    /**
     * 
     * @type {object}
     * @memberof CampaignNotificationCreateRequest
     */
    'name': object;
    /**
     * 
     * @type {object}
     * @memberof CampaignNotificationCreateRequest
     */
    'text'?: object;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationCreateRequest
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationCreateRequest
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationCreateRequest
     */
    'communicationType': CampaignNotificationCreateRequestCommunicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationCreateRequest
     */
    'boosterType'?: CampaignNotificationCreateRequestBoosterTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationCreateRequest
     */
    'messageType': CampaignNotificationCreateRequestMessageTypeEnum;
}

export const CampaignNotificationCreateRequestCommunicationTypeEnum = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Widget: 'widget'
} as const;

export type CampaignNotificationCreateRequestCommunicationTypeEnum = typeof CampaignNotificationCreateRequestCommunicationTypeEnum[keyof typeof CampaignNotificationCreateRequestCommunicationTypeEnum];
export const CampaignNotificationCreateRequestBoosterTypeEnum = {
    Basic: 'basic',
    Survey: 'survey',
    Referal: 'referal',
    Wheel: 'wheel',
    FreeShipping: 'freeShipping'
} as const;

export type CampaignNotificationCreateRequestBoosterTypeEnum = typeof CampaignNotificationCreateRequestBoosterTypeEnum[keyof typeof CampaignNotificationCreateRequestBoosterTypeEnum];
export const CampaignNotificationCreateRequestMessageTypeEnum = {
    Success: 'success',
    Launcher: 'launcher',
    Reminder: 'reminder',
    RefereeSuccess: 'refereeSuccess'
} as const;

export type CampaignNotificationCreateRequestMessageTypeEnum = typeof CampaignNotificationCreateRequestMessageTypeEnum[keyof typeof CampaignNotificationCreateRequestMessageTypeEnum];

/**
 * 
 * @export
 * @interface CampaignNotificationDto
 */
export interface CampaignNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationDto
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationDto
     */
    'communicationType': CampaignNotificationDtoCommunicationTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof CampaignNotificationDto
     */
    'name': object;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationDto
     */
    'messageType': CampaignNotificationDtoMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationDto
     */
    'boosterType'?: CampaignNotificationDtoBoosterTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof CampaignNotificationDto
     */
    'text'?: object;
}

export const CampaignNotificationDtoCommunicationTypeEnum = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Widget: 'widget'
} as const;

export type CampaignNotificationDtoCommunicationTypeEnum = typeof CampaignNotificationDtoCommunicationTypeEnum[keyof typeof CampaignNotificationDtoCommunicationTypeEnum];
export const CampaignNotificationDtoMessageTypeEnum = {
    Success: 'success',
    Launcher: 'launcher',
    Reminder: 'reminder',
    RefereeSuccess: 'refereeSuccess'
} as const;

export type CampaignNotificationDtoMessageTypeEnum = typeof CampaignNotificationDtoMessageTypeEnum[keyof typeof CampaignNotificationDtoMessageTypeEnum];
export const CampaignNotificationDtoBoosterTypeEnum = {
    Basic: 'basic',
    Survey: 'survey',
    Referal: 'referal',
    Wheel: 'wheel',
    FreeShipping: 'freeShipping'
} as const;

export type CampaignNotificationDtoBoosterTypeEnum = typeof CampaignNotificationDtoBoosterTypeEnum[keyof typeof CampaignNotificationDtoBoosterTypeEnum];

/**
 * 
 * @export
 * @interface CampaignNotificationListResponse
 */
export interface CampaignNotificationListResponse {
    /**
     * 
     * @type {Array<CampaignNotificationDto>}
     * @memberof CampaignNotificationListResponse
     */
    'campaignNotifications': Array<CampaignNotificationDto>;
    /**
     * 
     * @type {number}
     * @memberof CampaignNotificationListResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface CampaignNotificationResponse
 */
export interface CampaignNotificationResponse {
    /**
     * 
     * @type {CampaignNotificationDto}
     * @memberof CampaignNotificationResponse
     */
    'campaignNotification': CampaignNotificationDto;
}
/**
 * 
 * @export
 * @interface CampaignNotificationUpdateRequest
 */
export interface CampaignNotificationUpdateRequest {
    /**
     * 
     * @type {object}
     * @memberof CampaignNotificationUpdateRequest
     */
    'text'?: object;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationUpdateRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationUpdateRequest
     */
    'boosterType'?: CampaignNotificationUpdateRequestBoosterTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignNotificationUpdateRequest
     */
    'messageType'?: CampaignNotificationUpdateRequestMessageTypeEnum;
}

export const CampaignNotificationUpdateRequestBoosterTypeEnum = {
    Basic: 'basic',
    Survey: 'survey',
    Referal: 'referal',
    Wheel: 'wheel',
    FreeShipping: 'freeShipping'
} as const;

export type CampaignNotificationUpdateRequestBoosterTypeEnum = typeof CampaignNotificationUpdateRequestBoosterTypeEnum[keyof typeof CampaignNotificationUpdateRequestBoosterTypeEnum];
export const CampaignNotificationUpdateRequestMessageTypeEnum = {
    Success: 'success',
    Launcher: 'launcher',
    Reminder: 'reminder',
    RefereeSuccess: 'refereeSuccess'
} as const;

export type CampaignNotificationUpdateRequestMessageTypeEnum = typeof CampaignNotificationUpdateRequestMessageTypeEnum[keyof typeof CampaignNotificationUpdateRequestMessageTypeEnum];

/**
 * 
 * @export
 * @interface CampaignReportField
 */
export interface CampaignReportField {
    /**
     * 
     * @type {string}
     * @memberof CampaignReportField
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignReportField
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface CampaignReportRequest
 */
export interface CampaignReportRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignReportRequest
     */
    'email': string;
    /**
     * 
     * @type {Array<CampaignReportField>}
     * @memberof CampaignReportRequest
     */
    'fields'?: Array<CampaignReportField>;
}
/**
 * 
 * @export
 * @interface CampaignRequest
 */
export interface CampaignRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface CampaignRequestDto
 */
export interface CampaignRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CampaignRequestDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignRequestDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignRequestDto
     */
    'demandApp': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignRequestDto
     */
    'campaign': string;
    /**
     * 
     * @type {TrackingDetailsDto}
     * @memberof CampaignRequestDto
     */
    'trackingDetails'?: TrackingDetailsDto;
    /**
     * 
     * @type {string}
     * @memberof CampaignRequestDto
     */
    'status': CampaignRequestDtoStatusEnum;
}

export const CampaignRequestDtoStatusEnum = {
    Approved: 'approved',
    Rejected: 'rejected',
    Pending: 'pending'
} as const;

export type CampaignRequestDtoStatusEnum = typeof CampaignRequestDtoStatusEnum[keyof typeof CampaignRequestDtoStatusEnum];

/**
 * 
 * @export
 * @interface CampaignRequestListResponse
 */
export interface CampaignRequestListResponse {
    /**
     * 
     * @type {Array<CampaignRequestDto>}
     * @memberof CampaignRequestListResponse
     */
    'campaignRequests': Array<CampaignRequestDto> | null;
}
/**
 * 
 * @export
 * @interface CampaignRequestResponse
 */
export interface CampaignRequestResponse {
    /**
     * 
     * @type {CampaignRequestDto}
     * @memberof CampaignRequestResponse
     */
    'campaignRequest': CampaignRequestDto;
}
/**
 * 
 * @export
 * @interface CampaignRequestUpdateRequest
 */
export interface CampaignRequestUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CampaignRequestUpdateRequest
     */
    'status'?: CampaignRequestUpdateRequestStatusEnum;
}

export const CampaignRequestUpdateRequestStatusEnum = {
    Approved: 'approved',
    Rejected: 'rejected',
    Pending: 'pending'
} as const;

export type CampaignRequestUpdateRequestStatusEnum = typeof CampaignRequestUpdateRequestStatusEnum[keyof typeof CampaignRequestUpdateRequestStatusEnum];

/**
 * 
 * @export
 * @interface CampaignResponse
 */
export interface CampaignResponse {
    /**
     * 
     * @type {CampaignConfigDto}
     * @memberof CampaignResponse
     */
    'campaign': CampaignConfigDto;
}
/**
 * 
 * @export
 * @interface CampaignSaleRequest
 */
export interface CampaignSaleRequest {
    /**
     * 
     * @type {number}
     * @memberof CampaignSaleRequest
     */
    'netSaleValue': number;
}
/**
 * 
 * @export
 * @interface CampaignTargetCount
 */
export interface CampaignTargetCount {
    /**
     * 
     * @type {number}
     * @memberof CampaignTargetCount
     */
    'count': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CampaignTypes = {
    Standard: 'standard',
    Gamified: 'gamified'
} as const;

export type CampaignTypes = typeof CampaignTypes[keyof typeof CampaignTypes];


/**
 * 
 * @export
 * @enum {string}
 */

export const CampaignUpdateCommunicationChannels = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Widget: 'widget'
} as const;

export type CampaignUpdateCommunicationChannels = typeof CampaignUpdateCommunicationChannels[keyof typeof CampaignUpdateCommunicationChannels];


/**
 * 
 * @export
 * @enum {string}
 */

export const CampaignUpdatePlatformTargets = {
    Digital: 'digital',
    Fisico: 'fisico',
    Omni: 'omni'
} as const;

export type CampaignUpdatePlatformTargets = typeof CampaignUpdatePlatformTargets[keyof typeof CampaignUpdatePlatformTargets];


/**
 * 
 * @export
 * @interface CampaignUpdateRequest
 */
export interface CampaignUpdateRequest {
    /**
     * 
     * @type {Array<CampaignUpdateCommunicationChannels>}
     * @memberof CampaignUpdateRequest
     */
    'communicationChannels'?: Array<CampaignUpdateCommunicationChannels>;
    /**
     * 
     * @type {CampaignTypes}
     * @memberof CampaignUpdateRequest
     */
    'type'?: CampaignTypes;
    /**
     * 
     * @type {Array<CampaignUpdatePlatformTargets>}
     * @memberof CampaignUpdateRequest
     */
    'platformTarget'?: Array<CampaignUpdatePlatformTargets>;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'endDate'?: string;
    /**
     * 
     * @type {BudgetRequest}
     * @memberof CampaignUpdateRequest
     */
    'budget'?: BudgetRequest;
    /**
     * 
     * @type {ScheduleRequest}
     * @memberof CampaignUpdateRequest
     */
    'schedule'?: ScheduleRequest;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateRequest
     */
    'toDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignUpdateRequest
     */
    'whatsAppLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignUpdateRequest
     */
    'smartLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignUpdateRequest
     */
    'emailLiked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignUpdateRequest
     */
    'widgetLiked'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CampaignUpdateRequest
     */
    'targetMembers'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignUpdateRequest
     */
    'processedMembers'?: number;
    /**
     * 
     * @type {TargetMembersRequest}
     * @memberof CampaignUpdateRequest
     */
    'targetMembersConfig'?: TargetMembersRequest;
    /**
     * 
     * @type {RewardConfigRequest}
     * @memberof CampaignUpdateRequest
     */
    'rewardConfig'?: RewardConfigRequest;
    /**
     * 
     * @type {BoosterRequest}
     * @memberof CampaignUpdateRequest
     */
    'booster'?: BoosterRequest | null;
    /**
     * 
     * @type {object}
     * @memberof CampaignUpdateRequest
     */
    'metadata'?: object;
    /**
     * 
     * @type {AdvertisementDetailsRequest}
     * @memberof CampaignUpdateRequest
     */
    'advertisementDetails'?: AdvertisementDetailsRequest;
}


/**
 * 
 * @export
 * @interface CampaignUserDto
 */
export interface CampaignUserDto {
    /**
     * 
     * @type {string}
     * @memberof CampaignUserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUserDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUserDto
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUserDto
     */
    'user': string;
    /**
     * 
     * @type {CampiagnDiscountDto}
     * @memberof CampaignUserDto
     */
    'discount'?: CampiagnDiscountDto;
    /**
     * 
     * @type {string}
     * @memberof CampaignUserDto
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignUserDto
     */
    'status': CampaignUserDtoStatusEnum;
    /**
     * 
     * @type {CampaignUserSpinDto}
     * @memberof CampaignUserDto
     */
    'spin'?: CampaignUserSpinDto;
    /**
     * 
     * @type {string}
     * @memberof CampaignUserDto
     */
    'wheelOption'?: string;
}

export const CampaignUserDtoStatusEnum = {
    Valid: 'valid',
    Expired: 'expired',
    Completed: 'completed',
    Pending: 'pending',
    Notified: 'notified',
    Deleted: 'deleted'
} as const;

export type CampaignUserDtoStatusEnum = typeof CampaignUserDtoStatusEnum[keyof typeof CampaignUserDtoStatusEnum];

/**
 * 
 * @export
 * @interface CampaignUserResponse
 */
export interface CampaignUserResponse {
    /**
     * 
     * @type {CampaignUserDto}
     * @memberof CampaignUserResponse
     */
    'campaignUser': CampaignUserDto;
}
/**
 * 
 * @export
 * @interface CampaignUserSpinDto
 */
export interface CampaignUserSpinDto {
    /**
     * 
     * @type {number}
     * @memberof CampaignUserSpinDto
     */
    'spinValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignUserSpinDto
     */
    'wheelOption'?: string;
}
/**
 * 
 * @export
 * @interface CampaignUsersByRefereeResponse
 */
export interface CampaignUsersByRefereeResponse {
    /**
     * 
     * @type {PopulatedCampaignUserRefereeDto}
     * @memberof CampaignUsersByRefereeResponse
     */
    'campaignUserReferee': PopulatedCampaignUserRefereeDto | null;
}
/**
 * 
 * @export
 * @interface CampaignUsersResponse
 */
export interface CampaignUsersResponse {
    /**
     * 
     * @type {Array<PopulatedCampaignUserDto>}
     * @memberof CampaignUsersResponse
     */
    'campaignUsers': Array<PopulatedCampaignUserDto>;
    /**
     * 
     * @type {number}
     * @memberof CampaignUsersResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface CampaignsResponse
 */
export interface CampaignsResponse {
    /**
     * 
     * @type {Array<CampaignConfigDto>}
     * @memberof CampaignsResponse
     */
    'campaigns': Array<CampaignConfigDto>;
    /**
     * 
     * @type {number}
     * @memberof CampaignsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface CampiagnDiscountDto
 */
export interface CampiagnDiscountDto {
    /**
     * 
     * @type {string}
     * @memberof CampiagnDiscountDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampiagnDiscountDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface CancelBonusRequest
 */
export interface CancelBonusRequest {
    /**
     * 
     * @type {string}
     * @memberof CancelBonusRequest
     */
    'partnerCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelBonusRequest
     */
    'bonusId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelBonusRequest
     */
    'externalBusinessUnitId': string;
    /**
     * 
     * @type {string}
     * @memberof CancelBonusRequest
     */
    'externalSaleCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelBonusRequest
     */
    'posCode'?: string;
    /**
     * 
     * @type {FinalizeIdentificationRequest}
     * @memberof CancelBonusRequest
     */
    'identification': FinalizeIdentificationRequest;
    /**
     * 
     * @type {Array<OrderItemsRequest>}
     * @memberof CancelBonusRequest
     */
    'items'?: Array<OrderItemsRequest>;
    /**
     * 
     * @type {object}
     * @memberof CancelBonusRequest
     */
    'Fields'?: object;
    /**
     * 
     * @type {object}
     * @memberof CancelBonusRequest
     */
    'Expand'?: object;
}
/**
 * 
 * @export
 * @interface CancelBonusResponse
 */
export interface CancelBonusResponse {
    /**
     * 
     * @type {string}
     * @memberof CancelBonusResponse
     */
    'transactionId': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof CancelBonusResponse
     */
    'items': Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof CancelBonusResponse
     */
    'status': boolean;
    /**
     * 
     * @type {string}
     * @memberof CancelBonusResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CartDto
 */
export interface CartDto {
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    'customer': string;
    /**
     * 
     * @type {Array<CartItemDto>}
     * @memberof CartDto
     */
    'items': Array<CartItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    'user'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    'status': CartDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CartDto
     */
    'totalCartValue': number;
    /**
     * 
     * @type {number}
     * @memberof CartDto
     */
    'itemsCount': number;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    'firstAbandonedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof CartDto
     */
    'lastAbandonedAt': string | null;
}

export const CartDtoStatusEnum = {
    Completed: 'completed',
    Abandoned: 'abandoned',
    Active: 'active'
} as const;

export type CartDtoStatusEnum = typeof CartDtoStatusEnum[keyof typeof CartDtoStatusEnum];

/**
 * 
 * @export
 * @interface CartItemDto
 */
export interface CartItemDto {
    /**
     * 
     * @type {string}
     * @memberof CartItemDto
     */
    'externalId': string;
    /**
     * 
     * @type {number}
     * @memberof CartItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof CartItemDto
     */
    'price': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CartItemDto
     */
    'categories'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CartItemsCreateRequest
 */
export interface CartItemsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CartItemsCreateRequest
     */
    'externalId': string;
    /**
     * 
     * @type {number}
     * @memberof CartItemsCreateRequest
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof CartItemsCreateRequest
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CartItemsCreateRequest
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemsCreateRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CartReportRequest
 */
export interface CartReportRequest {
    /**
     * 
     * @type {string}
     * @memberof CartReportRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CartRequest
 */
export interface CartRequest {
    /**
     * 
     * @type {string}
     * @memberof CartRequest
     */
    'customer': string;
    /**
     * 
     * @type {string}
     * @memberof CartRequest
     */
    'user'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartRequest
     */
    'id'?: string;
    /**
     * 
     * @type {Array<CartItemsCreateRequest>}
     * @memberof CartRequest
     */
    'items': Array<CartItemsCreateRequest>;
    /**
     * 
     * @type {number}
     * @memberof CartRequest
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CartResponse
 */
export interface CartResponse {
    /**
     * 
     * @type {CartDto}
     * @memberof CartResponse
     */
    'cart': CartDto | null;
}
/**
 * 
 * @export
 * @interface CashbackConfigDto
 */
export interface CashbackConfigDto {
    /**
     * 
     * @type {number}
     * @memberof CashbackConfigDto
     */
    'minRedemptionValue': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackConfigDto
     */
    'multiplier'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackConfigDto
     */
    'partialRedemptionEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CashbackCreateRequest
 */
export interface CashbackCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'minPurchaseValue': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'expiry': number;
    /**
     * 
     * @type {string}
     * @memberof CashbackCreateRequest
     */
    'unit': CashbackCreateRequestUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'validAfterNumberOfDays': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'percentage': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'multiplier': number;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackCreateRequest
     */
    'partialRedemptionEnabled'?: boolean;
    /**
     * 
     * @type {UserDataCollectionRequest}
     * @memberof CashbackCreateRequest
     */
    'userDataCollection'?: UserDataCollectionRequest;
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'aov'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackCreateRequest
     */
    'boosterReward'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackCreateRequest
     */
    'triggerDiscountPreGeneration'?: boolean;
    /**
     * 
     * @type {CashbackPromotionRequest}
     * @memberof CashbackCreateRequest
     */
    'promotion'?: CashbackPromotionRequest;
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'minimumRedemptionValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'tier': number;
    /**
     * 
     * @type {string}
     * @memberof CashbackCreateRequest
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackCreateRequest
     */
    'useCashbackPopups'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CashbackCreateRequest
     */
    'remindsBeforeDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackCreateRequest
     */
    'enabled'?: boolean;
}

export const CashbackCreateRequestUnitEnum = {
    Day: 'day',
    Month: 'month'
} as const;

export type CashbackCreateRequestUnitEnum = typeof CashbackCreateRequestUnitEnum[keyof typeof CashbackCreateRequestUnitEnum];

/**
 * 
 * @export
 * @interface CashbackPopupDto
 */
export interface CashbackPopupDto {
    /**
     * 
     * @type {string}
     * @memberof CashbackPopupDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPopupDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPopupDto
     */
    'utmCampaign': string;
}
/**
 * 
 * @export
 * @interface CashbackPopupResponse
 */
export interface CashbackPopupResponse {
    /**
     * 
     * @type {CashbackPopupDto}
     * @memberof CashbackPopupResponse
     */
    'cashbackPopup': CashbackPopupDto | null;
}
/**
 * 
 * @export
 * @interface CashbackPromotionRequest
 */
export interface CashbackPromotionRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionRequest
     */
    'promotionId': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionRequest
     */
    'type': CashbackPromotionRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionRequest
     */
    'rewardType': CashbackPromotionRequestRewardTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionRequest
     */
    'value': number;
}

export const CashbackPromotionRequestTypeEnum = {
    Orders: 'orders',
    WelcomeGift: 'welcomeGift',
    Campaign: 'campaign'
} as const;

export type CashbackPromotionRequestTypeEnum = typeof CashbackPromotionRequestTypeEnum[keyof typeof CashbackPromotionRequestTypeEnum];
export const CashbackPromotionRequestRewardTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type CashbackPromotionRequestRewardTypeEnum = typeof CashbackPromotionRequestRewardTypeEnum[keyof typeof CashbackPromotionRequestRewardTypeEnum];

/**
 * 
 * @export
 * @interface CashbackSummaryResponse
 */
export interface CashbackSummaryResponse {
    /**
     * Most suitable discount to be applied on the purchase
     * @type {ApplicableDiscount}
     * @memberof CashbackSummaryResponse
     */
    'applicableDiscount': ApplicableDiscount;
    /**
     * Cashback to be generated after completing the purchase
     * @type {CashbackToBeGenerated}
     * @memberof CashbackSummaryResponse
     */
    'cashbackToBeGenerated'?: CashbackToBeGenerated;
}
/**
 * 
 * @export
 * @interface CashbackToBeGenerated
 */
export interface CashbackToBeGenerated {
    /**
     * Discount amount
     * @type {number}
     * @memberof CashbackToBeGenerated
     */
    'amount': number;
    /**
     * Response status message
     * @type {string}
     * @memberof CashbackToBeGenerated
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CashbackUpdateRequest
 */
export interface CashbackUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'minPurchaseValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'expiry'?: number;
    /**
     * 
     * @type {string}
     * @memberof CashbackUpdateRequest
     */
    'unit'?: CashbackUpdateRequestUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'multiplier'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackUpdateRequest
     */
    'partialRedemptionEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'validAfterNumberOfDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'aov'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackUpdateRequest
     */
    'boosterReward'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackUpdateRequest
     */
    'triggerDiscountPreGeneration'?: boolean;
    /**
     * 
     * @type {CashbackPromotionRequest}
     * @memberof CashbackUpdateRequest
     */
    'promotion'?: CashbackPromotionRequest;
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'minimumRedemptionValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'tier'?: number;
    /**
     * 
     * @type {string}
     * @memberof CashbackUpdateRequest
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackUpdateRequest
     */
    'useCashbackPopups'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CashbackUpdateRequest
     */
    'remindsBeforeDays'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CashbackUpdateRequest
     */
    'enabled'?: boolean;
}

export const CashbackUpdateRequestUnitEnum = {
    Day: 'day',
    Month: 'month'
} as const;

export type CashbackUpdateRequestUnitEnum = typeof CashbackUpdateRequestUnitEnum[keyof typeof CashbackUpdateRequestUnitEnum];

/**
 * 
 * @export
 * @interface CategoriesResponse
 */
export interface CategoriesResponse {
    /**
     * 
     * @type {Array<CategoryDto>}
     * @memberof CategoriesResponse
     */
    'categories': Array<CategoryDto>;
}
/**
 * 
 * @export
 * @interface CategoryDto
 */
export interface CategoryDto {
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CategoryResponse
 */
export interface CategoryResponse {
    /**
     * 
     * @type {CategoryDto}
     * @memberof CategoryResponse
     */
    'category': CategoryDto;
}
/**
 * 
 * @export
 * @interface ClearDiscountRequest
 */
export interface ClearDiscountRequest {
    /**
     * 
     * @type {string}
     * @memberof ClearDiscountRequest
     */
    'cartId': string;
}
/**
 * 
 * @export
 * @interface ClicksResponse
 */
export interface ClicksResponse {
    /**
     * 
     * @type {Array<object>}
     * @memberof ClicksResponse
     */
    'clicks': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof ClicksResponse
     */
    'totalClicks': number;
    /**
     * 
     * @type {number}
     * @memberof ClicksResponse
     */
    'clickThroughRate': number;
}
/**
 * 
 * @export
 * @interface CommentRequest
 */
export interface CommentRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CommentRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommentRequest
     */
    'writeAuthority': CommentRequestWriteAuthorityEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommentRequest
     */
    'avatars': Array<string>;
}

export const CommentRequestWriteAuthorityEnum = {
    All: 'all',
    Moderators: 'moderators'
} as const;

export type CommentRequestWriteAuthorityEnum = typeof CommentRequestWriteAuthorityEnum[keyof typeof CommentRequestWriteAuthorityEnum];

/**
 * 
 * @export
 * @interface CouponsDto
 */
export interface CouponsDto {
    /**
     * 
     * @type {string}
     * @memberof CouponsDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponsDto
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface CreateInventoryRequest
 */
export interface CreateInventoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInventoryRequest
     */
    'type': CreateInventoryRequestTypeEnum;
    /**
     * 
     * @type {Array<InventoryPriceRequest>}
     * @memberof CreateInventoryRequest
     */
    'inventoryPrice': Array<InventoryPriceRequest>;
    /**
     * 
     * @type {InventoryPriceRequest}
     * @memberof CreateInventoryRequest
     */
    'defaultInventoryPrice': InventoryPriceRequest;
}

export const CreateInventoryRequestTypeEnum = {
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Banner: 'banner',
    Email: 'email'
} as const;

export type CreateInventoryRequestTypeEnum = typeof CreateInventoryRequestTypeEnum[keyof typeof CreateInventoryRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateWelcomeGiftRequest
 */
export interface CreateWelcomeGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateWelcomeGiftRequest
     */
    'type': CreateWelcomeGiftRequestTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWelcomeGiftRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateWelcomeGiftRequest
     */
    'expiresInDays': number;
    /**
     * 
     * @type {number}
     * @memberof CreateWelcomeGiftRequest
     */
    'remindsBeforeDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWelcomeGiftRequest
     */
    'monetary'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateWelcomeGiftRequest
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateWelcomeGiftRequest
     */
    'minPurchaseAmount': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWelcomeGiftRequest
     */
    'phoneVerificationEnabled'?: boolean;
}

export const CreateWelcomeGiftRequestTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type CreateWelcomeGiftRequestTypeEnum = typeof CreateWelcomeGiftRequestTypeEnum[keyof typeof CreateWelcomeGiftRequestTypeEnum];

/**
 * 
 * @export
 * @interface CustomOrderCreateRequest
 */
export interface CustomOrderCreateRequest {
    /**
     * The order id created on your platform
     * @type {string}
     * @memberof CustomOrderCreateRequest
     */
    'id': string;
    /**
     * An array of products purchased in this order
     * @type {Array<ItemsCreateRequest>}
     * @memberof CustomOrderCreateRequest
     */
    'items': Array<ItemsCreateRequest>;
    /**
     * Tax amount applied to this order
     * @type {number}
     * @memberof CustomOrderCreateRequest
     */
    'tax': number;
    /**
     * Shipping total
     * @type {number}
     * @memberof CustomOrderCreateRequest
     */
    'shipping': number;
    /**
     * Order total value
     * @type {number}
     * @memberof CustomOrderCreateRequest
     */
    'total': number;
    /**
     * Total discount amount applied to this order
     * @type {number}
     * @memberof CustomOrderCreateRequest
     */
    'totalDiscounts': number;
    /**
     * Customer email
     * @type {string}
     * @memberof CustomOrderCreateRequest
     */
    'customerEmail': string;
    /**
     * Customer first name
     * @type {string}
     * @memberof CustomOrderCreateRequest
     */
    'customerFirstName'?: string;
    /**
     * Customer last name
     * @type {string}
     * @memberof CustomOrderCreateRequest
     */
    'customerLastName'?: string;
    /**
     * Customer phone number
     * @type {string}
     * @memberof CustomOrderCreateRequest
     */
    'customerPhone'?: string;
    /**
     * Array of discounts applied to this order
     * @type {Array<DiscountCreateRequest>}
     * @memberof CustomOrderCreateRequest
     */
    'appliedDiscounts': Array<DiscountCreateRequest>;
    /**
     * The status of the order, eg: inviced, paid, etc...
     * @type {string}
     * @memberof CustomOrderCreateRequest
     */
    'status': string;
    /**
     * Order creation date
     * @type {string}
     * @memberof CustomOrderCreateRequest
     */
    'orderDate': string;
}
/**
 * 
 * @export
 * @interface CustomerResponse
 */
export interface CustomerResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomerResponse
     */
    'customerId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponse
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponse
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface DiscountCashbackValidatorRequest
 */
export interface DiscountCashbackValidatorRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountCashbackValidatorRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DiscountCreateRequest
 */
export interface DiscountCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountCreateRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountCreateRequest
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof DiscountCreateRequest
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface DiscountDto
 */
export interface DiscountDto {
    /**
     * User latest source
     * @type {string}
     * @memberof DiscountDto
     */
    'userSource'?: DiscountDtoUserSourceEnum;
    /**
     * User source at discount creation
     * @type {string}
     * @memberof DiscountDto
     */
    'originalUserSource'?: DiscountDtoOriginalUserSourceEnum;
    /**
     * User source at redeem time
     * @type {string}
     * @memberof DiscountDto
     */
    'redeemedUserSource'?: DiscountDtoRedeemedUserSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof DiscountDto
     */
    'value': number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscountDto
     */
    'used': boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'status': DiscountDtoStatusEnum;
    /**
     * 
     * @type {ReferenceDto}
     * @memberof DiscountDto
     */
    'reference'?: ReferenceDto;
    /**
     * 
     * @type {Array<DiscountOrderDto>}
     * @memberof DiscountDto
     */
    'orders'?: Array<DiscountOrderDto>;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'usedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'source': DiscountDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'cardId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'createdByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'returnedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'returnedByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'returnedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'remindsAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'redeemedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'redeemedByGroup'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscountDto
     */
    'usedValue'?: number;
    /**
     * 
     * @type {CashbackConfigDto}
     * @memberof DiscountDto
     */
    'cashbackConfig': CashbackConfigDto;
    /**
     * 
     * @type {DiscountSkuDto}
     * @memberof DiscountDto
     */
    'skuDetails'?: DiscountSkuDto;
    /**
     * 
     * @type {BogoDto}
     * @memberof DiscountDto
     */
    'bogoDetails'?: BogoDto;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    'type'?: DiscountDtoTypeEnum;
    /**
     * 
     * @type {DiscountPointsDto}
     * @memberof DiscountDto
     */
    'points'?: DiscountPointsDto;
}

export const DiscountDtoUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type DiscountDtoUserSourceEnum = typeof DiscountDtoUserSourceEnum[keyof typeof DiscountDtoUserSourceEnum];
export const DiscountDtoOriginalUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type DiscountDtoOriginalUserSourceEnum = typeof DiscountDtoOriginalUserSourceEnum[keyof typeof DiscountDtoOriginalUserSourceEnum];
export const DiscountDtoRedeemedUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type DiscountDtoRedeemedUserSourceEnum = typeof DiscountDtoRedeemedUserSourceEnum[keyof typeof DiscountDtoRedeemedUserSourceEnum];
export const DiscountDtoStatusEnum = {
    Used: 'used',
    Valid: 'valid',
    Expired: 'expired',
    Returned: 'returned',
    Cancelled: 'cancelled',
    Pending: 'pending'
} as const;

export type DiscountDtoStatusEnum = typeof DiscountDtoStatusEnum[keyof typeof DiscountDtoStatusEnum];
export const DiscountDtoSourceEnum = {
    OnlineOrder: 'onlineOrder',
    OfflineOrder: 'offlineOrder',
    WelcomeGift: 'WelcomeGift',
    Campaign: 'campaign',
    Points: 'points',
    Flows: 'flows'
} as const;

export type DiscountDtoSourceEnum = typeof DiscountDtoSourceEnum[keyof typeof DiscountDtoSourceEnum];
export const DiscountDtoTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type DiscountDtoTypeEnum = typeof DiscountDtoTypeEnum[keyof typeof DiscountDtoTypeEnum];

/**
 * 
 * @export
 * @interface DiscountExportRequest
 */
export interface DiscountExportRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountExportRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface DiscountOrderDto
 */
export interface DiscountOrderDto {
    /**
     * 
     * @type {string}
     * @memberof DiscountOrderDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountOrderDto
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountOrderDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountOrderDto
     */
    'source'?: DiscountOrderDtoSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof DiscountOrderDto
     */
    'total'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscountOrderDto
     */
    'invoiced'?: boolean;
}

export const DiscountOrderDtoSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;

export type DiscountOrderDtoSourceEnum = typeof DiscountOrderDtoSourceEnum[keyof typeof DiscountOrderDtoSourceEnum];

/**
 * 
 * @export
 * @interface DiscountPointsDto
 */
export interface DiscountPointsDto {
    /**
     * 
     * @type {number}
     * @memberof DiscountPointsDto
     */
    'usedPoints'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountPointsDto
     */
    'redeemedBackPoints'?: number;
}
/**
 * 
 * @export
 * @interface DiscountPopulatedDto
 */
export interface DiscountPopulatedDto {
    /**
     * User latest source
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'userSource'?: DiscountPopulatedDtoUserSourceEnum;
    /**
     * User source at discount creation
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'originalUserSource'?: DiscountPopulatedDtoOriginalUserSourceEnum;
    /**
     * User source at redeem time
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'redeemedUserSource'?: DiscountPopulatedDtoRedeemedUserSourceEnum;
    /**
     * 
     * @type {UserDto}
     * @memberof DiscountPopulatedDto
     */
    'user': UserDto | null;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof DiscountPopulatedDto
     */
    'value': number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscountPopulatedDto
     */
    'used': boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'status': DiscountPopulatedDtoStatusEnum;
    /**
     * 
     * @type {ReferenceDto}
     * @memberof DiscountPopulatedDto
     */
    'reference'?: ReferenceDto;
    /**
     * 
     * @type {Array<DiscountOrderDto>}
     * @memberof DiscountPopulatedDto
     */
    'orders'?: Array<DiscountOrderDto>;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'usedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'source': DiscountPopulatedDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'cardId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'createdByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'returnedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'returnedByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'returnedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'remindsAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'redeemedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'redeemedByGroup'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscountPopulatedDto
     */
    'usedValue'?: number;
    /**
     * 
     * @type {CashbackConfigDto}
     * @memberof DiscountPopulatedDto
     */
    'cashbackConfig': CashbackConfigDto;
    /**
     * 
     * @type {DiscountSkuDto}
     * @memberof DiscountPopulatedDto
     */
    'skuDetails'?: DiscountSkuDto;
    /**
     * 
     * @type {BogoDto}
     * @memberof DiscountPopulatedDto
     */
    'bogoDetails'?: BogoDto;
    /**
     * 
     * @type {string}
     * @memberof DiscountPopulatedDto
     */
    'type'?: DiscountPopulatedDtoTypeEnum;
    /**
     * 
     * @type {DiscountPointsDto}
     * @memberof DiscountPopulatedDto
     */
    'points'?: DiscountPointsDto;
}

export const DiscountPopulatedDtoUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type DiscountPopulatedDtoUserSourceEnum = typeof DiscountPopulatedDtoUserSourceEnum[keyof typeof DiscountPopulatedDtoUserSourceEnum];
export const DiscountPopulatedDtoOriginalUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type DiscountPopulatedDtoOriginalUserSourceEnum = typeof DiscountPopulatedDtoOriginalUserSourceEnum[keyof typeof DiscountPopulatedDtoOriginalUserSourceEnum];
export const DiscountPopulatedDtoRedeemedUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type DiscountPopulatedDtoRedeemedUserSourceEnum = typeof DiscountPopulatedDtoRedeemedUserSourceEnum[keyof typeof DiscountPopulatedDtoRedeemedUserSourceEnum];
export const DiscountPopulatedDtoStatusEnum = {
    Used: 'used',
    Valid: 'valid',
    Expired: 'expired',
    Returned: 'returned',
    Cancelled: 'cancelled',
    Pending: 'pending'
} as const;

export type DiscountPopulatedDtoStatusEnum = typeof DiscountPopulatedDtoStatusEnum[keyof typeof DiscountPopulatedDtoStatusEnum];
export const DiscountPopulatedDtoSourceEnum = {
    OnlineOrder: 'onlineOrder',
    OfflineOrder: 'offlineOrder',
    WelcomeGift: 'WelcomeGift',
    Campaign: 'campaign',
    Points: 'points',
    Flows: 'flows'
} as const;

export type DiscountPopulatedDtoSourceEnum = typeof DiscountPopulatedDtoSourceEnum[keyof typeof DiscountPopulatedDtoSourceEnum];
export const DiscountPopulatedDtoTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type DiscountPopulatedDtoTypeEnum = typeof DiscountPopulatedDtoTypeEnum[keyof typeof DiscountPopulatedDtoTypeEnum];

/**
 * 
 * @export
 * @interface DiscountRequest
 */
export interface DiscountRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface DiscountResponse
 */
export interface DiscountResponse {
    /**
     * 
     * @type {DiscountDto}
     * @memberof DiscountResponse
     */
    'discount': DiscountDto;
}
/**
 * 
 * @export
 * @interface DiscountSkuDto
 */
export interface DiscountSkuDto {
    /**
     * 
     * @type {string}
     * @memberof DiscountSkuDto
     */
    'skuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountSkuDto
     */
    'productId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountSkuDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface DiscountsPopulatedResponse
 */
export interface DiscountsPopulatedResponse {
    /**
     * 
     * @type {Array<DiscountPopulatedDto>}
     * @memberof DiscountsPopulatedResponse
     */
    'discounts': Array<DiscountPopulatedDto>;
    /**
     * 
     * @type {number}
     * @memberof DiscountsPopulatedResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface DiscountsResponse
 */
export interface DiscountsResponse {
    /**
     * 
     * @type {Array<DiscountDto>}
     * @memberof DiscountsResponse
     */
    'discounts': Array<DiscountDto>;
    /**
     * 
     * @type {number}
     * @memberof DiscountsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface DiscountsTotalsResponse
 */
export interface DiscountsTotalsResponse {
    /**
     * 
     * @type {number}
     * @memberof DiscountsTotalsResponse
     */
    'totalGiven': number;
    /**
     * 
     * @type {number}
     * @memberof DiscountsTotalsResponse
     */
    'totalRedeemed': number;
    /**
     * 
     * @type {number}
     * @memberof DiscountsTotalsResponse
     */
    'totalGiftNowGiven': number;
    /**
     * 
     * @type {number}
     * @memberof DiscountsTotalsResponse
     */
    'totalGiftNowRedeemed': number;
    /**
     * 
     * @type {number}
     * @memberof DiscountsTotalsResponse
     */
    'totalWelcomeGiftGiven': number;
    /**
     * 
     * @type {number}
     * @memberof DiscountsTotalsResponse
     */
    'totalWelcomeGiftRedeemed': number;
}
/**
 * 
 * @export
 * @interface DurationRequest
 */
export interface DurationRequest {
    /**
     * 
     * @type {string}
     * @memberof DurationRequest
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof DurationRequest
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface EmployeeDetailDto
 */
export interface EmployeeDetailDto {
    /**
     * User role
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'role': string;
    /**
     * Manager ID
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'manager': string | null;
    /**
     * Organization Id
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'organization': string;
    /**
     * Department ID
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'department': string;
    /**
     * Location ID
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'location': string;
}
/**
 * 
 * @export
 * @interface FinalizeAuthenticationRequest
 */
export interface FinalizeAuthenticationRequest {
    /**
     * 
     * @type {string}
     * @memberof FinalizeAuthenticationRequest
     */
    'Code': string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeAuthenticationRequest
     */
    'Type': string;
    /**
     * 
     * @type {boolean}
     * @memberof FinalizeAuthenticationRequest
     */
    'validatedByException': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FinalizeAuthenticationRequest
     */
    'authenticated': boolean;
}
/**
 * 
 * @export
 * @interface FinalizeBonusRequest
 */
export interface FinalizeBonusRequest {
    /**
     * 
     * @type {string}
     * @memberof FinalizeBonusRequest
     */
    'externalBusinessUnitId': string;
    /**
     * 
     * @type {PartnerCredentialsRequest}
     * @memberof FinalizeBonusRequest
     */
    'partnerCredentials': PartnerCredentialsRequest;
    /**
     * 
     * @type {FinalizeIdentificationRequest}
     * @memberof FinalizeBonusRequest
     */
    'identification': FinalizeIdentificationRequest;
    /**
     * 
     * @type {BonusRequest}
     * @memberof FinalizeBonusRequest
     */
    'bonus': BonusRequest;
    /**
     * 
     * @type {Array<CampaignRequest>}
     * @memberof FinalizeBonusRequest
     */
    'campaigns': Array<CampaignRequest>;
    /**
     * 
     * @type {FinalizeAuthenticationRequest}
     * @memberof FinalizeBonusRequest
     */
    'authentication': FinalizeAuthenticationRequest;
    /**
     * 
     * @type {SaleRequest}
     * @memberof FinalizeBonusRequest
     */
    'sale': SaleRequest;
}
/**
 * 
 * @export
 * @interface FinalizeBonusResponse
 */
export interface FinalizeBonusResponse {
    /**
     * 
     * @type {object}
     * @memberof FinalizeBonusResponse
     */
    'nextStep': object | null;
    /**
     * 
     * @type {string}
     * @memberof FinalizeBonusResponse
     */
    'bonusId': string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeBonusResponse
     */
    'partnerSaleId': string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeBonusResponse
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeBonusResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeBonusResponse
     */
    'customerText': string;
    /**
     * 
     * @type {boolean}
     * @memberof FinalizeBonusResponse
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface FinalizeIdentificationRequest
 */
export interface FinalizeIdentificationRequest {
    /**
     * 
     * @type {string}
     * @memberof FinalizeIdentificationRequest
     */
    'identificationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeIdentificationRequest
     */
    'storeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeIdentificationRequest
     */
    'costumerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeIdentificationRequest
     */
    'operatorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeIdentificationRequest
     */
    'operatorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeIdentificationRequest
     */
    'customerDocument'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeIdentificationRequest
     */
    'Phone'?: string | null;
}
/**
 * 
 * @export
 * @interface FreeShippingCodeDto
 */
export interface FreeShippingCodeDto {
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeDto
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeDto
     */
    'status': FreeShippingCodeDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeDto
     */
    'usedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeDto
     */
    'userFreeShipping'?: string;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeDto
     */
    'createdAt': string;
}

export const FreeShippingCodeDtoStatusEnum = {
    Valid: 'valid',
    Invalid: 'invalid',
    Used: 'used',
    Expired: 'expired'
} as const;

export type FreeShippingCodeDtoStatusEnum = typeof FreeShippingCodeDtoStatusEnum[keyof typeof FreeShippingCodeDtoStatusEnum];

/**
 * 
 * @export
 * @interface FreeShippingCodeResponse
 */
export interface FreeShippingCodeResponse {
    /**
     * 
     * @type {FreeShippingCodeDto}
     * @memberof FreeShippingCodeResponse
     */
    'freeShippingCode': FreeShippingCodeDto;
}
/**
 * 
 * @export
 * @interface FreeShippingCodeUpdateRequest
 */
export interface FreeShippingCodeUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FreeShippingCodeUpdateRequest
     */
    'used'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeUpdateRequest
     */
    'usedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FreeShippingCodeUpdateRequest
     */
    'status'?: FreeShippingCodeUpdateRequestStatusEnum;
}

export const FreeShippingCodeUpdateRequestStatusEnum = {
    Valid: 'valid',
    Invalid: 'invalid',
    Used: 'used',
    Expired: 'expired'
} as const;

export type FreeShippingCodeUpdateRequestStatusEnum = typeof FreeShippingCodeUpdateRequestStatusEnum[keyof typeof FreeShippingCodeUpdateRequestStatusEnum];

/**
 * 
 * @export
 * @interface FreeShippingCodesResponse
 */
export interface FreeShippingCodesResponse {
    /**
     * 
     * @type {Array<FreeShippingCodeDto>}
     * @memberof FreeShippingCodesResponse
     */
    'freeShippingCodes': Array<FreeShippingCodeDto>;
}
/**
 * 
 * @export
 * @interface GenerateOtpResponse
 */
export interface GenerateOtpResponse {
    /**
     * OTP code sent by sms
     * @type {string}
     * @memberof GenerateOtpResponse
     */
    'code': string;
    /**
     * Order amount
     * @type {number}
     * @memberof GenerateOtpResponse
     */
    'amount': number;
    /**
     * User phone number
     * @type {string}
     * @memberof GenerateOtpResponse
     */
    'phone': string;
    /**
     * Identifier of the sales rep that created the order
     * @type {string}
     * @memberof GenerateOtpResponse
     */
    'createdBy': string;
}
/**
 * 
 * @export
 * @interface GetBonusResponse
 */
export interface GetBonusResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBonusResponse
     */
    'nextStep': string;
    /**
     * 
     * @type {string}
     * @memberof GetBonusResponse
     */
    'customerText': string;
    /**
     * 
     * @type {string}
     * @memberof GetBonusResponse
     */
    'operatorText': string;
    /**
     * 
     * @type {Array<BonusResponse>}
     * @memberof GetBonusResponse
     */
    'bonus': Array<BonusResponse>;
    /**
     * 
     * @type {string}
     * @memberof GetBonusResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBonusResponse
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface GiftCardsDto
 */
export interface GiftCardsDto {
    /**
     * 
     * @type {string}
     * @memberof GiftCardsDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GiftCardsDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof GiftCardsDto
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface GlobalBrandDto
 */
export interface GlobalBrandDto {
    /**
     * 
     * @type {string}
     * @memberof GlobalBrandDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GlobalBrandDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GlobalBrandsResponse
 */
export interface GlobalBrandsResponse {
    /**
     * 
     * @type {Array<GlobalBrandDto>}
     * @memberof GlobalBrandsResponse
     */
    'globalBrands': Array<GlobalBrandDto>;
    /**
     * 
     * @type {number}
     * @memberof GlobalBrandsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface GlobalCategoriesDto
 */
export interface GlobalCategoriesDto {
    /**
     * 
     * @type {string}
     * @memberof GlobalCategoriesDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GlobalCategoriesDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalCategoriesDto
     */
    'deleted': boolean;
}
/**
 * 
 * @export
 * @interface GlobalCategoriesResponse
 */
export interface GlobalCategoriesResponse {
    /**
     * 
     * @type {Array<GlobalCategoriesDto>}
     * @memberof GlobalCategoriesResponse
     */
    'globalCategories': Array<GlobalCategoriesDto>;
    /**
     * 
     * @type {number}
     * @memberof GlobalCategoriesResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface GlobalProductDto
 */
export interface GlobalProductDto {
    /**
     * 
     * @type {string}
     * @memberof GlobalProductDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GlobalProductDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GlobalProductsResponse
 */
export interface GlobalProductsResponse {
    /**
     * 
     * @type {Array<GlobalProductDto>}
     * @memberof GlobalProductsResponse
     */
    'globalProducts': Array<GlobalProductDto>;
    /**
     * 
     * @type {number}
     * @memberof GlobalProductsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface IdentificationAuthResponse
 */
export interface IdentificationAuthResponse {
    /**
     * 
     * @type {string}
     * @memberof IdentificationAuthResponse
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof IdentificationAuthResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof IdentificationAuthResponse
     */
    'operatorText': string;
    /**
     * 
     * @type {string}
     * @memberof IdentificationAuthResponse
     */
    'customerText': string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentificationAuthResponse
     */
    'isPassword': boolean;
}
/**
 * 
 * @export
 * @interface IdentificationFormResponse
 */
export interface IdentificationFormResponse {
    /**
     * 
     * @type {string}
     * @memberof IdentificationFormResponse
     */
    'partnerCode': string;
    /**
     * 
     * @type {string}
     * @memberof IdentificationFormResponse
     */
    'nextStep': string;
    /**
     * 
     * @type {string}
     * @memberof IdentificationFormResponse
     */
    'customerText': string;
    /**
     * 
     * @type {string}
     * @memberof IdentificationFormResponse
     */
    'operatorText': string;
    /**
     * 
     * @type {Array<IdentificationFromDto>}
     * @memberof IdentificationFormResponse
     */
    'identificationForms': Array<IdentificationFromDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IdentificationFormResponse
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface IdentificationFromDto
 */
export interface IdentificationFromDto {
    /**
     * 
     * @type {boolean}
     * @memberof IdentificationFromDto
     */
    'isIdentificationCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentificationFromDto
     */
    'type': IdentificationFromDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IdentificationFromDto
     */
    'operatorText': string;
    /**
     * 
     * @type {string}
     * @memberof IdentificationFromDto
     */
    'customerText': string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentificationFromDto
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentificationFromDto
     */
    'isPassword': boolean;
}

export const IdentificationFromDtoTypeEnum = {
    Phone: 'phone',
    Email: 'email',
    Name: 'name',
    Cpf: 'cpf',
    Gender: 'gender'
} as const;

export type IdentificationFromDtoTypeEnum = typeof IdentificationFromDtoTypeEnum[keyof typeof IdentificationFromDtoTypeEnum];

/**
 * 
 * @export
 * @interface IdentificationRequest
 */
export interface IdentificationRequest {
    /**
     * 
     * @type {UserIdentificationRequest}
     * @memberof IdentificationRequest
     */
    'identification': UserIdentificationRequest;
    /**
     * 
     * @type {IdentificationSaleRequest}
     * @memberof IdentificationRequest
     */
    'sale': IdentificationSaleRequest;
    /**
     * 
     * @type {PartnerCredentialsRequest}
     * @memberof IdentificationRequest
     */
    'partnerCredentials': PartnerCredentialsRequest;
    /**
     * 
     * @type {string}
     * @memberof IdentificationRequest
     */
    'externalBusinessUnitId': string;
}
/**
 * 
 * @export
 * @interface IdentificationResponse
 */
export interface IdentificationResponse {
    /**
     * 
     * @type {string}
     * @memberof IdentificationResponse
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof IdentificationResponse
     */
    'costumerId': string;
}
/**
 * 
 * @export
 * @interface IdentificationSaleRequest
 */
export interface IdentificationSaleRequest {
    /**
     * 
     * @type {number}
     * @memberof IdentificationSaleRequest
     */
    'netSaleValue': number;
}
/**
 * 
 * @export
 * @interface ImportRequest
 */
export interface ImportRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportRequest
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ImportRequest
     */
    'operation'?: ImportRequestOperationEnum;
}

export const ImportRequestOperationEnum = {
    Insert: 'insert',
    Update: 'update',
    Upsert: 'upsert'
} as const;

export type ImportRequestOperationEnum = typeof ImportRequestOperationEnum[keyof typeof ImportRequestOperationEnum];

/**
 * 
 * @export
 * @interface ImpressionCreateRequest
 */
export interface ImpressionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ImpressionCreateRequest
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionCreateRequest
     */
    'retailApp': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionCreateRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionCreateRequest
     */
    'type': ImpressionCreateRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ImpressionCreateRequest
     */
    'campaignId': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionCreateRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionCreateRequest
     */
    'customerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionCreateRequest
     */
    'date': string;
}

export const ImpressionCreateRequestTypeEnum = {
    View: 'view',
    Click: 'click',
    Convergence: 'convergence'
} as const;

export type ImpressionCreateRequestTypeEnum = typeof ImpressionCreateRequestTypeEnum[keyof typeof ImpressionCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface ImpressionDto
 */
export interface ImpressionDto {
    /**
     * 
     * @type {string}
     * @memberof ImpressionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionDto
     */
    'type': ImpressionDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ImpressionDto
     */
    'campaignId': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionDto
     */
    'customerId'?: string;
    /**
     * 
     * @type {ImpressionOrderDto}
     * @memberof ImpressionDto
     */
    'order'?: ImpressionOrderDto;
    /**
     * 
     * @type {string}
     * @memberof ImpressionDto
     */
    'date': string;
}

export const ImpressionDtoTypeEnum = {
    View: 'view',
    Click: 'click',
    Convergence: 'convergence'
} as const;

export type ImpressionDtoTypeEnum = typeof ImpressionDtoTypeEnum[keyof typeof ImpressionDtoTypeEnum];

/**
 * 
 * @export
 * @interface ImpressionItemsDto
 */
export interface ImpressionItemsDto {
    /**
     * 
     * @type {number}
     * @memberof ImpressionItemsDto
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImpressionItemsDto
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof ImpressionItemsDto
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionItemsDto
     */
    'productName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImpressionItemsDto
     */
    'categories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ImpressionItemsDto
     */
    'brand'?: string;
}
/**
 * 
 * @export
 * @interface ImpressionOrderDto
 */
export interface ImpressionOrderDto {
    /**
     * 
     * @type {string}
     * @memberof ImpressionOrderDto
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof ImpressionOrderDto
     */
    'orderDate': string;
    /**
     * 
     * @type {number}
     * @memberof ImpressionOrderDto
     */
    'orderTotal': number;
    /**
     * 
     * @type {Array<ImpressionItemsDto>}
     * @memberof ImpressionOrderDto
     */
    'items': Array<ImpressionItemsDto>;
}
/**
 * 
 * @export
 * @interface ImpressionResponse
 */
export interface ImpressionResponse {
    /**
     * 
     * @type {ImpressionDto}
     * @memberof ImpressionResponse
     */
    'impression': ImpressionDto;
}
/**
 * 
 * @export
 * @interface InventoryDto
 */
export interface InventoryDto {
    /**
     * 
     * @type {string}
     * @memberof InventoryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InventoryDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof InventoryDto
     */
    'type': InventoryDtoTypeEnum;
    /**
     * 
     * @type {Array<InventoryPriceDto>}
     * @memberof InventoryDto
     */
    'inventoryPrice': Array<InventoryPriceDto>;
    /**
     * 
     * @type {InventoryPriceDto}
     * @memberof InventoryDto
     */
    'defaultInventoryPrice': InventoryPriceDto;
}

export const InventoryDtoTypeEnum = {
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Banner: 'banner',
    Email: 'email'
} as const;

export type InventoryDtoTypeEnum = typeof InventoryDtoTypeEnum[keyof typeof InventoryDtoTypeEnum];

/**
 * 
 * @export
 * @interface InventoryListResponse
 */
export interface InventoryListResponse {
    /**
     * 
     * @type {Array<InventoryDto>}
     * @memberof InventoryListResponse
     */
    'inventory': Array<InventoryDto> | null;
}
/**
 * 
 * @export
 * @interface InventoryPriceDto
 */
export interface InventoryPriceDto {
    /**
     * 
     * @type {string}
     * @memberof InventoryPriceDto
     */
    'segmentId': string;
    /**
     * 
     * @type {number}
     * @memberof InventoryPriceDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof InventoryPriceDto
     */
    'frequency': number;
    /**
     * 
     * @type {string}
     * @memberof InventoryPriceDto
     */
    'currency': InventoryPriceDtoCurrencyEnum;
}

export const InventoryPriceDtoCurrencyEnum = {
    Aed: 'aed',
    Afn: 'afn',
    All: 'all',
    Amd: 'amd',
    Ang: 'ang',
    Aoa: 'aoa',
    Ars: 'ars',
    Aud: 'aud',
    Awg: 'awg',
    Azn: 'azn',
    Bam: 'bam',
    Bbd: 'bbd',
    Bdt: 'bdt',
    Bgn: 'bgn',
    Bhd: 'bhd',
    Bif: 'bif',
    Bmd: 'bmd',
    Bnd: 'bnd',
    Bob: 'bob',
    Brl: 'brl',
    Bsd: 'bsd',
    Btn: 'btn',
    Bwp: 'bwp',
    Byn: 'byn',
    Bzd: 'bzd',
    Cad: 'cad',
    Cdf: 'cdf',
    Chf: 'chf',
    Clp: 'clp',
    Cny: 'cny',
    Cop: 'cop',
    Crc: 'crc',
    Cuc: 'cuc',
    Cup: 'cup',
    Cve: 'cve',
    Czk: 'czk',
    Djf: 'djf',
    Dkk: 'dkk',
    Dop: 'dop',
    Dzd: 'dzd',
    Egp: 'egp',
    Ern: 'ern',
    Etb: 'etb',
    Eur: 'eur',
    Fjd: 'fjd',
    Fkp: 'fkp',
    Gbp: 'gbp',
    Gel: 'gel',
    Ghs: 'ghs',
    Gip: 'gip',
    Gmd: 'gmd',
    Gnf: 'gnf',
    Gtq: 'gtq',
    Gyd: 'gyd',
    Hkd: 'hkd',
    Hnl: 'hnl',
    Hrk: 'hrk',
    Htg: 'htg',
    Huf: 'huf',
    Idr: 'idr',
    Ils: 'ils',
    Inr: 'inr',
    Iqd: 'iqd',
    Irr: 'irr',
    Isk: 'isk',
    Jmd: 'jmd',
    Jod: 'jod',
    Jpy: 'jpy',
    Kes: 'kes',
    Kgs: 'kgs',
    Khr: 'khr',
    Kmf: 'kmf',
    Kpw: 'kpw',
    Krw: 'krw',
    Kwd: 'kwd',
    Kyd: 'kyd',
    Kzt: 'kzt',
    Lak: 'lak',
    Lbp: 'lbp',
    Lkr: 'lkr',
    Lrd: 'lrd',
    Lsl: 'lsl',
    Lyd: 'lyd',
    Mad: 'mad',
    Mdl: 'mdl',
    Mga: 'mga',
    Mkd: 'mkd',
    Mmk: 'mmk',
    Mnt: 'mnt',
    Mop: 'mop',
    Mru: 'mru',
    Mur: 'mur',
    Mvr: 'mvr',
    Mwk: 'mwk',
    Mxn: 'mxn',
    Myr: 'myr',
    Mzn: 'mzn',
    Nad: 'nad',
    Ngn: 'ngn',
    Nio: 'nio',
    Nok: 'nok',
    Npr: 'npr',
    Nzd: 'nzd',
    Omr: 'omr',
    Pab: 'pab',
    Pen: 'pen',
    Pgk: 'pgk',
    Php: 'php',
    Pkr: 'pkr',
    Pln: 'pln',
    Pyg: 'pyg',
    Qar: 'qar',
    Ron: 'ron',
    Rsd: 'rsd',
    Rub: 'rub',
    Rwf: 'rwf',
    Sar: 'sar',
    Sbd: 'sbd',
    Scr: 'scr',
    Sdg: 'sdg',
    Sek: 'sek',
    Sgd: 'sgd',
    Shp: 'shp',
    Sll: 'sll',
    Sos: 'sos',
    Srd: 'srd',
    Ssp: 'ssp',
    Stn: 'stn',
    Svc: 'svc',
    Syp: 'syp',
    Szl: 'szl',
    Thb: 'thb',
    Tjs: 'tjs',
    Tmt: 'tmt',
    Tnd: 'tnd',
    Top: 'top',
    Try: 'try',
    Ttd: 'ttd',
    Twd: 'twd',
    Tzs: 'tzs',
    Uah: 'uah',
    Ugx: 'ugx',
    Usd: 'usd',
    Uyu: 'uyu',
    Uzs: 'uzs',
    Ves: 'ves',
    Vnd: 'vnd',
    Vuv: 'vuv',
    Wst: 'wst',
    Xaf: 'xaf',
    Xcd: 'xcd',
    Xof: 'xof',
    Xpf: 'xpf',
    Yer: 'yer',
    Zar: 'zar',
    Zmw: 'zmw',
    Zwl: 'zwl'
} as const;

export type InventoryPriceDtoCurrencyEnum = typeof InventoryPriceDtoCurrencyEnum[keyof typeof InventoryPriceDtoCurrencyEnum];

/**
 * 
 * @export
 * @interface InventoryPriceRequest
 */
export interface InventoryPriceRequest {
    /**
     * 
     * @type {string}
     * @memberof InventoryPriceRequest
     */
    'segmentId': string;
    /**
     * 
     * @type {number}
     * @memberof InventoryPriceRequest
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof InventoryPriceRequest
     */
    'frequency': number;
    /**
     * 
     * @type {string}
     * @memberof InventoryPriceRequest
     */
    'currency': InventoryPriceRequestCurrencyEnum;
}

export const InventoryPriceRequestCurrencyEnum = {
    Aed: 'aed',
    Afn: 'afn',
    All: 'all',
    Amd: 'amd',
    Ang: 'ang',
    Aoa: 'aoa',
    Ars: 'ars',
    Aud: 'aud',
    Awg: 'awg',
    Azn: 'azn',
    Bam: 'bam',
    Bbd: 'bbd',
    Bdt: 'bdt',
    Bgn: 'bgn',
    Bhd: 'bhd',
    Bif: 'bif',
    Bmd: 'bmd',
    Bnd: 'bnd',
    Bob: 'bob',
    Brl: 'brl',
    Bsd: 'bsd',
    Btn: 'btn',
    Bwp: 'bwp',
    Byn: 'byn',
    Bzd: 'bzd',
    Cad: 'cad',
    Cdf: 'cdf',
    Chf: 'chf',
    Clp: 'clp',
    Cny: 'cny',
    Cop: 'cop',
    Crc: 'crc',
    Cuc: 'cuc',
    Cup: 'cup',
    Cve: 'cve',
    Czk: 'czk',
    Djf: 'djf',
    Dkk: 'dkk',
    Dop: 'dop',
    Dzd: 'dzd',
    Egp: 'egp',
    Ern: 'ern',
    Etb: 'etb',
    Eur: 'eur',
    Fjd: 'fjd',
    Fkp: 'fkp',
    Gbp: 'gbp',
    Gel: 'gel',
    Ghs: 'ghs',
    Gip: 'gip',
    Gmd: 'gmd',
    Gnf: 'gnf',
    Gtq: 'gtq',
    Gyd: 'gyd',
    Hkd: 'hkd',
    Hnl: 'hnl',
    Hrk: 'hrk',
    Htg: 'htg',
    Huf: 'huf',
    Idr: 'idr',
    Ils: 'ils',
    Inr: 'inr',
    Iqd: 'iqd',
    Irr: 'irr',
    Isk: 'isk',
    Jmd: 'jmd',
    Jod: 'jod',
    Jpy: 'jpy',
    Kes: 'kes',
    Kgs: 'kgs',
    Khr: 'khr',
    Kmf: 'kmf',
    Kpw: 'kpw',
    Krw: 'krw',
    Kwd: 'kwd',
    Kyd: 'kyd',
    Kzt: 'kzt',
    Lak: 'lak',
    Lbp: 'lbp',
    Lkr: 'lkr',
    Lrd: 'lrd',
    Lsl: 'lsl',
    Lyd: 'lyd',
    Mad: 'mad',
    Mdl: 'mdl',
    Mga: 'mga',
    Mkd: 'mkd',
    Mmk: 'mmk',
    Mnt: 'mnt',
    Mop: 'mop',
    Mru: 'mru',
    Mur: 'mur',
    Mvr: 'mvr',
    Mwk: 'mwk',
    Mxn: 'mxn',
    Myr: 'myr',
    Mzn: 'mzn',
    Nad: 'nad',
    Ngn: 'ngn',
    Nio: 'nio',
    Nok: 'nok',
    Npr: 'npr',
    Nzd: 'nzd',
    Omr: 'omr',
    Pab: 'pab',
    Pen: 'pen',
    Pgk: 'pgk',
    Php: 'php',
    Pkr: 'pkr',
    Pln: 'pln',
    Pyg: 'pyg',
    Qar: 'qar',
    Ron: 'ron',
    Rsd: 'rsd',
    Rub: 'rub',
    Rwf: 'rwf',
    Sar: 'sar',
    Sbd: 'sbd',
    Scr: 'scr',
    Sdg: 'sdg',
    Sek: 'sek',
    Sgd: 'sgd',
    Shp: 'shp',
    Sll: 'sll',
    Sos: 'sos',
    Srd: 'srd',
    Ssp: 'ssp',
    Stn: 'stn',
    Svc: 'svc',
    Syp: 'syp',
    Szl: 'szl',
    Thb: 'thb',
    Tjs: 'tjs',
    Tmt: 'tmt',
    Tnd: 'tnd',
    Top: 'top',
    Try: 'try',
    Ttd: 'ttd',
    Twd: 'twd',
    Tzs: 'tzs',
    Uah: 'uah',
    Ugx: 'ugx',
    Usd: 'usd',
    Uyu: 'uyu',
    Uzs: 'uzs',
    Ves: 'ves',
    Vnd: 'vnd',
    Vuv: 'vuv',
    Wst: 'wst',
    Xaf: 'xaf',
    Xcd: 'xcd',
    Xof: 'xof',
    Xpf: 'xpf',
    Yer: 'yer',
    Zar: 'zar',
    Zmw: 'zmw',
    Zwl: 'zwl'
} as const;

export type InventoryPriceRequestCurrencyEnum = typeof InventoryPriceRequestCurrencyEnum[keyof typeof InventoryPriceRequestCurrencyEnum];

/**
 * 
 * @export
 * @interface InventoryResponse
 */
export interface InventoryResponse {
    /**
     * 
     * @type {InventoryDto}
     * @memberof InventoryResponse
     */
    'inventory': InventoryDto;
}
/**
 * 
 * @export
 * @interface ItemsCreateRequest
 */
export interface ItemsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ItemsCreateRequest
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof ItemsCreateRequest
     */
    'externalProductId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemsCreateRequest
     */
    'externalSkuId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ItemsCreateRequest
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ItemsCreateRequest
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof ItemsCreateRequest
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemsCreateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemsCreateRequest
     */
    'type': ItemsCreateRequestTypeEnum;
}

export const ItemsCreateRequestTypeEnum = {
    Normal: 'normal',
    Foreign: 'foreign',
    Returned: 'returned'
} as const;

export type ItemsCreateRequestTypeEnum = typeof ItemsCreateRequestTypeEnum[keyof typeof ItemsCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface ItemsReturnRequest
 */
export interface ItemsReturnRequest {
    /**
     * 
     * @type {string}
     * @memberof ItemsReturnRequest
     */
    'externalId': string;
    /**
     * 
     * @type {number}
     * @memberof ItemsReturnRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface ListOfflineOrdersResponse
 */
export interface ListOfflineOrdersResponse {
    /**
     * Offline orders list
     * @type {Array<OrderDto>}
     * @memberof ListOfflineOrdersResponse
     */
    'offlineOrders': Array<OrderDto>;
    /**
     * Total count of offline orders
     * @type {number}
     * @memberof ListOfflineOrdersResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface LiveSellingCreateRequest
 */
export interface LiveSellingCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof LiveSellingCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LiveSellingCreateRequest
     */
    'videoUrl'?: string;
    /**
     * 
     * @type {DurationRequest}
     * @memberof LiveSellingCreateRequest
     */
    'duration': DurationRequest;
    /**
     * 
     * @type {DiscountRequest}
     * @memberof LiveSellingCreateRequest
     */
    'discount'?: DiscountRequest;
    /**
     * 
     * @type {Array<ProductRequest>}
     * @memberof LiveSellingCreateRequest
     */
    'products': Array<ProductRequest>;
    /**
     * 
     * @type {CommentRequest}
     * @memberof LiveSellingCreateRequest
     */
    'comment': CommentRequest;
    /**
     * 
     * @type {Array<ModeratorRequest>}
     * @memberof LiveSellingCreateRequest
     */
    'moderators': Array<ModeratorRequest>;
}
/**
 * 
 * @export
 * @interface LiveSellingResponse
 */
export interface LiveSellingResponse {
    /**
     * 
     * @type {object}
     * @memberof LiveSellingResponse
     */
    'liveSelling': object;
}
/**
 * 
 * @export
 * @interface LiveSellingUpdateRequest
 */
export interface LiveSellingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof LiveSellingUpdateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveSellingUpdateRequest
     */
    'videoUrl'?: string;
    /**
     * 
     * @type {DurationRequest}
     * @memberof LiveSellingUpdateRequest
     */
    'duration'?: DurationRequest;
    /**
     * 
     * @type {DiscountRequest}
     * @memberof LiveSellingUpdateRequest
     */
    'discount'?: DiscountRequest;
    /**
     * 
     * @type {Array<ProductRequest>}
     * @memberof LiveSellingUpdateRequest
     */
    'products'?: Array<ProductRequest>;
    /**
     * 
     * @type {CommentRequest}
     * @memberof LiveSellingUpdateRequest
     */
    'comment'?: CommentRequest;
    /**
     * 
     * @type {Array<ModeratorRequest>}
     * @memberof LiveSellingUpdateRequest
     */
    'moderators'?: Array<ModeratorRequest>;
}
/**
 * 
 * @export
 * @interface ModeratorRequest
 */
export interface ModeratorRequest {
    /**
     * 
     * @type {string}
     * @memberof ModeratorRequest
     */
    'avatar': string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OfflineOrderCreatRequest
 */
export interface OfflineOrderCreatRequest {
    /**
     * Phone number
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'type'?: OfflineOrderCreatRequestTypeEnum;
    /**
     * Identifier of the sales rep that created the purchase
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'createdBy': string;
    /**
     * Order total amount
     * @type {number}
     * @memberof OfflineOrderCreatRequest
     */
    'amount': number;
    /**
     * User CPF
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'cpf'?: string;
    /**
     * User name
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'name'?: string;
    /**
     * Identifier of the discount to be used in the order
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'discountId'?: string;
    /**
     * Purchase receipt
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'receipt'?: string;
    /**
     * Transaction identifier
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfflineOrderCreatRequest
     */
    'email'?: string;
    /**
     * 
     * @type {number}
     * @memberof OfflineOrderCreatRequest
     */
    'pinSize'?: number;
}

export const OfflineOrderCreatRequestTypeEnum = {
    Email: 'email',
    Phone: 'phone',
    UserId: 'userId'
} as const;

export type OfflineOrderCreatRequestTypeEnum = typeof OfflineOrderCreatRequestTypeEnum[keyof typeof OfflineOrderCreatRequestTypeEnum];

/**
 * 
 * @export
 * @interface OfflineOrderDeleteRequest
 */
export interface OfflineOrderDeleteRequest {
    /**
     * Identifier of the sales rep that returned the purchase
     * @type {string}
     * @memberof OfflineOrderDeleteRequest
     */
    'returnedBy': string;
}
/**
 * 
 * @export
 * @interface OfflineOrderResponse
 */
export interface OfflineOrderResponse {
    /**
     * Created offline order object
     * @type {OrderDto}
     * @memberof OfflineOrderResponse
     */
    'offlineOrder': OrderDto;
}
/**
 * 
 * @export
 * @interface OfflineOrderUpdateRequest
 */
export interface OfflineOrderUpdateRequest {
    /**
     * Purchase receipt
     * @type {string}
     * @memberof OfflineOrderUpdateRequest
     */
    'receipt'?: string;
    /**
     * Identifier of the generated discount
     * @type {string}
     * @memberof OfflineOrderUpdateRequest
     */
    'generatedDiscount'?: string;
    /**
     * Identifier of the used discount
     * @type {string}
     * @memberof OfflineOrderUpdateRequest
     */
    'usedDiscount'?: string;
    /**
     * Amount of discount applied to the order
     * @type {number}
     * @memberof OfflineOrderUpdateRequest
     */
    'discountAmount'?: number;
}
/**
 * 
 * @export
 * @interface OfflineOrderVerifyResponse
 */
export interface OfflineOrderVerifyResponse {
    /**
     * 
     * @type {UserDto}
     * @memberof OfflineOrderVerifyResponse
     */
    'user': UserDto;
}
/**
 * 
 * @export
 * @interface OnlineOrderDiscountDto
 */
export interface OnlineOrderDiscountDto {
    /**
     * 
     * @type {string}
     * @memberof OnlineOrderDiscountDto
     */
    'source': string;
    /**
     * 
     * @type {number}
     * @memberof OnlineOrderDiscountDto
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof OnlineOrderDiscountDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface OrderDiscountDto
 */
export interface OrderDiscountDto {
    /**
     * 
     * @type {number}
     * @memberof OrderDiscountDto
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscountDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface OrderDto
 */
export interface OrderDto {
    /**
     * 
     * @type {Array<OrderItemDto>}
     * @memberof OrderDto
     */
    'items': Array<OrderItemDto>;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'status': OrderDtoStatusEnum;
    /**
     * 
     * @type {OrderTotalsDto}
     * @memberof OrderDto
     */
    'totals': OrderTotalsDto;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'discount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'date': string;
    /**
     * 
     * @type {Array<GiftCardsDto>}
     * @memberof OrderDto
     */
    'giftCards': Array<GiftCardsDto>;
    /**
     * 
     * @type {Array<OrderDiscountDto>}
     * @memberof OrderDto
     */
    'discounts': Array<OrderDiscountDto>;
    /**
     * 
     * @type {Array<CouponsDto>}
     * @memberof OrderDto
     */
    'promotionCoupons': Array<CouponsDto>;
    /**
     * 
     * @type {object}
     * @memberof OrderDto
     */
    'metadata'?: object;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'completedAt': string | null;
    /**
     * 
     * @type {OnlineOrderDiscountDto}
     * @memberof OrderDto
     */
    'generatedDiscount'?: OnlineOrderDiscountDto;
    /**
     * 
     * @type {OrderSmsHistoryDto}
     * @memberof OrderDto
     */
    'smsHistory'?: OrderSmsHistoryDto;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'createdByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'returnedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'returnedByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'receipt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'userType'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'userSource'?: OrderDtoUserSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'originalUserSource'?: OrderDtoOriginalUserSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'orderSource': OrderDtoOrderSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDto
     */
    'skipCashbackCreation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDto
     */
    'cashbackDisabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'cartExternalId': string | null;
}

export const OrderDtoStatusEnum = {
    PendingCashback: 'pendingCashback',
    Completed: 'completed',
    Confirmed: 'confirmed',
    Received: 'received',
    Cancelled: 'cancelled',
    Returned: 'returned',
    Draft: 'draft'
} as const;

export type OrderDtoStatusEnum = typeof OrderDtoStatusEnum[keyof typeof OrderDtoStatusEnum];
export const OrderDtoUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type OrderDtoUserSourceEnum = typeof OrderDtoUserSourceEnum[keyof typeof OrderDtoUserSourceEnum];
export const OrderDtoOriginalUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type OrderDtoOriginalUserSourceEnum = typeof OrderDtoOriginalUserSourceEnum[keyof typeof OrderDtoOriginalUserSourceEnum];
export const OrderDtoOrderSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;

export type OrderDtoOrderSourceEnum = typeof OrderDtoOrderSourceEnum[keyof typeof OrderDtoOrderSourceEnum];

/**
 * 
 * @export
 * @interface OrderIdentificationRequest
 */
export interface OrderIdentificationRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderIdentificationRequest
     */
    'storeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderIdentificationRequest
     */
    'costumerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderIdentificationRequest
     */
    'identificationCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrderIdentificationRequest
     */
    'customerDocument'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderIdentificationRequest
     */
    'operatorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderIdentificationRequest
     */
    'operatorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderIdentificationRequest
     */
    'Phone'?: string | null;
}
/**
 * 
 * @export
 * @interface OrderItemDto
 */
export interface OrderItemDto {
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'product'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'order': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'externalProductId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'externalSkuId'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'type': OrderItemDtoTypeEnum;
}

export const OrderItemDtoTypeEnum = {
    Normal: 'normal',
    Foreign: 'foreign',
    Returned: 'returned'
} as const;

export type OrderItemDtoTypeEnum = typeof OrderItemDtoTypeEnum[keyof typeof OrderItemDtoTypeEnum];

/**
 * 
 * @export
 * @interface OrderItemsRequest
 */
export interface OrderItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof OrderItemsRequest
     */
    'itenID'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemsRequest
     */
    'netSaleValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemsRequest
     */
    'grossSaleValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemsRequest
     */
    'quantityItems'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemsRequest
     */
    'productCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemsRequest
     */
    'productDescription'?: string;
}
/**
 * 
 * @export
 * @interface OrderPopulatedItemResponse
 */
export interface OrderPopulatedItemResponse {
    /**
     * 
     * @type {OrderDto}
     * @memberof OrderPopulatedItemResponse
     */
    'order': OrderDto;
}
/**
 * 
 * @export
 * @interface OrderPopulatedUserDto
 */
export interface OrderPopulatedUserDto {
    /**
     * 
     * @type {UserDto}
     * @memberof OrderPopulatedUserDto
     */
    'user': UserDto | null;
    /**
     * 
     * @type {SalesRepDto}
     * @memberof OrderPopulatedUserDto
     */
    'salesRep'?: SalesRepDto;
    /**
     * 
     * @type {SalesRepGroupDto}
     * @memberof OrderPopulatedUserDto
     */
    'salesRepGroup'?: SalesRepGroupDto;
    /**
     * 
     * @type {DiscountDto}
     * @memberof OrderPopulatedUserDto
     */
    'generatedDiscount'?: DiscountDto;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'status': OrderPopulatedUserDtoStatusEnum;
    /**
     * 
     * @type {OrderTotalsDto}
     * @memberof OrderPopulatedUserDto
     */
    'totals': OrderTotalsDto;
    /**
     * 
     * @type {number}
     * @memberof OrderPopulatedUserDto
     */
    'discount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'date': string;
    /**
     * 
     * @type {Array<GiftCardsDto>}
     * @memberof OrderPopulatedUserDto
     */
    'giftCards': Array<GiftCardsDto>;
    /**
     * 
     * @type {Array<OrderDiscountDto>}
     * @memberof OrderPopulatedUserDto
     */
    'discounts': Array<OrderDiscountDto>;
    /**
     * 
     * @type {Array<CouponsDto>}
     * @memberof OrderPopulatedUserDto
     */
    'promotionCoupons': Array<CouponsDto>;
    /**
     * 
     * @type {object}
     * @memberof OrderPopulatedUserDto
     */
    'metadata'?: object;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'completedAt': string | null;
    /**
     * 
     * @type {OrderSmsHistoryDto}
     * @memberof OrderPopulatedUserDto
     */
    'smsHistory'?: OrderSmsHistoryDto;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'createdByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'returnedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'returnedByGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'receipt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'userType'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'userSource'?: OrderPopulatedUserDtoUserSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'originalUserSource'?: OrderPopulatedUserDtoOriginalUserSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'orderSource': OrderPopulatedUserDtoOrderSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrderPopulatedUserDto
     */
    'skipCashbackCreation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderPopulatedUserDto
     */
    'cashbackDisabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderPopulatedUserDto
     */
    'cartExternalId': string | null;
    /**
     * 
     * @type {Array<OrderItemDto>}
     * @memberof OrderPopulatedUserDto
     */
    'items': Array<OrderItemDto>;
}

export const OrderPopulatedUserDtoStatusEnum = {
    PendingCashback: 'pendingCashback',
    Completed: 'completed',
    Confirmed: 'confirmed',
    Received: 'received',
    Cancelled: 'cancelled',
    Returned: 'returned',
    Draft: 'draft'
} as const;

export type OrderPopulatedUserDtoStatusEnum = typeof OrderPopulatedUserDtoStatusEnum[keyof typeof OrderPopulatedUserDtoStatusEnum];
export const OrderPopulatedUserDtoUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type OrderPopulatedUserDtoUserSourceEnum = typeof OrderPopulatedUserDtoUserSourceEnum[keyof typeof OrderPopulatedUserDtoUserSourceEnum];
export const OrderPopulatedUserDtoOriginalUserSourceEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;

export type OrderPopulatedUserDtoOriginalUserSourceEnum = typeof OrderPopulatedUserDtoOriginalUserSourceEnum[keyof typeof OrderPopulatedUserDtoOriginalUserSourceEnum];
export const OrderPopulatedUserDtoOrderSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;

export type OrderPopulatedUserDtoOrderSourceEnum = typeof OrderPopulatedUserDtoOrderSourceEnum[keyof typeof OrderPopulatedUserDtoOrderSourceEnum];

/**
 * 
 * @export
 * @interface OrderResponse
 */
export interface OrderResponse {
    /**
     * 
     * @type {OrderDto}
     * @memberof OrderResponse
     */
    'order': OrderDto;
}
/**
 * 
 * @export
 * @interface OrderSmsHistoryDto
 */
export interface OrderSmsHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof OrderSmsHistoryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderSmsHistoryDto
     */
    'status': OrderSmsHistoryDtoStatusEnum;
}

export const OrderSmsHistoryDtoStatusEnum = {
    Pending: 'pending',
    Sent: 'sent',
    Delivered: 'delivered',
    Failed: 'failed'
} as const;

export type OrderSmsHistoryDtoStatusEnum = typeof OrderSmsHistoryDtoStatusEnum[keyof typeof OrderSmsHistoryDtoStatusEnum];

/**
 * 
 * @export
 * @interface OrderTotalsDto
 */
export interface OrderTotalsDto {
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'couponsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'discountCodesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'internalCouponsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'internalDiscountCodesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'totalPaid': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'shipping'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'tax'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'refundedAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotalsDto
     */
    'refundedTax'?: number;
}
/**
 * 
 * @export
 * @interface OrdersChartData
 */
export interface OrdersChartData {
    /**
     * 
     * @type {number}
     * @memberof OrdersChartData
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof OrdersChartData
     */
    'total': number;
    /**
     * 
     * @type {string}
     * @memberof OrdersChartData
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface OrdersChartsResponse
 */
export interface OrdersChartsResponse {
    /**
     * 
     * @type {Array<OrdersChartData>}
     * @memberof OrdersChartsResponse
     */
    'data': Array<OrdersChartData>;
    /**
     * 
     * @type {number}
     * @memberof OrdersChartsResponse
     */
    'totalRevenue': number;
}
/**
 * 
 * @export
 * @interface OrdersCreateRequest
 */
export interface OrdersCreateRequest {
    /**
     * autoEnroll will create the user if not exists
     * @type {boolean}
     * @memberof OrdersCreateRequest
     */
    'autoEnroll': boolean;
    /**
     * Order Identifier if exists
     * @type {string}
     * @memberof OrdersCreateRequest
     */
    'externalId': string;
    /**
     * Order creation date
     * @type {string}
     * @memberof OrdersCreateRequest
     */
    'date': string;
    /**
     * discount source online or offline
     * @type {string}
     * @memberof OrdersCreateRequest
     */
    'status': OrdersCreateRequestStatusEnum;
    /**
     * discount source online or offline
     * @type {string}
     * @memberof OrdersCreateRequest
     */
    'source': OrdersCreateRequestSourceEnum;
    /**
     * list of items
     * @type {Array<ItemsCreateRequest>}
     * @memberof OrdersCreateRequest
     */
    'items': Array<ItemsCreateRequest>;
    /**
     * Total discount Amount
     * @type {number}
     * @memberof OrdersCreateRequest
     */
    'discount': number;
    /**
     * Net shipping Amount
     * @type {number}
     * @memberof OrdersCreateRequest
     */
    'shipping': number;
    /**
     * Net tax Amount
     * @type {number}
     * @memberof OrdersCreateRequest
     */
    'tax': number;
    /**
     * completedAt is required when order is completed
     * @type {string}
     * @memberof OrdersCreateRequest
     */
    'completedAt'?: string;
    /**
     * Receipt Number
     * @type {string}
     * @memberof OrdersCreateRequest
     */
    'receipt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrdersCreateRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersCreateRequest
     */
    'createdBy'?: string;
}

export const OrdersCreateRequestStatusEnum = {
    PendingCashback: 'pendingCashback',
    Completed: 'completed',
    Confirmed: 'confirmed',
    Received: 'received',
    Cancelled: 'cancelled',
    Returned: 'returned',
    Draft: 'draft'
} as const;

export type OrdersCreateRequestStatusEnum = typeof OrdersCreateRequestStatusEnum[keyof typeof OrdersCreateRequestStatusEnum];
export const OrdersCreateRequestSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;

export type OrdersCreateRequestSourceEnum = typeof OrdersCreateRequestSourceEnum[keyof typeof OrdersCreateRequestSourceEnum];

/**
 * 
 * @export
 * @interface OrdersExportRequest
 */
export interface OrdersExportRequest {
    /**
     * 
     * @type {string}
     * @memberof OrdersExportRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface OrdersOverviewResponse
 */
export interface OrdersOverviewResponse {
    /**
     * 
     * @type {Array<OrdersChartData>}
     * @memberof OrdersOverviewResponse
     */
    'membersData': Array<OrdersChartData>;
    /**
     * 
     * @type {number}
     * @memberof OrdersOverviewResponse
     */
    'membersTotal': number;
    /**
     * 
     * @type {Array<OrdersChartData>}
     * @memberof OrdersOverviewResponse
     */
    'nonMembersData': Array<OrdersChartData>;
    /**
     * 
     * @type {number}
     * @memberof OrdersOverviewResponse
     */
    'nonMembersTotal': number;
    /**
     * 
     * @type {number}
     * @memberof OrdersOverviewResponse
     */
    'total': number;
    /**
     * 
     * @type {Array<OrdersChartData>}
     * @memberof OrdersOverviewResponse
     */
    'totalData': Array<OrdersChartData>;
}
/**
 * 
 * @export
 * @interface OrdersPopulatedUsersResponse
 */
export interface OrdersPopulatedUsersResponse {
    /**
     * 
     * @type {Array<OrderPopulatedUserDto>}
     * @memberof OrdersPopulatedUsersResponse
     */
    'orders': Array<OrderPopulatedUserDto>;
    /**
     * 
     * @type {number}
     * @memberof OrdersPopulatedUsersResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface OrdersResponse
 */
export interface OrdersResponse {
    /**
     * 
     * @type {Array<OrderDto>}
     * @memberof OrdersResponse
     */
    'orders': Array<OrderDto>;
    /**
     * 
     * @type {number}
     * @memberof OrdersResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface OrdersReturnRequest
 */
export interface OrdersReturnRequest {
    /**
     * list of return items
     * @type {Array<ItemsReturnRequest>}
     * @memberof OrdersReturnRequest
     */
    'items': Array<ItemsReturnRequest>;
    /**
     * Refund Amount for listed items
     * @type {number}
     * @memberof OrdersReturnRequest
     */
    'refundedAmount': number;
    /**
     * Refund tax Amount for listed items
     * @type {number}
     * @memberof OrdersReturnRequest
     */
    'refundedTax': number;
    /**
     * 
     * @type {string}
     * @memberof OrdersReturnRequest
     */
    'externalId': string;
}
/**
 * 
 * @export
 * @interface OrdersStatisticsResponse
 */
export interface OrdersStatisticsResponse {
    /**
     * 
     * @type {number}
     * @memberof OrdersStatisticsResponse
     */
    'aov': number;
    /**
     * 
     * @type {number}
     * @memberof OrdersStatisticsResponse
     */
    'purchaseFrequency': number;
}
/**
 * 
 * @export
 * @interface OtpResendRequest
 */
export interface OtpResendRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpResendRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OtpResendRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface OtpResponse
 */
export interface OtpResponse {
    /**
     * 
     * @type {string}
     * @memberof OtpResponse
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface PartnerCredentialsRequest
 */
export interface PartnerCredentialsRequest {
    /**
     * 
     * @type {string}
     * @memberof PartnerCredentialsRequest
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCredentialsRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCredentialsRequest
     */
    'authorizationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCredentialsRequest
     */
    'identificationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerCredentialsRequest
     */
    'partnerCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCredentialsRequest
     */
    'providerUrl'?: string;
}
/**
 * 
 * @export
 * @interface PartnerRequest
 */
export interface PartnerRequest {
    /**
     * 
     * @type {string}
     * @memberof PartnerRequest
     */
    'partnerName': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerRequest
     */
    'partnerCode': string;
}
/**
 * 
 * @export
 * @interface PartnerResponse
 */
export interface PartnerResponse {
    /**
     * 
     * @type {string}
     * @memberof PartnerResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerResponse
     */
    'partnerName': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerResponse
     */
    'partnerCode': string;
}
/**
 * 
 * @export
 * @interface PaymentMethodRequest
 */
export interface PaymentMethodRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodRequest
     */
    'netSaleValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodRequest
     */
    'paymentMethodId'?: number;
}
/**
 * 
 * @export
 * @interface PointsModelCreateRequest
 */
export interface PointsModelCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof PointsModelCreateRequest
     */
    'gems': number;
    /**
     * 
     * @type {number}
     * @memberof PointsModelCreateRequest
     */
    'exp': number;
}
/**
 * 
 * @export
 * @interface PointsModelDto
 */
export interface PointsModelDto {
    /**
     * 
     * @type {number}
     * @memberof PointsModelDto
     */
    'gems': number;
    /**
     * 
     * @type {number}
     * @memberof PointsModelDto
     */
    'exp': number;
}
/**
 * 
 * @export
 * @interface PopularCategoriesResponse
 */
export interface PopularCategoriesResponse {
    /**
     * 
     * @type {Array<ProductCategoryDto>}
     * @memberof PopularCategoriesResponse
     */
    'categories': Array<ProductCategoryDto>;
}
/**
 * 
 * @export
 * @interface PopularProductsResponse
 */
export interface PopularProductsResponse {
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof PopularProductsResponse
     */
    'products': Array<ProductDto>;
}
/**
 * 
 * @export
 * @interface PopulatedCampaignUserDto
 */
export interface PopulatedCampaignUserDto {
    /**
     * 
     * @type {string}
     * @memberof PopulatedCampaignUserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedCampaignUserDto
     */
    'app': string;
    /**
     * 
     * @type {CampaignConfigDto}
     * @memberof PopulatedCampaignUserDto
     */
    'campaign': CampaignConfigDto;
    /**
     * 
     * @type {string}
     * @memberof PopulatedCampaignUserDto
     */
    'user': string;
    /**
     * 
     * @type {CampiagnDiscountDto}
     * @memberof PopulatedCampaignUserDto
     */
    'discount'?: CampiagnDiscountDto;
    /**
     * 
     * @type {string}
     * @memberof PopulatedCampaignUserDto
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedCampaignUserDto
     */
    'status': PopulatedCampaignUserDtoStatusEnum;
}

export const PopulatedCampaignUserDtoStatusEnum = {
    Valid: 'valid',
    Expired: 'expired',
    Completed: 'completed',
    Pending: 'pending',
    Notified: 'notified',
    Deleted: 'deleted'
} as const;

export type PopulatedCampaignUserDtoStatusEnum = typeof PopulatedCampaignUserDtoStatusEnum[keyof typeof PopulatedCampaignUserDtoStatusEnum];

/**
 * 
 * @export
 * @interface PopulatedCampaignUserRefereeDto
 */
export interface PopulatedCampaignUserRefereeDto {
    /**
     * 
     * @type {string}
     * @memberof PopulatedCampaignUserRefereeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedCampaignUserRefereeDto
     */
    'app': string;
    /**
     * 
     * @type {CampaignConfigDto}
     * @memberof PopulatedCampaignUserRefereeDto
     */
    'campaign': CampaignConfigDto;
    /**
     * 
     * @type {boolean}
     * @memberof PopulatedCampaignUserRefereeDto
     */
    'converted': boolean;
    /**
     * 
     * @type {string}
     * @memberof PopulatedCampaignUserRefereeDto
     */
    'refereeUser': string;
    /**
     * 
     * @type {CampiagnDiscountDto}
     * @memberof PopulatedCampaignUserRefereeDto
     */
    'refereeDiscount'?: CampiagnDiscountDto;
}
/**
 * 
 * @export
 * @interface PopulatedOfflineOrderResponse
 */
export interface PopulatedOfflineOrderResponse {
    /**
     * Order populated with user and discount
     * @type {Array<PopulatedOrderDto>}
     * @memberof PopulatedOfflineOrderResponse
     */
    'populatedOrders': Array<PopulatedOrderDto>;
    /**
     * Total count of purchases after filtering
     * @type {number}
     * @memberof PopulatedOfflineOrderResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PopulatedOrderDto
 */
export interface PopulatedOrderDto {
    /**
     * 
     * @type {OrderDto}
     * @memberof PopulatedOrderDto
     */
    'order': OrderDto;
    /**
     * 
     * @type {UserDto}
     * @memberof PopulatedOrderDto
     */
    'user': UserDto;
    /**
     * 
     * @type {DiscountDto}
     * @memberof PopulatedOrderDto
     */
    'discount'?: DiscountDto;
}
/**
 * 
 * @export
 * @interface ProductCategoryDto
 */
export interface ProductCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryDto
     */
    'category': string;
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryDto
     */
    'totalPurchases': number;
}
/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'externalId': string;
    /**
     * 
     * @type {object}
     * @memberof ProductDto
     */
    'name': object;
    /**
     * 
     * @type {object}
     * @memberof ProductDto
     */
    'description': object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductDto
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'url': string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    'quantity': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductDto
     */
    'categories': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductDto
     */
    'globalCategories'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    'views': number;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    'purchases': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductDto
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'brand': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'globalBrand': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'globalProduct': string;
}
/**
 * 
 * @export
 * @interface ProductRequest
 */
export interface ProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductRequest
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof ProductRequest
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface ProductResponse
 */
export interface ProductResponse {
    /**
     * 
     * @type {ProductDto}
     * @memberof ProductResponse
     */
    'product': ProductDto;
}
/**
 * 
 * @export
 * @interface ProductSearchResponse
 */
export interface ProductSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductSearchResponse
     */
    'count': number;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof ProductSearchResponse
     */
    'products': Array<ProductDto>;
}
/**
 * 
 * @export
 * @interface ProductsResponse
 */
export interface ProductsResponse {
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof ProductsResponse
     */
    'products': Array<ProductDto>;
    /**
     * 
     * @type {number}
     * @memberof ProductsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PromotionCashbackDto
 */
export interface PromotionCashbackDto {
    /**
     * 
     * @type {string}
     * @memberof PromotionCashbackDto
     */
    'promotionId': string;
    /**
     * 
     * @type {string}
     * @memberof PromotionCashbackDto
     */
    'type': PromotionCashbackDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PromotionCashbackDto
     */
    'rewardType': PromotionCashbackDtoRewardTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PromotionCashbackDto
     */
    'value': number;
}

export const PromotionCashbackDtoTypeEnum = {
    Orders: 'orders',
    WelcomeGift: 'welcomeGift',
    Campaign: 'campaign'
} as const;

export type PromotionCashbackDtoTypeEnum = typeof PromotionCashbackDtoTypeEnum[keyof typeof PromotionCashbackDtoTypeEnum];
export const PromotionCashbackDtoRewardTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type PromotionCashbackDtoRewardTypeEnum = typeof PromotionCashbackDtoRewardTypeEnum[keyof typeof PromotionCashbackDtoRewardTypeEnum];

/**
 * 
 * @export
 * @interface PurchaseValuesModelCreateRequest
 */
export interface PurchaseValuesModelCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof PurchaseValuesModelCreateRequest
     */
    'tier': number;
    /**
     * 
     * @type {PointsModelCreateRequest}
     * @memberof PurchaseValuesModelCreateRequest
     */
    'points': PointsModelCreateRequest;
    /**
     * 
     * @type {number}
     * @memberof PurchaseValuesModelCreateRequest
     */
    'cash': number;
}
/**
 * 
 * @export
 * @interface PurchaseValuesModelDto
 */
export interface PurchaseValuesModelDto {
    /**
     * 
     * @type {number}
     * @memberof PurchaseValuesModelDto
     */
    'tier': number;
    /**
     * 
     * @type {PointsModelDto}
     * @memberof PurchaseValuesModelDto
     */
    'points': PointsModelDto;
    /**
     * 
     * @type {number}
     * @memberof PurchaseValuesModelDto
     */
    'cash': number;
}
/**
 * 
 * @export
 * @interface RedeemApiDetailCreateRequest
 */
export interface RedeemApiDetailCreateRequest {
    /**
     * The url to the api / request endpoint
     * @type {string}
     * @memberof RedeemApiDetailCreateRequest
     */
    'url': string;
    /**
     * Api HTTP method, post, get etc...
     * @type {string}
     * @memberof RedeemApiDetailCreateRequest
     */
    'method': RedeemApiDetailCreateRequestMethodEnum;
    /**
     * Signature used to create the secret
     * @type {string}
     * @memberof RedeemApiDetailCreateRequest
     */
    'signautre': string;
}

export const RedeemApiDetailCreateRequestMethodEnum = {
    Post: 'post',
    Get: 'get',
    Put: 'put',
    Delete: 'delete'
} as const;

export type RedeemApiDetailCreateRequestMethodEnum = typeof RedeemApiDetailCreateRequestMethodEnum[keyof typeof RedeemApiDetailCreateRequestMethodEnum];

/**
 * 
 * @export
 * @interface ReferenceDto
 */
export interface ReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ReferenceDto
     */
    'referenceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDto
     */
    'wheelOptionId'?: string;
}
/**
 * 
 * @export
 * @interface RewardConfigDto
 */
export interface RewardConfigDto {
    /**
     * 
     * @type {string}
     * @memberof RewardConfigDto
     */
    'type'?: RewardConfigDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigDto
     */
    'validFor'?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigDto
     */
    'minPurchaseAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigDto
     */
    'multiplier'?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigDto
     */
    'boostedDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigDto
     */
    'source'?: string;
    /**
     * 
     * @type {SkuDto}
     * @memberof RewardConfigDto
     */
    'skuGift'?: SkuDto;
    /**
     * 
     * @type {BogoDto}
     * @memberof RewardConfigDto
     */
    'bogo'?: BogoDto;
}

export const RewardConfigDtoTypeEnum = {
    Percentage: 'percentage',
    Monetary: 'monetary',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO',
    Mix: 'mix'
} as const;

export type RewardConfigDtoTypeEnum = typeof RewardConfigDtoTypeEnum[keyof typeof RewardConfigDtoTypeEnum];

/**
 * 
 * @export
 * @interface RewardConfigRequest
 */
export interface RewardConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof RewardConfigRequest
     */
    'type': RewardConfigRequestTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigRequest
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigRequest
     */
    'validFor'?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigRequest
     */
    'minPurchaseAmount'?: number;
    /**
     * 
     * @type {SkuRequest}
     * @memberof RewardConfigRequest
     */
    'skuGift'?: SkuRequest;
    /**
     * 
     * @type {BogoRequest}
     * @memberof RewardConfigRequest
     */
    'bogo'?: BogoRequest;
}

export const RewardConfigRequestTypeEnum = {
    Percentage: 'percentage',
    Monetary: 'monetary',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO',
    Mix: 'mix'
} as const;

export type RewardConfigRequestTypeEnum = typeof RewardConfigRequestTypeEnum[keyof typeof RewardConfigRequestTypeEnum];

/**
 * 
 * @export
 * @interface SaleRequest
 */
export interface SaleRequest {
    /**
     * 
     * @type {string}
     * @memberof SaleRequest
     */
    'salesChannel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequest
     */
    'netSaleValue': number;
    /**
     * 
     * @type {string}
     * @memberof SaleRequest
     */
    'posCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleRequest
     */
    'sellerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleRequest
     */
    'externalSaleId'?: string;
    /**
     * 
     * @type {Array<OrderItemsRequest>}
     * @memberof SaleRequest
     */
    'items'?: Array<OrderItemsRequest>;
    /**
     * 
     * @type {string}
     * @memberof SaleRequest
     */
    'custumerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleRequest
     */
    'fiscalId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SaleRequest
     */
    'totalQuantityItems'?: number;
    /**
     * 
     * @type {PaymentMethodRequest}
     * @memberof SaleRequest
     */
    'paymentMethods'?: PaymentMethodRequest;
}
/**
 * 
 * @export
 * @interface SalesRepAddRequest
 */
export interface SalesRepAddRequest {
    /**
     * 
     * @type {string}
     * @memberof SalesRepAddRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepAddRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepAddRequest
     */
    'admin': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepAddRequest
     */
    'group': string;
}
/**
 * 
 * @export
 * @interface SalesRepCreateRequest
 */
export interface SalesRepCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SalesRepCreateRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepCreateRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepCreateRequest
     */
    'admin': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepCreateRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepCreateRequest
     */
    'language'?: SalesRepCreateRequestLanguageEnum;
}

export const SalesRepCreateRequestLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type SalesRepCreateRequestLanguageEnum = typeof SalesRepCreateRequestLanguageEnum[keyof typeof SalesRepCreateRequestLanguageEnum];

/**
 * 
 * @export
 * @interface SalesRepDto
 */
export interface SalesRepDto {
    /**
     * 
     * @type {string}
     * @memberof SalesRepDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {SalesRepTotalsDto}
     * @memberof SalesRepDto
     */
    'totals': SalesRepTotalsDto;
    /**
     * 
     * @type {string}
     * @memberof SalesRepDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepDto
     */
    'admin': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepDto
     */
    'group'?: string;
}
/**
 * 
 * @export
 * @interface SalesRepGroupCreateRequest
 */
export interface SalesRepGroupCreateRequest {
    /**
     * The password of the sales group admin
     * @type {string}
     * @memberof SalesRepGroupCreateRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepGroupCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepGroupCreateRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepGroupCreateRequest
     */
    'language'?: SalesRepGroupCreateRequestLanguageEnum;
}

export const SalesRepGroupCreateRequestLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type SalesRepGroupCreateRequestLanguageEnum = typeof SalesRepGroupCreateRequestLanguageEnum[keyof typeof SalesRepGroupCreateRequestLanguageEnum];

/**
 * 
 * @export
 * @interface SalesRepGroupDto
 */
export interface SalesRepGroupDto {
    /**
     * 
     * @type {string}
     * @memberof SalesRepGroupDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepGroupDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepGroupDto
     */
    'admin': string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepGroupDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SalesRepGroupResponse
 */
export interface SalesRepGroupResponse {
    /**
     * 
     * @type {SalesRepGroupDto}
     * @memberof SalesRepGroupResponse
     */
    'salesRepGroup': SalesRepGroupDto;
}
/**
 * 
 * @export
 * @interface SalesRepGroupUpdateRequest
 */
export interface SalesRepGroupUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SalesRepGroupUpdateRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface SalesRepGroupsResponse
 */
export interface SalesRepGroupsResponse {
    /**
     * 
     * @type {Array<SalesRepGroupDto>}
     * @memberof SalesRepGroupsResponse
     */
    'salesRepGroups': Array<SalesRepGroupDto>;
    /**
     * 
     * @type {number}
     * @memberof SalesRepGroupsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface SalesRepListResponse
 */
export interface SalesRepListResponse {
    /**
     * 
     * @type {Array<SalesRepDto>}
     * @memberof SalesRepListResponse
     */
    'salesReps': Array<SalesRepDto>;
    /**
     * 
     * @type {number}
     * @memberof SalesRepListResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface SalesRepResponse
 */
export interface SalesRepResponse {
    /**
     * 
     * @type {SalesRepDto}
     * @memberof SalesRepResponse
     */
    'salesRep': SalesRepDto;
}
/**
 * 
 * @export
 * @interface SalesRepTotalsDto
 */
export interface SalesRepTotalsDto {
    /**
     * 
     * @type {number}
     * @memberof SalesRepTotalsDto
     */
    'customersRegistered': number;
    /**
     * 
     * @type {number}
     * @memberof SalesRepTotalsDto
     */
    'discountsRedeemed': number;
}
/**
 * 
 * @export
 * @interface SalesRepUpdateRequest
 */
export interface SalesRepUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SalesRepUpdateRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesRepUpdateRequest
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface SalesRepsResponse
 */
export interface SalesRepsResponse {
    /**
     * 
     * @type {Array<SalesRepDto>}
     * @memberof SalesRepsResponse
     */
    'salesReps': Array<SalesRepDto>;
}
/**
 * 
 * @export
 * @interface SalesRequest
 */
export interface SalesRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesRequest
     */
    'netSaleValue': number;
}
/**
 * 
 * @export
 * @interface SalesResponse
 */
export interface SalesResponse {
    /**
     * 
     * @type {Array<object>}
     * @memberof SalesResponse
     */
    'sales': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof SalesResponse
     */
    'totalSales': number;
}
/**
 * 
 * @export
 * @interface SalesStatisticsResponse
 */
export interface SalesStatisticsResponse {
    /**
     * 
     * @type {OrdersStatisticsResponse}
     * @memberof SalesStatisticsResponse
     */
    'totalUsers': OrdersStatisticsResponse;
    /**
     * 
     * @type {OrdersStatisticsResponse}
     * @memberof SalesStatisticsResponse
     */
    'members': OrdersStatisticsResponse;
    /**
     * 
     * @type {OrdersStatisticsResponse}
     * @memberof SalesStatisticsResponse
     */
    'nonMembers': OrdersStatisticsResponse;
    /**
     * 
     * @type {OrdersStatisticsResponse}
     * @memberof SalesStatisticsResponse
     */
    'membersWithCoretava': OrdersStatisticsResponse;
}
/**
 * 
 * @export
 * @interface ScheduleDto
 */
export interface ScheduleDto {
    /**
     * 
     * @type {{ [key: string]: ScheduleDtoTimesPerWeekdaysValue; }}
     * @memberof ScheduleDto
     */
    'timesPerWeekdays': { [key: string]: ScheduleDtoTimesPerWeekdaysValue; };
    /**
     * 
     * @type {number}
     * @memberof ScheduleDto
     */
    'timezoneOffset': number;
}
/**
 * @type ScheduleDtoTimesPerWeekdaysValue
 * @export
 */
export type ScheduleDtoTimesPerWeekdaysValue = Array<TimeSlotDto>;

/**
 * 
 * @export
 * @interface ScheduleRequest
 */
export interface ScheduleRequest {
    /**
     * 
     * @type {{ [key: string]: ScheduleRequestTimesPerWeekdaysValue; }}
     * @memberof ScheduleRequest
     */
    'timesPerWeekdays': { [key: string]: ScheduleRequestTimesPerWeekdaysValue; };
    /**
     * 
     * @type {number}
     * @memberof ScheduleRequest
     */
    'timezoneOffset': number;
}
/**
 * @type ScheduleRequestTimesPerWeekdaysValue
 * @export
 */
export type ScheduleRequestTimesPerWeekdaysValue = Array<TimeSlotRequest>;

/**
 * 
 * @export
 * @interface SimpleDateDto
 */
export interface SimpleDateDto {
    /**
     * Year
     * @type {number}
     * @memberof SimpleDateDto
     */
    'year': number;
    /**
     * Month
     * @type {number}
     * @memberof SimpleDateDto
     */
    'month': number;
    /**
     * Day
     * @type {number}
     * @memberof SimpleDateDto
     */
    'day': number;
}
/**
 * 
 * @export
 * @interface SkuDto
 */
export interface SkuDto {
    /**
     * 
     * @type {string}
     * @memberof SkuDto
     */
    'skuId': string;
    /**
     * 
     * @type {string}
     * @memberof SkuDto
     */
    'productId'?: string;
}
/**
 * 
 * @export
 * @interface SkuRequest
 */
export interface SkuRequest {
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    'skuId': string;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof SkuRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TargetMembersDto
 */
export interface TargetMembersDto {
    /**
     * 
     * @type {string}
     * @memberof TargetMembersDto
     */
    'type'?: TargetMembersDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TargetMembersDto
     */
    'segmentId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TargetMembersDto
     */
    'timeOnDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof TargetMembersDto
     */
    'minValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof TargetMembersDto
     */
    'maxValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof TargetMembersDto
     */
    'timePeriod'?: TargetMembersDtoTimePeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof TargetMembersDto
     */
    'url'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TargetMembersDto
     */
    'retailerApps'?: Array<string>;
}

export const TargetMembersDtoTypeEnum = {
    PurchasedWith: 'purchasedWith',
    NewCustomer: 'newCustomer',
    AbandonedCart: 'abandonedCart',
    All: 'all',
    UploadCsv: 'uploadCsv',
    Audience: 'audience'
} as const;

export type TargetMembersDtoTypeEnum = typeof TargetMembersDtoTypeEnum[keyof typeof TargetMembersDtoTypeEnum];
export const TargetMembersDtoTimePeriodEnum = {
    OneYear: 'oneYear',
    OneWeek: 'oneWeek',
    OneMonth: 'oneMonth',
    ThreeMonth: 'threeMonth',
    SixMonth: 'sixMonth'
} as const;

export type TargetMembersDtoTimePeriodEnum = typeof TargetMembersDtoTimePeriodEnum[keyof typeof TargetMembersDtoTimePeriodEnum];

/**
 * 
 * @export
 * @interface TargetMembersRequest
 */
export interface TargetMembersRequest {
    /**
     * 
     * @type {string}
     * @memberof TargetMembersRequest
     */
    'type'?: TargetMembersRequestTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TargetMembersRequest
     */
    'timeOnDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof TargetMembersRequest
     */
    'minValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof TargetMembersRequest
     */
    'maxValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof TargetMembersRequest
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof TargetMembersRequest
     */
    'segmentId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TargetMembersRequest
     */
    'retailerApps'?: Array<string>;
}

export const TargetMembersRequestTypeEnum = {
    PurchasedWith: 'purchasedWith',
    NewCustomer: 'newCustomer',
    AbandonedCart: 'abandonedCart',
    All: 'all',
    UploadCsv: 'uploadCsv',
    Audience: 'audience'
} as const;

export type TargetMembersRequestTypeEnum = typeof TargetMembersRequestTypeEnum[keyof typeof TargetMembersRequestTypeEnum];

/**
 * 
 * @export
 * @interface TimeSlotDto
 */
export interface TimeSlotDto {
    /**
     * 
     * @type {number}
     * @memberof TimeSlotDto
     */
    'startTime': number;
    /**
     * 
     * @type {number}
     * @memberof TimeSlotDto
     */
    'endTime': number;
}
/**
 * 
 * @export
 * @interface TimeSlotRequest
 */
export interface TimeSlotRequest {
    /**
     * The minutes from utc start of time
     * @type {number}
     * @memberof TimeSlotRequest
     */
    'startTime': number;
    /**
     * The minutes from utc end of time
     * @type {number}
     * @memberof TimeSlotRequest
     */
    'endTime': number;
}
/**
 * 
 * @export
 * @interface TotalsDto
 */
export interface TotalsDto {
    /**
     * Total number of completed missions
     * @type {number}
     * @memberof TotalsDto
     */
    'numberOfCompletedMissions': number;
    /**
     * Total number of active points
     * @type {number}
     * @memberof TotalsDto
     */
    'totalActivePoints': number;
    /**
     * Total number of cashback balance
     * @type {number}
     * @memberof TotalsDto
     */
    'totalCashbackBalance': number;
    /**
     * Total number of recent cashback earned
     * @type {number}
     * @memberof TotalsDto
     */
    'recentCashbackEarned': number;
    /**
     * Total number of redeemed points
     * @type {number}
     * @memberof TotalsDto
     */
    'totalRedeemedPoints': number;
    /**
     * Total number of generated points
     * @type {number}
     * @memberof TotalsDto
     */
    'totalGeneratedPoints': number;
    /**
     * Total number of campaign disocunts
     * @type {number}
     * @memberof TotalsDto
     */
    'numberOfCreatedCampaignDiscounts': number;
    /**
     * Total number of used campaign discounts
     * @type {number}
     * @memberof TotalsDto
     */
    'numberOfUsedCampaignDiscounts': number;
    /**
     * Total number of orders
     * @type {number}
     * @memberof TotalsDto
     */
    'ordersCount': number;
    /**
     * Total sum of orders values
     * @type {number}
     * @memberof TotalsDto
     */
    'ordersTotal': number;
    /**
     * Total number of online orders
     * @type {number}
     * @memberof TotalsDto
     */
    'onlineOrdersCount': number;
    /**
     * Total sum of online orders values
     * @type {number}
     * @memberof TotalsDto
     */
    'onlineOrdersTotal': number;
    /**
     * Total number of offline orders
     * @type {number}
     * @memberof TotalsDto
     */
    'offlineOrdersCount': number;
    /**
     * Total sum of offline orders values
     * @type {number}
     * @memberof TotalsDto
     */
    'offlineOrdersTotal': number;
}
/**
 * 
 * @export
 * @interface TotvsCampaignRequest
 */
export interface TotvsCampaignRequest {
    /**
     * 
     * @type {string}
     * @memberof TotvsCampaignRequest
     */
    'externalBusinessUnitId': string;
    /**
     * 
     * @type {CampaignSaleRequest}
     * @memberof TotvsCampaignRequest
     */
    'sale': CampaignSaleRequest;
    /**
     * 
     * @type {CampaignIdentificationRequest}
     * @memberof TotvsCampaignRequest
     */
    'identification': CampaignIdentificationRequest;
    /**
     * 
     * @type {PartnerCredentialsRequest}
     * @memberof TotvsCampaignRequest
     */
    'partnerCredentials': PartnerCredentialsRequest;
}
/**
 * 
 * @export
 * @interface TotvsCampaignResponse
 */
export interface TotvsCampaignResponse {
    /**
     * 
     * @type {string}
     * @memberof TotvsCampaignResponse
     */
    'nextStep': string;
    /**
     * 
     * @type {string}
     * @memberof TotvsCampaignResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof TotvsCampaignResponse
     */
    'operatorText': string;
    /**
     * 
     * @type {string}
     * @memberof TotvsCampaignResponse
     */
    'customerText': string;
    /**
     * 
     * @type {Array<CampaignsResponse>}
     * @memberof TotvsCampaignResponse
     */
    'campaigns': Array<CampaignsResponse>;
    /**
     * 
     * @type {Array<object>}
     * @memberof TotvsCampaignResponse
     */
    'bonus': Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof TotvsCampaignResponse
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface TotvsOrderRequest
 */
export interface TotvsOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof TotvsOrderRequest
     */
    'externalBusinessUnitId': string;
    /**
     * 
     * @type {SaleRequest}
     * @memberof TotvsOrderRequest
     */
    'sale': SaleRequest;
    /**
     * 
     * @type {OrderIdentificationRequest}
     * @memberof TotvsOrderRequest
     */
    'identification': OrderIdentificationRequest;
    /**
     * 
     * @type {PartnerCredentialsRequest}
     * @memberof TotvsOrderRequest
     */
    'partnerCredentials': PartnerCredentialsRequest;
}
/**
 * 
 * @export
 * @interface TotvsOrderResponse
 */
export interface TotvsOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof TotvsOrderResponse
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof TotvsOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof TotvsOrderResponse
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface TrackingDetailsDto
 */
export interface TrackingDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof TrackingDetailsDto
     */
    'approvedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingDetailsDto
     */
    'rejectedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingDetailsDto
     */
    'approvedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingDetailsDto
     */
    'rejectedBy'?: string;
}
/**
 * 
 * @export
 * @interface UpdateRequest
 */
export interface UpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRequest
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRequest
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRequest
     */
    'value'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdateRequest
     */
    'metadata'?: object;
}
/**
 * 
 * @export
 * @interface UpdateWelcomeGiftRequest
 */
export interface UpdateWelcomeGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateWelcomeGiftRequest
     */
    'type'?: UpdateWelcomeGiftRequestTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateWelcomeGiftRequest
     */
    'monetary'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWelcomeGiftRequest
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWelcomeGiftRequest
     */
    'minPurchaseAmount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWelcomeGiftRequest
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateWelcomeGiftRequest
     */
    'expiresInDays'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWelcomeGiftRequest
     */
    'phoneVerificationEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateWelcomeGiftRequest
     */
    'remindsBeforeDays'?: number | null;
}

export const UpdateWelcomeGiftRequestTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type UpdateWelcomeGiftRequestTypeEnum = typeof UpdateWelcomeGiftRequestTypeEnum[keyof typeof UpdateWelcomeGiftRequestTypeEnum];

/**
 * 
 * @export
 * @interface UserAuthenticateResponse
 */
export interface UserAuthenticateResponse {
    /**
     * 
     * @type {string}
     * @memberof UserAuthenticateResponse
     */
    'nextStep': string;
    /**
     * 
     * @type {string}
     * @memberof UserAuthenticateResponse
     */
    'partnerCode': string;
    /**
     * 
     * @type {AuthenticateResposne}
     * @memberof UserAuthenticateResponse
     */
    'authentication': AuthenticateResposne;
    /**
     * 
     * @type {string}
     * @memberof UserAuthenticateResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAuthenticateResponse
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface UserAuthenticationRequest
 */
export interface UserAuthenticationRequest {
    /**
     * 
     * @type {string}
     * @memberof UserAuthenticationRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof UserAuthenticationRequest
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface UserDataCollectionDto
 */
export interface UserDataCollectionDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDataCollectionDto
     */
    'requiredFields': Array<UserDataCollectionDtoRequiredFieldsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDataCollectionDto
     */
    'optionalFields': Array<UserDataCollectionDtoOptionalFieldsEnum>;
}

export const UserDataCollectionDtoRequiredFieldsEnum = {
    Name: 'name',
    Cpf: 'cpf',
    Email: 'email',
    Birthday: 'birthday'
} as const;

export type UserDataCollectionDtoRequiredFieldsEnum = typeof UserDataCollectionDtoRequiredFieldsEnum[keyof typeof UserDataCollectionDtoRequiredFieldsEnum];
export const UserDataCollectionDtoOptionalFieldsEnum = {
    Name: 'name',
    Cpf: 'cpf',
    Email: 'email',
    Birthday: 'birthday'
} as const;

export type UserDataCollectionDtoOptionalFieldsEnum = typeof UserDataCollectionDtoOptionalFieldsEnum[keyof typeof UserDataCollectionDtoOptionalFieldsEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const UserDataCollectionOptionalFields = {
    Name: 'name',
    Cpf: 'cpf',
    Email: 'email',
    Birthday: 'birthday'
} as const;

export type UserDataCollectionOptionalFields = typeof UserDataCollectionOptionalFields[keyof typeof UserDataCollectionOptionalFields];


/**
 * 
 * @export
 * @interface UserDataCollectionRequest
 */
export interface UserDataCollectionRequest {
    /**
     * 
     * @type {Array<UserDataCollectionRequiredFields>}
     * @memberof UserDataCollectionRequest
     */
    'requiredFields': Array<UserDataCollectionRequiredFields>;
    /**
     * 
     * @type {Array<UserDataCollectionOptionalFields>}
     * @memberof UserDataCollectionRequest
     */
    'optionalFields': Array<UserDataCollectionOptionalFields>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserDataCollectionRequiredFields = {
    Name: 'name',
    Cpf: 'cpf',
    Email: 'email',
    Birthday: 'birthday'
} as const;

export type UserDataCollectionRequiredFields = typeof UserDataCollectionRequiredFields[keyof typeof UserDataCollectionRequiredFields];


/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * User unique identifier
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * App id
     * @type {string}
     * @memberof UserDto
     */
    'app': string;
    /**
     * User email
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string | null;
    /**
     * User name
     * @type {string}
     * @memberof UserDto
     */
    'name': string | null;
    /**
     * User first name
     * @type {string}
     * @memberof UserDto
     */
    'firstName': string | null;
    /**
     * User last name
     * @type {string}
     * @memberof UserDto
     */
    'lastName': string | null;
    /**
     * User creation source
     * @type {string}
     * @memberof UserDto
     */
    'source'?: UserDtoSourceEnum;
    /**
     * User gender
     * @type {object}
     * @memberof UserDto
     */
    'gender': UserDtoGenderEnum | null;
    /**
     * User phone number
     * @type {string}
     * @memberof UserDto
     */
    'phone'?: string;
    /**
     * User Unverified phone number
     * @type {string}
     * @memberof UserDto
     */
    'unverifiedPhone'?: string;
    /**
     * User external identifier
     * @type {string}
     * @memberof UserDto
     */
    'externalId': string | null;
    /**
     * Avatar
     * @type {string}
     * @memberof UserDto
     */
    'avatar': string | null;
    /**
     * User language
     * @type {string}
     * @memberof UserDto
     */
    'language': UserDtoLanguageEnum;
    /**
     * User country
     * @type {string}
     * @memberof UserDto
     */
    'country': string;
    /**
     * Pristine
     * @type {boolean}
     * @memberof UserDto
     */
    'pristine': boolean;
    /**
     * User CPF
     * @type {string}
     * @memberof UserDto
     */
    'cpf'?: string;
    /**
     * User current level
     * @type {number}
     * @memberof UserDto
     */
    'tier': number;
    /**
     * Date of last user level update
     * @type {string}
     * @memberof UserDto
     */
    'tierUpdatedDate': string | null;
    /**
     * User Badges
     * @type {Array<string>}
     * @memberof UserDto
     */
    'badges': Array<string>;
    /**
     * current user poitns
     * @type {UserPointsDto}
     * @memberof UserDto
     */
    'points': UserPointsDto;
    /**
     * User statitics
     * @type {TotalsDto}
     * @memberof UserDto
     */
    'totals': TotalsDto;
    /**
     * User referral status
     * @type {UserReferralsDto}
     * @memberof UserDto
     */
    'referral': UserReferralsDto;
    /**
     * User type, eg member, draft, prospect
     * @type {string}
     * @memberof UserDto
     */
    'type': UserDtoTypeEnum;
    /**
     * User Socials links
     * @type {UserSocialDto}
     * @memberof UserDto
     */
    'social': UserSocialDto;
    /**
     * User Currency
     * @type {string}
     * @memberof UserDto
     */
    'currency': string;
    /**
     * User last logn date
     * @type {string}
     * @memberof UserDto
     */
    'lastLogin': string | null;
    /**
     * Metadata
     * @type {object}
     * @memberof UserDto
     */
    'metadata': object | null;
    /**
     * User creation date
     * @type {string}
     * @memberof UserDto
     */
    'createdAt': string;
    /**
     * 
     * @type {UserDtoDateOfBirth}
     * @memberof UserDto
     */
    'dateOfBirth': UserDtoDateOfBirth | null;
    /**
     * User group id
     * @type {string}
     * @memberof UserDto
     */
    'userGroup': string | null;
    /**
     * User first login date
     * @type {boolean}
     * @memberof UserDto
     */
    'firstLogin': boolean | null;
    /**
     * User active status
     * @type {boolean}
     * @memberof UserDto
     */
    'active': boolean;
    /**
     * 
     * @type {UserDtoEmployeeDetail}
     * @memberof UserDto
     */
    'employeeDetail': UserDtoEmployeeDetail | null;
    /**
     * Identifier of the sales rep that created the user
     * @type {string}
     * @memberof UserDto
     */
    'creatorSalesRepId'?: string;
    /**
     * Indicates if users engage in transactions through both online and offline platforms
     * @type {boolean}
     * @memberof UserDto
     */
    'omniChannel': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'skipWelcomeGiftCreation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'hasInteractedWithLS': boolean;
    /**
     * User Properties
     * @type {UserPropertiesDTO}
     * @memberof UserDto
     */
    'properties': UserPropertiesDTO;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'postalCode'?: string;
}

export const UserDtoSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;

export type UserDtoSourceEnum = typeof UserDtoSourceEnum[keyof typeof UserDtoSourceEnum];
export const UserDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Nb: 'NB',
    I: 'I',
    J: 'J',
    N: 'N',
    NA: 'N/A',
    Empty: ''
} as const;

export type UserDtoGenderEnum = typeof UserDtoGenderEnum[keyof typeof UserDtoGenderEnum];
export const UserDtoLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type UserDtoLanguageEnum = typeof UserDtoLanguageEnum[keyof typeof UserDtoLanguageEnum];
export const UserDtoTypeEnum = {
    Draft: 'draft',
    Member: 'member',
    Prospect: 'prospect',
    Registered: 'registered'
} as const;

export type UserDtoTypeEnum = typeof UserDtoTypeEnum[keyof typeof UserDtoTypeEnum];

/**
 * User birthday
 * @export
 * @interface UserDtoDateOfBirth
 */
export interface UserDtoDateOfBirth {
    /**
     * Year
     * @type {number}
     * @memberof UserDtoDateOfBirth
     */
    'year': number;
    /**
     * Month
     * @type {number}
     * @memberof UserDtoDateOfBirth
     */
    'month': number;
    /**
     * Day
     * @type {number}
     * @memberof UserDtoDateOfBirth
     */
    'day': number;
}
/**
 * User Employee details
 * @export
 * @interface UserDtoEmployeeDetail
 */
export interface UserDtoEmployeeDetail {
    /**
     * User role
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'role': string;
    /**
     * Manager ID
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'manager': string | null;
    /**
     * Organization Id
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'organization': string;
    /**
     * Department ID
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'department': string;
    /**
     * Location ID
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'location': string;
}
/**
 * 
 * @export
 * @interface UserFreeShippingDto
 */
export interface UserFreeShippingDto {
    /**
     * 
     * @type {string}
     * @memberof UserFreeShippingDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserFreeShippingDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof UserFreeShippingDto
     */
    'tier': string;
    /**
     * 
     * @type {string}
     * @memberof UserFreeShippingDto
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof UserFreeShippingDto
     */
    'appFreeShipping': string;
    /**
     * 
     * @type {string}
     * @memberof UserFreeShippingDto
     */
    'status': UserFreeShippingDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof UserFreeShippingDto
     */
    'totalNumberOfCodes': number;
    /**
     * 
     * @type {number}
     * @memberof UserFreeShippingDto
     */
    'remainingNumberOfCodes': number;
}

export const UserFreeShippingDtoStatusEnum = {
    Active: 'active',
    Disabled: 'disabled',
    Expired: 'expired'
} as const;

export type UserFreeShippingDtoStatusEnum = typeof UserFreeShippingDtoStatusEnum[keyof typeof UserFreeShippingDtoStatusEnum];

/**
 * 
 * @export
 * @interface UserFreeShippingListResponse
 */
export interface UserFreeShippingListResponse {
    /**
     * 
     * @type {Array<UserFreeShippingDto>}
     * @memberof UserFreeShippingListResponse
     */
    'userFreeShippings': Array<UserFreeShippingDto>;
}
/**
 * 
 * @export
 * @interface UserFreeShippingResponse
 */
export interface UserFreeShippingResponse {
    /**
     * 
     * @type {UserFreeShippingDto}
     * @memberof UserFreeShippingResponse
     */
    'userFreeShipping': UserFreeShippingDto;
}
/**
 * 
 * @export
 * @interface UserIdentificationRequest
 */
export interface UserIdentificationRequest {
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'identificationCode': string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'birthday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'operatorCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'operatorName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserIdentificationRequest
     */
    'document'?: string;
}
/**
 * 
 * @export
 * @interface UserIdentifyResponse
 */
export interface UserIdentifyResponse {
    /**
     * 
     * @type {string}
     * @memberof UserIdentifyResponse
     */
    'nextStep': string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentifyResponse
     */
    'partnerCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentifyResponse
     */
    'customerText': string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentifyResponse
     */
    'operatorText': string;
    /**
     * 
     * @type {IdentificationAuthResponse}
     * @memberof UserIdentifyResponse
     */
    'authentication': IdentificationAuthResponse;
    /**
     * 
     * @type {IdentificationResponse}
     * @memberof UserIdentifyResponse
     */
    'identification': IdentificationResponse;
    /**
     * 
     * @type {Array<BonusResponse>}
     * @memberof UserIdentifyResponse
     */
    'bonus': Array<BonusResponse>;
    /**
     * 
     * @type {string}
     * @memberof UserIdentifyResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserIdentifyResponse
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface UserOrderTotalResponse
 */
export interface UserOrderTotalResponse {
    /**
     * 
     * @type {number}
     * @memberof UserOrderTotalResponse
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface UserPointsDto
 */
export interface UserPointsDto {
    /**
     * Points
     * @type {number}
     * @memberof UserPointsDto
     */
    'gems': number;
    /**
     * Level points
     * @type {number}
     * @memberof UserPointsDto
     */
    'exp': number;
}
/**
 * 
 * @export
 * @interface UserPropertiesDTO
 */
export interface UserPropertiesDTO {
    /**
     * Last purchase date
     * @type {string}
     * @memberof UserPropertiesDTO
     */
    'lastPurchaseDate': string | null;
    /**
     * Average time between purchases
     * @type {number}
     * @memberof UserPropertiesDTO
     */
    'averageBetweenPurchases': number;
    /**
     * Discount usage rate
     * @type {number}
     * @memberof UserPropertiesDTO
     */
    'discountUsageRate': number;
    /**
     * Count of completed purchases
     * @type {number}
     * @memberof UserPropertiesDTO
     */
    'completedPurchasesCount': number;
    /**
     * Count of internal discounts used
     * @type {number}
     * @memberof UserPropertiesDTO
     */
    'internalUsedDiscounts': number;
    /**
     * Last interactive date
     * @type {string}
     * @memberof UserPropertiesDTO
     */
    'lastInteractiveDate': string | null;
    /**
     * Communication Statistics
     * @type {object}
     * @memberof UserPropertiesDTO
     */
    'communication'?: object;
}
/**
 * 
 * @export
 * @interface UserReferralsDto
 */
export interface UserReferralsDto {
    /**
     * Referrer ID
     * @type {string}
     * @memberof UserReferralsDto
     */
    'referrer': string | null;
    /**
     * Referral source
     * @type {object}
     * @memberof UserReferralsDto
     */
    'source': UserReferralsDtoSourceEnum | null;
}

export const UserReferralsDtoSourceEnum = {
    OfflineOrder: 'offlineOrder',
    OnlineOrder: 'onlineOrder'
} as const;

export type UserReferralsDtoSourceEnum = typeof UserReferralsDtoSourceEnum[keyof typeof UserReferralsDtoSourceEnum];

/**
 * 
 * @export
 * @interface UserSocialDto
 */
export interface UserSocialDto {
    /**
     * Facebook link
     * @type {string}
     * @memberof UserSocialDto
     */
    'facebook': string | null;
    /**
     * Instagram link
     * @type {string}
     * @memberof UserSocialDto
     */
    'instagram': string | null;
}
/**
 * 
 * @export
 * @interface UserWelcomeGiftResponse
 */
export interface UserWelcomeGiftResponse {
    /**
     * 
     * @type {DiscountDto}
     * @memberof UserWelcomeGiftResponse
     */
    'UserWelcomeGift': DiscountDto;
}
/**
 * 
 * @export
 * @interface VerifyOfflineOrderOtpRequest
 */
export interface VerifyOfflineOrderOtpRequest {
    /**
     * One-Time Password code
     * @type {string}
     * @memberof VerifyOfflineOrderOtpRequest
     */
    'code': string;
    /**
     * Phone number
     * @type {string}
     * @memberof VerifyOfflineOrderOtpRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyOfflineOrderOtpRequest
     */
    'type'?: VerifyOfflineOrderOtpRequestTypeEnum;
    /**
     * User CPF
     * @type {string}
     * @memberof VerifyOfflineOrderOtpRequest
     */
    'cpf'?: string;
    /**
     * User name
     * @type {string}
     * @memberof VerifyOfflineOrderOtpRequest
     */
    'name'?: string;
    /**
     * User email
     * @type {string}
     * @memberof VerifyOfflineOrderOtpRequest
     */
    'email'?: string;
    /**
     * User birthday
     * @type {string}
     * @memberof VerifyOfflineOrderOtpRequest
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyOfflineOrderOtpRequest
     */
    'oldPhone'?: string;
}

export const VerifyOfflineOrderOtpRequestTypeEnum = {
    Email: 'email',
    Phone: 'phone',
    UserId: 'userId'
} as const;

export type VerifyOfflineOrderOtpRequestTypeEnum = typeof VerifyOfflineOrderOtpRequestTypeEnum[keyof typeof VerifyOfflineOrderOtpRequestTypeEnum];

/**
 * 
 * @export
 * @interface VerifyOtpRequest
 */
export interface VerifyOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyOtpRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyOtpRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ViewsResposne
 */
export interface ViewsResposne {
    /**
     * 
     * @type {Array<object>}
     * @memberof ViewsResposne
     */
    'views': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof ViewsResposne
     */
    'totalViews': number;
}
/**
 * 
 * @export
 * @interface WelcomeGiftDto
 */
export interface WelcomeGiftDto {
    /**
     * 
     * @type {string}
     * @memberof WelcomeGiftDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WelcomeGiftDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof WelcomeGiftDto
     */
    'type': WelcomeGiftDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WelcomeGiftDto
     */
    'monetary'?: number;
    /**
     * 
     * @type {number}
     * @memberof WelcomeGiftDto
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof WelcomeGiftDto
     */
    'minPurchaseAmount': number;
    /**
     * 
     * @type {boolean}
     * @memberof WelcomeGiftDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof WelcomeGiftDto
     */
    'expiresInDays': number;
    /**
     * 
     * @type {boolean}
     * @memberof WelcomeGiftDto
     */
    'phoneVerificationEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof WelcomeGiftDto
     */
    'remindsBeforeDays': number | null;
}

export const WelcomeGiftDtoTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type WelcomeGiftDtoTypeEnum = typeof WelcomeGiftDtoTypeEnum[keyof typeof WelcomeGiftDtoTypeEnum];

/**
 * 
 * @export
 * @interface WelcomeGiftGetResponse
 */
export interface WelcomeGiftGetResponse {
    /**
     * 
     * @type {WelcomeGiftDto}
     * @memberof WelcomeGiftGetResponse
     */
    'welcomeGift'?: WelcomeGiftDto | null;
}
/**
 * 
 * @export
 * @interface WelcomeGiftResponse
 */
export interface WelcomeGiftResponse {
    /**
     * 
     * @type {WelcomeGiftDto}
     * @memberof WelcomeGiftResponse
     */
    'welcomeGift': WelcomeGiftDto;
}

/**
 * AppCashbackApi - axios parameter creator
 * @export
 */
export const AppCashbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create AppCashback
         * @param {string} gamixAppId 
         * @param {CashbackCreateRequest} cashbackCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerCreate: async (gamixAppId: string, cashbackCreateRequest: CashbackCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appCashbackControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'cashbackCreateRequest' is not null or undefined
            assertParamExists('appCashbackControllerCreate', 'cashbackCreateRequest', cashbackCreateRequest)
            const localVarPath = `/v2/app-cashback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cashbackCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appCashbackControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appCashbackControllerDelete', 'id', id)
            const localVarPath = `/v2/app-cashback/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appCashbackControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appCashbackControllerGet', 'id', id)
            const localVarPath = `/v2/app-cashback/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Apps Cashback
         * @param {string} gamixAppId 
         * @param {number} [percentage] 
         * @param {number} [expiry] 
         * @param {AppCashbackControllerListUnitEnum} [unit] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerList: async (gamixAppId: string, percentage?: number, expiry?: number, unit?: AppCashbackControllerListUnitEnum, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appCashbackControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/app-cashback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (percentage !== undefined) {
                localVarQueryParameter['percentage'] = percentage;
            }

            if (expiry !== undefined) {
                localVarQueryParameter['expiry'] = expiry;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CashbackUpdateRequest} cashbackUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerUpdate: async (gamixAppId: string, id: string, cashbackUpdateRequest: CashbackUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appCashbackControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appCashbackControllerUpdate', 'id', id)
            // verify required parameter 'cashbackUpdateRequest' is not null or undefined
            assertParamExists('appCashbackControllerUpdate', 'cashbackUpdateRequest', cashbackUpdateRequest)
            const localVarPath = `/v2/app-cashback/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cashbackUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppCashbackApi - functional programming interface
 * @export
 */
export const AppCashbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppCashbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create AppCashback
         * @param {string} gamixAppId 
         * @param {CashbackCreateRequest} cashbackCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appCashbackControllerCreate(gamixAppId: string, cashbackCreateRequest: CashbackCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppCashbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appCashbackControllerCreate(gamixAppId, cashbackCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppCashbackApi.appCashbackControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appCashbackControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appCashbackControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppCashbackApi.appCashbackControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appCashbackControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppCashbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appCashbackControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppCashbackApi.appCashbackControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Apps Cashback
         * @param {string} gamixAppId 
         * @param {number} [percentage] 
         * @param {number} [expiry] 
         * @param {AppCashbackControllerListUnitEnum} [unit] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appCashbackControllerList(gamixAppId: string, percentage?: number, expiry?: number, unit?: AppCashbackControllerListUnitEnum, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppCashbackListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appCashbackControllerList(gamixAppId, percentage, expiry, unit, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppCashbackApi.appCashbackControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CashbackUpdateRequest} cashbackUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appCashbackControllerUpdate(gamixAppId: string, id: string, cashbackUpdateRequest: CashbackUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppCashbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appCashbackControllerUpdate(gamixAppId, id, cashbackUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppCashbackApi.appCashbackControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppCashbackApi - factory interface
 * @export
 */
export const AppCashbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppCashbackApiFp(configuration)
    return {
        /**
         * 
         * @summary Create AppCashback
         * @param {string} gamixAppId 
         * @param {CashbackCreateRequest} cashbackCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerCreate(gamixAppId: string, cashbackCreateRequest: CashbackCreateRequest, options?: any): AxiosPromise<AppCashbackResponse> {
            return localVarFp.appCashbackControllerCreate(gamixAppId, cashbackCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.appCashbackControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<AppCashbackResponse> {
            return localVarFp.appCashbackControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Apps Cashback
         * @param {string} gamixAppId 
         * @param {number} [percentage] 
         * @param {number} [expiry] 
         * @param {AppCashbackControllerListUnitEnum} [unit] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerList(gamixAppId: string, percentage?: number, expiry?: number, unit?: AppCashbackControllerListUnitEnum, limit?: number, skip?: number, options?: any): AxiosPromise<AppCashbackListResponse> {
            return localVarFp.appCashbackControllerList(gamixAppId, percentage, expiry, unit, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update AppCashback
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CashbackUpdateRequest} cashbackUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appCashbackControllerUpdate(gamixAppId: string, id: string, cashbackUpdateRequest: CashbackUpdateRequest, options?: any): AxiosPromise<AppCashbackResponse> {
            return localVarFp.appCashbackControllerUpdate(gamixAppId, id, cashbackUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppCashbackApi - object-oriented interface
 * @export
 * @class AppCashbackApi
 * @extends {BaseAPI}
 */
export class AppCashbackApi extends BaseAPI {
    /**
     * 
     * @summary Create AppCashback
     * @param {string} gamixAppId 
     * @param {CashbackCreateRequest} cashbackCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCashbackApi
     */
    public appCashbackControllerCreate(gamixAppId: string, cashbackCreateRequest: CashbackCreateRequest, options?: RawAxiosRequestConfig) {
        return AppCashbackApiFp(this.configuration).appCashbackControllerCreate(gamixAppId, cashbackCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete AppCashback
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCashbackApi
     */
    public appCashbackControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return AppCashbackApiFp(this.configuration).appCashbackControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get AppCashback
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCashbackApi
     */
    public appCashbackControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return AppCashbackApiFp(this.configuration).appCashbackControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Apps Cashback
     * @param {string} gamixAppId 
     * @param {number} [percentage] 
     * @param {number} [expiry] 
     * @param {AppCashbackControllerListUnitEnum} [unit] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCashbackApi
     */
    public appCashbackControllerList(gamixAppId: string, percentage?: number, expiry?: number, unit?: AppCashbackControllerListUnitEnum, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return AppCashbackApiFp(this.configuration).appCashbackControllerList(gamixAppId, percentage, expiry, unit, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update AppCashback
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {CashbackUpdateRequest} cashbackUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCashbackApi
     */
    public appCashbackControllerUpdate(gamixAppId: string, id: string, cashbackUpdateRequest: CashbackUpdateRequest, options?: RawAxiosRequestConfig) {
        return AppCashbackApiFp(this.configuration).appCashbackControllerUpdate(gamixAppId, id, cashbackUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AppCashbackControllerListUnitEnum = {
    Day: 'day',
    Month: 'month'
} as const;
export type AppCashbackControllerListUnitEnum = typeof AppCashbackControllerListUnitEnum[keyof typeof AppCashbackControllerListUnitEnum];


/**
 * AppEcommerceApi - axios parameter creator
 * @export
 */
export const AppEcommerceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create App Ecommerce
         * @param {string} gamixAppId 
         * @param {AppEcommerceCreateRequest} appEcommerceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEcommerceControllerCreate: async (gamixAppId: string, appEcommerceCreateRequest: AppEcommerceCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appEcommerceControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'appEcommerceCreateRequest' is not null or undefined
            assertParamExists('appEcommerceControllerCreate', 'appEcommerceCreateRequest', appEcommerceCreateRequest)
            const localVarPath = `/v2/app-ecommerce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appEcommerceCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete App Ecommerce
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEcommerceControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appEcommerceControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appEcommerceControllerDelete', 'id', id)
            const localVarPath = `/v2/app-ecommerce/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get App Ecommerce
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEcommerceControllerGet: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appEcommerceControllerGet', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/app-ecommerce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update App Ecommerce
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppEcommerceCreateRequest} appEcommerceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEcommerceControllerUpdate: async (gamixAppId: string, id: string, appEcommerceCreateRequest: AppEcommerceCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appEcommerceControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appEcommerceControllerUpdate', 'id', id)
            // verify required parameter 'appEcommerceCreateRequest' is not null or undefined
            assertParamExists('appEcommerceControllerUpdate', 'appEcommerceCreateRequest', appEcommerceCreateRequest)
            const localVarPath = `/v2/app-ecommerce/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appEcommerceCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppEcommerceApi - functional programming interface
 * @export
 */
export const AppEcommerceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppEcommerceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create App Ecommerce
         * @param {string} gamixAppId 
         * @param {AppEcommerceCreateRequest} appEcommerceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appEcommerceControllerCreate(gamixAppId: string, appEcommerceCreateRequest: AppEcommerceCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppEcommerceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appEcommerceControllerCreate(gamixAppId, appEcommerceCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppEcommerceApi.appEcommerceControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete App Ecommerce
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appEcommerceControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appEcommerceControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppEcommerceApi.appEcommerceControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get App Ecommerce
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appEcommerceControllerGet(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppEcommerceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appEcommerceControllerGet(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppEcommerceApi.appEcommerceControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update App Ecommerce
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppEcommerceCreateRequest} appEcommerceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appEcommerceControllerUpdate(gamixAppId: string, id: string, appEcommerceCreateRequest: AppEcommerceCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppEcommerceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appEcommerceControllerUpdate(gamixAppId, id, appEcommerceCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppEcommerceApi.appEcommerceControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppEcommerceApi - factory interface
 * @export
 */
export const AppEcommerceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppEcommerceApiFp(configuration)
    return {
        /**
         * 
         * @summary Create App Ecommerce
         * @param {string} gamixAppId 
         * @param {AppEcommerceCreateRequest} appEcommerceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEcommerceControllerCreate(gamixAppId: string, appEcommerceCreateRequest: AppEcommerceCreateRequest, options?: any): AxiosPromise<AppEcommerceResponse> {
            return localVarFp.appEcommerceControllerCreate(gamixAppId, appEcommerceCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete App Ecommerce
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEcommerceControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.appEcommerceControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get App Ecommerce
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEcommerceControllerGet(gamixAppId: string, options?: any): AxiosPromise<AppEcommerceResponse> {
            return localVarFp.appEcommerceControllerGet(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update App Ecommerce
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppEcommerceCreateRequest} appEcommerceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEcommerceControllerUpdate(gamixAppId: string, id: string, appEcommerceCreateRequest: AppEcommerceCreateRequest, options?: any): AxiosPromise<AppEcommerceResponse> {
            return localVarFp.appEcommerceControllerUpdate(gamixAppId, id, appEcommerceCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppEcommerceApi - object-oriented interface
 * @export
 * @class AppEcommerceApi
 * @extends {BaseAPI}
 */
export class AppEcommerceApi extends BaseAPI {
    /**
     * 
     * @summary Create App Ecommerce
     * @param {string} gamixAppId 
     * @param {AppEcommerceCreateRequest} appEcommerceCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppEcommerceApi
     */
    public appEcommerceControllerCreate(gamixAppId: string, appEcommerceCreateRequest: AppEcommerceCreateRequest, options?: RawAxiosRequestConfig) {
        return AppEcommerceApiFp(this.configuration).appEcommerceControllerCreate(gamixAppId, appEcommerceCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete App Ecommerce
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppEcommerceApi
     */
    public appEcommerceControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return AppEcommerceApiFp(this.configuration).appEcommerceControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get App Ecommerce
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppEcommerceApi
     */
    public appEcommerceControllerGet(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return AppEcommerceApiFp(this.configuration).appEcommerceControllerGet(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update App Ecommerce
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {AppEcommerceCreateRequest} appEcommerceCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppEcommerceApi
     */
    public appEcommerceControllerUpdate(gamixAppId: string, id: string, appEcommerceCreateRequest: AppEcommerceCreateRequest, options?: RawAxiosRequestConfig) {
        return AppEcommerceApiFp(this.configuration).appEcommerceControllerUpdate(gamixAppId, id, appEcommerceCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppFreeShippingApi - axios parameter creator
 * @export
 */
export const AppFreeShippingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create appFreeShipping
         * @param {string} gamixAppId 
         * @param {AppFreeShippingCreateRequest} appFreeShippingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerCreate: async (gamixAppId: string, appFreeShippingCreateRequest: AppFreeShippingCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appFreeShippingControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'appFreeShippingCreateRequest' is not null or undefined
            assertParamExists('appFreeShippingControllerCreate', 'appFreeShippingCreateRequest', appFreeShippingCreateRequest)
            const localVarPath = `/v2/free-shipping/apps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appFreeShippingCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete app free shipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appFreeShippingControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appFreeShippingControllerDelete', 'id', id)
            const localVarPath = `/v2/free-shipping/apps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable appFreeShipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerEnable: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appFreeShippingControllerEnable', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appFreeShippingControllerEnable', 'id', id)
            const localVarPath = `/v2/free-shipping/apps/enable/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get appFreeShipping by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerGetById: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appFreeShippingControllerGetById', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appFreeShippingControllerGetById', 'id', id)
            const localVarPath = `/v2/free-shipping/apps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List appFreeShippings
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerList: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appFreeShippingControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/free-shipping/apps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update appFreeShipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppFreeShippingUpdateRequest} appFreeShippingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerUpdate: async (gamixAppId: string, id: string, appFreeShippingUpdateRequest: AppFreeShippingUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appFreeShippingControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appFreeShippingControllerUpdate', 'id', id)
            // verify required parameter 'appFreeShippingUpdateRequest' is not null or undefined
            assertParamExists('appFreeShippingControllerUpdate', 'appFreeShippingUpdateRequest', appFreeShippingUpdateRequest)
            const localVarPath = `/v2/free-shipping/apps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appFreeShippingUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppFreeShippingApi - functional programming interface
 * @export
 */
export const AppFreeShippingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppFreeShippingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create appFreeShipping
         * @param {string} gamixAppId 
         * @param {AppFreeShippingCreateRequest} appFreeShippingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appFreeShippingControllerCreate(gamixAppId: string, appFreeShippingCreateRequest: AppFreeShippingCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppFreeShippingResposne>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appFreeShippingControllerCreate(gamixAppId, appFreeShippingCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppFreeShippingApi.appFreeShippingControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete app free shipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appFreeShippingControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppFreeShippingResposne>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appFreeShippingControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppFreeShippingApi.appFreeShippingControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enable appFreeShipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appFreeShippingControllerEnable(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppFreeShippingResposne>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appFreeShippingControllerEnable(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppFreeShippingApi.appFreeShippingControllerEnable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get appFreeShipping by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appFreeShippingControllerGetById(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppFreeShippingResposne>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appFreeShippingControllerGetById(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppFreeShippingApi.appFreeShippingControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List appFreeShippings
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appFreeShippingControllerList(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppFreeShippingListResposne>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appFreeShippingControllerList(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppFreeShippingApi.appFreeShippingControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update appFreeShipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppFreeShippingUpdateRequest} appFreeShippingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appFreeShippingControllerUpdate(gamixAppId: string, id: string, appFreeShippingUpdateRequest: AppFreeShippingUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppFreeShippingResposne>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appFreeShippingControllerUpdate(gamixAppId, id, appFreeShippingUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppFreeShippingApi.appFreeShippingControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppFreeShippingApi - factory interface
 * @export
 */
export const AppFreeShippingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppFreeShippingApiFp(configuration)
    return {
        /**
         * 
         * @summary Create appFreeShipping
         * @param {string} gamixAppId 
         * @param {AppFreeShippingCreateRequest} appFreeShippingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerCreate(gamixAppId: string, appFreeShippingCreateRequest: AppFreeShippingCreateRequest, options?: any): AxiosPromise<AppFreeShippingResposne> {
            return localVarFp.appFreeShippingControllerCreate(gamixAppId, appFreeShippingCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete app free shipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<AppFreeShippingResposne> {
            return localVarFp.appFreeShippingControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable appFreeShipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerEnable(gamixAppId: string, id: string, options?: any): AxiosPromise<AppFreeShippingResposne> {
            return localVarFp.appFreeShippingControllerEnable(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get appFreeShipping by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerGetById(gamixAppId: string, id: string, options?: any): AxiosPromise<AppFreeShippingResposne> {
            return localVarFp.appFreeShippingControllerGetById(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List appFreeShippings
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerList(gamixAppId: string, options?: any): AxiosPromise<AppFreeShippingListResposne> {
            return localVarFp.appFreeShippingControllerList(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update appFreeShipping
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppFreeShippingUpdateRequest} appFreeShippingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appFreeShippingControllerUpdate(gamixAppId: string, id: string, appFreeShippingUpdateRequest: AppFreeShippingUpdateRequest, options?: any): AxiosPromise<AppFreeShippingResposne> {
            return localVarFp.appFreeShippingControllerUpdate(gamixAppId, id, appFreeShippingUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppFreeShippingApi - object-oriented interface
 * @export
 * @class AppFreeShippingApi
 * @extends {BaseAPI}
 */
export class AppFreeShippingApi extends BaseAPI {
    /**
     * 
     * @summary Create appFreeShipping
     * @param {string} gamixAppId 
     * @param {AppFreeShippingCreateRequest} appFreeShippingCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppFreeShippingApi
     */
    public appFreeShippingControllerCreate(gamixAppId: string, appFreeShippingCreateRequest: AppFreeShippingCreateRequest, options?: RawAxiosRequestConfig) {
        return AppFreeShippingApiFp(this.configuration).appFreeShippingControllerCreate(gamixAppId, appFreeShippingCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete app free shipping
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppFreeShippingApi
     */
    public appFreeShippingControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return AppFreeShippingApiFp(this.configuration).appFreeShippingControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable appFreeShipping
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppFreeShippingApi
     */
    public appFreeShippingControllerEnable(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return AppFreeShippingApiFp(this.configuration).appFreeShippingControllerEnable(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get appFreeShipping by id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppFreeShippingApi
     */
    public appFreeShippingControllerGetById(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return AppFreeShippingApiFp(this.configuration).appFreeShippingControllerGetById(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List appFreeShippings
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppFreeShippingApi
     */
    public appFreeShippingControllerList(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return AppFreeShippingApiFp(this.configuration).appFreeShippingControllerList(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update appFreeShipping
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {AppFreeShippingUpdateRequest} appFreeShippingUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppFreeShippingApi
     */
    public appFreeShippingControllerUpdate(gamixAppId: string, id: string, appFreeShippingUpdateRequest: AppFreeShippingUpdateRequest, options?: RawAxiosRequestConfig) {
        return AppFreeShippingApiFp(this.configuration).appFreeShippingControllerUpdate(gamixAppId, id, appFreeShippingUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CampaignNotificationApi - axios parameter creator
 * @export
 */
export const CampaignNotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Campaign Notification
         * @param {string} gamixAppId 
         * @param {CampaignNotificationCreateRequest} campaignNotificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerCreate: async (gamixAppId: string, campaignNotificationCreateRequest: CampaignNotificationCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignNotificationControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'campaignNotificationCreateRequest' is not null or undefined
            assertParamExists('campaignNotificationControllerCreate', 'campaignNotificationCreateRequest', campaignNotificationCreateRequest)
            const localVarPath = `/v2/ecommerce/campaign-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignNotificationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignNotificationControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignNotificationControllerDelete', 'id', id)
            const localVarPath = `/v2/ecommerce/campaign-notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignNotificationControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignNotificationControllerGet', 'id', id)
            const localVarPath = `/v2/ecommerce/campaign-notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Campaign Notifications
         * @param {string} gamixAppId 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerListByCampaign: async (gamixAppId: string, campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignNotificationControllerListByCampaign', 'gamixAppId', gamixAppId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignNotificationControllerListByCampaign', 'campaignId', campaignId)
            const localVarPath = `/v2/ecommerce/campaign-notification/campaign/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignNotificationUpdateRequest} campaignNotificationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerUpdate: async (gamixAppId: string, id: string, campaignNotificationUpdateRequest: CampaignNotificationUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignNotificationControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignNotificationControllerUpdate', 'id', id)
            // verify required parameter 'campaignNotificationUpdateRequest' is not null or undefined
            assertParamExists('campaignNotificationControllerUpdate', 'campaignNotificationUpdateRequest', campaignNotificationUpdateRequest)
            const localVarPath = `/v2/ecommerce/campaign-notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignNotificationUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignNotificationApi - functional programming interface
 * @export
 */
export const CampaignNotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignNotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Campaign Notification
         * @param {string} gamixAppId 
         * @param {CampaignNotificationCreateRequest} campaignNotificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignNotificationControllerCreate(gamixAppId: string, campaignNotificationCreateRequest: CampaignNotificationCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignNotificationControllerCreate(gamixAppId, campaignNotificationCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignNotificationApi.campaignNotificationControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignNotificationControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignNotificationControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignNotificationApi.campaignNotificationControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignNotificationControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignNotificationControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignNotificationApi.campaignNotificationControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Campaign Notifications
         * @param {string} gamixAppId 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignNotificationControllerListByCampaign(gamixAppId: string, campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNotificationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignNotificationControllerListByCampaign(gamixAppId, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignNotificationApi.campaignNotificationControllerListByCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignNotificationUpdateRequest} campaignNotificationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignNotificationControllerUpdate(gamixAppId: string, id: string, campaignNotificationUpdateRequest: CampaignNotificationUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignNotificationControllerUpdate(gamixAppId, id, campaignNotificationUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignNotificationApi.campaignNotificationControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignNotificationApi - factory interface
 * @export
 */
export const CampaignNotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignNotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Campaign Notification
         * @param {string} gamixAppId 
         * @param {CampaignNotificationCreateRequest} campaignNotificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerCreate(gamixAppId: string, campaignNotificationCreateRequest: CampaignNotificationCreateRequest, options?: any): AxiosPromise<CampaignNotificationResponse> {
            return localVarFp.campaignNotificationControllerCreate(gamixAppId, campaignNotificationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.campaignNotificationControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<CampaignNotificationResponse> {
            return localVarFp.campaignNotificationControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Campaign Notifications
         * @param {string} gamixAppId 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerListByCampaign(gamixAppId: string, campaignId: string, options?: any): AxiosPromise<CampaignNotificationListResponse> {
            return localVarFp.campaignNotificationControllerListByCampaign(gamixAppId, campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Campaign Notification
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignNotificationUpdateRequest} campaignNotificationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignNotificationControllerUpdate(gamixAppId: string, id: string, campaignNotificationUpdateRequest: CampaignNotificationUpdateRequest, options?: any): AxiosPromise<CampaignNotificationResponse> {
            return localVarFp.campaignNotificationControllerUpdate(gamixAppId, id, campaignNotificationUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignNotificationApi - object-oriented interface
 * @export
 * @class CampaignNotificationApi
 * @extends {BaseAPI}
 */
export class CampaignNotificationApi extends BaseAPI {
    /**
     * 
     * @summary Create Campaign Notification
     * @param {string} gamixAppId 
     * @param {CampaignNotificationCreateRequest} campaignNotificationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignNotificationApi
     */
    public campaignNotificationControllerCreate(gamixAppId: string, campaignNotificationCreateRequest: CampaignNotificationCreateRequest, options?: RawAxiosRequestConfig) {
        return CampaignNotificationApiFp(this.configuration).campaignNotificationControllerCreate(gamixAppId, campaignNotificationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Campaign Notification
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignNotificationApi
     */
    public campaignNotificationControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CampaignNotificationApiFp(this.configuration).campaignNotificationControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Campaign Notification
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignNotificationApi
     */
    public campaignNotificationControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CampaignNotificationApiFp(this.configuration).campaignNotificationControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Campaign Notifications
     * @param {string} gamixAppId 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignNotificationApi
     */
    public campaignNotificationControllerListByCampaign(gamixAppId: string, campaignId: string, options?: RawAxiosRequestConfig) {
        return CampaignNotificationApiFp(this.configuration).campaignNotificationControllerListByCampaign(gamixAppId, campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Campaign Notification
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {CampaignNotificationUpdateRequest} campaignNotificationUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignNotificationApi
     */
    public campaignNotificationControllerUpdate(gamixAppId: string, id: string, campaignNotificationUpdateRequest: CampaignNotificationUpdateRequest, options?: RawAxiosRequestConfig) {
        return CampaignNotificationApiFp(this.configuration).campaignNotificationControllerUpdate(gamixAppId, id, campaignNotificationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CampaignRequestApi - axios parameter creator
 * @export
 */
export const CampaignRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get Campaign Request by app
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignRequestControllerGetByApp: async (gamixAppId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignRequestControllerGetByApp', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/campaign-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update campaign Request 
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignRequestUpdateRequest} campaignRequestUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignRequestControllerUpdate: async (gamixAppId: string, id: string, campaignRequestUpdateRequest: CampaignRequestUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignRequestControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignRequestControllerUpdate', 'id', id)
            // verify required parameter 'campaignRequestUpdateRequest' is not null or undefined
            assertParamExists('campaignRequestControllerUpdate', 'campaignRequestUpdateRequest', campaignRequestUpdateRequest)
            const localVarPath = `/v2/ecommerce/campaign-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignRequestUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignRequestApi - functional programming interface
 * @export
 */
export const CampaignRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get Campaign Request by app
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignRequestControllerGetByApp(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignRequestControllerGetByApp(gamixAppId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignRequestApi.campaignRequestControllerGetByApp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update campaign Request 
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignRequestUpdateRequest} campaignRequestUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignRequestControllerUpdate(gamixAppId: string, id: string, campaignRequestUpdateRequest: CampaignRequestUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignRequestControllerUpdate(gamixAppId, id, campaignRequestUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignRequestApi.campaignRequestControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignRequestApi - factory interface
 * @export
 */
export const CampaignRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignRequestApiFp(configuration)
    return {
        /**
         * 
         * @summary get Campaign Request by app
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignRequestControllerGetByApp(gamixAppId: string, limit?: number, skip?: number, options?: any): AxiosPromise<CampaignRequestListResponse> {
            return localVarFp.campaignRequestControllerGetByApp(gamixAppId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update campaign Request 
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignRequestUpdateRequest} campaignRequestUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignRequestControllerUpdate(gamixAppId: string, id: string, campaignRequestUpdateRequest: CampaignRequestUpdateRequest, options?: any): AxiosPromise<CampaignRequestResponse> {
            return localVarFp.campaignRequestControllerUpdate(gamixAppId, id, campaignRequestUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignRequestApi - object-oriented interface
 * @export
 * @class CampaignRequestApi
 * @extends {BaseAPI}
 */
export class CampaignRequestApi extends BaseAPI {
    /**
     * 
     * @summary get Campaign Request by app
     * @param {string} gamixAppId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignRequestApi
     */
    public campaignRequestControllerGetByApp(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return CampaignRequestApiFp(this.configuration).campaignRequestControllerGetByApp(gamixAppId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update campaign Request 
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {CampaignRequestUpdateRequest} campaignRequestUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignRequestApi
     */
    public campaignRequestControllerUpdate(gamixAppId: string, id: string, campaignRequestUpdateRequest: CampaignRequestUpdateRequest, options?: RawAxiosRequestConfig) {
        return CampaignRequestApiFp(this.configuration).campaignRequestControllerUpdate(gamixAppId, id, campaignRequestUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CampaignsApi - axios parameter creator
 * @export
 */
export const CampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Campaign
         * @param {string} gamixAppId 
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerCreate: async (gamixAppId: string, campaignCreateRequest: CampaignCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'campaignCreateRequest' is not null or undefined
            assertParamExists('campaignsControllerCreate', 'campaignCreateRequest', campaignCreateRequest)
            const localVarPath = `/v2/ecommerce/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Campaigns
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignsControllerDelete', 'id', id)
            const localVarPath = `/v2/ecommerce/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send Campaign Report
         * @param {string} gamixAppId 
         * @param {CampaignReportRequest} campaignReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerGenerateReport: async (gamixAppId: string, campaignReportRequest: CampaignReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerGenerateReport', 'gamixAppId', gamixAppId)
            // verify required parameter 'campaignReportRequest' is not null or undefined
            assertParamExists('campaignsControllerGenerateReport', 'campaignReportRequest', campaignReportRequest)
            const localVarPath = `/v2/ecommerce/campaigns/export/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Campaign By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignsControllerGet', 'id', id)
            const localVarPath = `/v2/ecommerce/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Campaign By Booster Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerGetByBoosterId: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerGetByBoosterId', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignsControllerGetByBoosterId', 'id', id)
            const localVarPath = `/v2/ecommerce/campaigns/booster/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get campaign target count
         * @summary 
         * @param {string} gamixAppId 
         * @param {Array<CampaignsControllerGetTargetCountSourcesEnum>} sources 
         * @param {CampaignsControllerGetTargetCountTypeEnum} type 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [segmentId] 
         * @param {Array<string>} [retailerApps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerGetTargetCount: async (gamixAppId: string, sources: Array<CampaignsControllerGetTargetCountSourcesEnum>, type: CampaignsControllerGetTargetCountTypeEnum, startDate?: string, endDate?: string, segmentId?: string, retailerApps?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerGetTargetCount', 'gamixAppId', gamixAppId)
            // verify required parameter 'sources' is not null or undefined
            assertParamExists('campaignsControllerGetTargetCount', 'sources', sources)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('campaignsControllerGetTargetCount', 'type', type)
            const localVarPath = `/v2/ecommerce/campaigns/targets/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (segmentId !== undefined) {
                localVarQueryParameter['segmentId'] = segmentId;
            }

            if (retailerApps) {
                localVarQueryParameter['retailerApps'] = retailerApps;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Campaigns
         * @param {string} gamixAppId 
         * @param {string} [search] 
         * @param {Array<CampaignsControllerListCommunicationChannelsEnum>} [communicationChannels] 
         * @param {Array<CampaignsControllerListStatusEnum>} [status] 
         * @param {string} [sort] 
         * @param {CampaignsControllerListTypeEnum} [type] 
         * @param {string} [fromDateStart] 
         * @param {string} [fromDateEnd] 
         * @param {boolean} [active] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerList: async (gamixAppId: string, search?: string, communicationChannels?: Array<CampaignsControllerListCommunicationChannelsEnum>, status?: Array<CampaignsControllerListStatusEnum>, sort?: string, type?: CampaignsControllerListTypeEnum, fromDateStart?: string, fromDateEnd?: string, active?: boolean, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (communicationChannels) {
                localVarQueryParameter['communicationChannels'] = communicationChannels;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (fromDateStart !== undefined) {
                localVarQueryParameter['fromDateStart'] = (fromDateStart as any instanceof Date) ?
                    (fromDateStart as any).toISOString() :
                    fromDateStart;
            }

            if (fromDateEnd !== undefined) {
                localVarQueryParameter['fromDateEnd'] = (fromDateEnd as any instanceof Date) ?
                    (fromDateEnd as any).toISOString() :
                    fromDateEnd;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit the campaign
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerSubmit: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerSubmit', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignsControllerSubmit', 'id', id)
            const localVarPath = `/v2/ecommerce/campaigns/{id}/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Campaigns
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignUpdateRequest} campaignUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerUpdate: async (gamixAppId: string, id: string, campaignUpdateRequest: CampaignUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignsControllerUpdate', 'id', id)
            // verify required parameter 'campaignUpdateRequest' is not null or undefined
            assertParamExists('campaignsControllerUpdate', 'campaignUpdateRequest', campaignUpdateRequest)
            const localVarPath = `/v2/ecommerce/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload campaign user CSV
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerUploadCSV: async (gamixAppId: string, id: string, importRequest: ImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignsControllerUploadCSV', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignsControllerUploadCSV', 'id', id)
            // verify required parameter 'importRequest' is not null or undefined
            assertParamExists('campaignsControllerUploadCSV', 'importRequest', importRequest)
            const localVarPath = `/v2/ecommerce/campaigns/{id}/upload-csv`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignsApi - functional programming interface
 * @export
 */
export const CampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Campaign
         * @param {string} gamixAppId 
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerCreate(gamixAppId: string, campaignCreateRequest: CampaignCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerCreate(gamixAppId, campaignCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Campaigns
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary send Campaign Report
         * @param {string} gamixAppId 
         * @param {CampaignReportRequest} campaignReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerGenerateReport(gamixAppId: string, campaignReportRequest: CampaignReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerGenerateReport(gamixAppId, campaignReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerGenerateReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Campaign By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Campaign By Booster Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerGetByBoosterId(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerGetByBoosterId(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerGetByBoosterId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get campaign target count
         * @summary 
         * @param {string} gamixAppId 
         * @param {Array<CampaignsControllerGetTargetCountSourcesEnum>} sources 
         * @param {CampaignsControllerGetTargetCountTypeEnum} type 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [segmentId] 
         * @param {Array<string>} [retailerApps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerGetTargetCount(gamixAppId: string, sources: Array<CampaignsControllerGetTargetCountSourcesEnum>, type: CampaignsControllerGetTargetCountTypeEnum, startDate?: string, endDate?: string, segmentId?: string, retailerApps?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignTargetCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerGetTargetCount(gamixAppId, sources, type, startDate, endDate, segmentId, retailerApps, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerGetTargetCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Campaigns
         * @param {string} gamixAppId 
         * @param {string} [search] 
         * @param {Array<CampaignsControllerListCommunicationChannelsEnum>} [communicationChannels] 
         * @param {Array<CampaignsControllerListStatusEnum>} [status] 
         * @param {string} [sort] 
         * @param {CampaignsControllerListTypeEnum} [type] 
         * @param {string} [fromDateStart] 
         * @param {string} [fromDateEnd] 
         * @param {boolean} [active] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerList(gamixAppId: string, search?: string, communicationChannels?: Array<CampaignsControllerListCommunicationChannelsEnum>, status?: Array<CampaignsControllerListStatusEnum>, sort?: string, type?: CampaignsControllerListTypeEnum, fromDateStart?: string, fromDateEnd?: string, active?: boolean, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerList(gamixAppId, search, communicationChannels, status, sort, type, fromDateStart, fromDateEnd, active, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit the campaign
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerSubmit(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerSubmit(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerSubmit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Campaigns
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignUpdateRequest} campaignUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerUpdate(gamixAppId: string, id: string, campaignUpdateRequest: CampaignUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerUpdate(gamixAppId, id, campaignUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload campaign user CSV
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsControllerUploadCSV(gamixAppId: string, id: string, importRequest: ImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsControllerUploadCSV(gamixAppId, id, importRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.campaignsControllerUploadCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignsApi - factory interface
 * @export
 */
export const CampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Campaign
         * @param {string} gamixAppId 
         * @param {CampaignCreateRequest} campaignCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerCreate(gamixAppId: string, campaignCreateRequest: CampaignCreateRequest, options?: any): AxiosPromise<CampaignResponse> {
            return localVarFp.campaignsControllerCreate(gamixAppId, campaignCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Campaigns
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<CampaignResponse> {
            return localVarFp.campaignsControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send Campaign Report
         * @param {string} gamixAppId 
         * @param {CampaignReportRequest} campaignReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerGenerateReport(gamixAppId: string, campaignReportRequest: CampaignReportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.campaignsControllerGenerateReport(gamixAppId, campaignReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Campaign By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<CampaignResponse> {
            return localVarFp.campaignsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Campaign By Booster Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerGetByBoosterId(gamixAppId: string, id: string, options?: any): AxiosPromise<CampaignResponse> {
            return localVarFp.campaignsControllerGetByBoosterId(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get campaign target count
         * @summary 
         * @param {string} gamixAppId 
         * @param {Array<CampaignsControllerGetTargetCountSourcesEnum>} sources 
         * @param {CampaignsControllerGetTargetCountTypeEnum} type 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [segmentId] 
         * @param {Array<string>} [retailerApps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerGetTargetCount(gamixAppId: string, sources: Array<CampaignsControllerGetTargetCountSourcesEnum>, type: CampaignsControllerGetTargetCountTypeEnum, startDate?: string, endDate?: string, segmentId?: string, retailerApps?: Array<string>, options?: any): AxiosPromise<CampaignTargetCount> {
            return localVarFp.campaignsControllerGetTargetCount(gamixAppId, sources, type, startDate, endDate, segmentId, retailerApps, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Campaigns
         * @param {string} gamixAppId 
         * @param {string} [search] 
         * @param {Array<CampaignsControllerListCommunicationChannelsEnum>} [communicationChannels] 
         * @param {Array<CampaignsControllerListStatusEnum>} [status] 
         * @param {string} [sort] 
         * @param {CampaignsControllerListTypeEnum} [type] 
         * @param {string} [fromDateStart] 
         * @param {string} [fromDateEnd] 
         * @param {boolean} [active] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerList(gamixAppId: string, search?: string, communicationChannels?: Array<CampaignsControllerListCommunicationChannelsEnum>, status?: Array<CampaignsControllerListStatusEnum>, sort?: string, type?: CampaignsControllerListTypeEnum, fromDateStart?: string, fromDateEnd?: string, active?: boolean, limit?: number, skip?: number, options?: any): AxiosPromise<CampaignsResponse> {
            return localVarFp.campaignsControllerList(gamixAppId, search, communicationChannels, status, sort, type, fromDateStart, fromDateEnd, active, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit the campaign
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerSubmit(gamixAppId: string, id: string, options?: any): AxiosPromise<CampaignResponse> {
            return localVarFp.campaignsControllerSubmit(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Campaigns
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CampaignUpdateRequest} campaignUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerUpdate(gamixAppId: string, id: string, campaignUpdateRequest: CampaignUpdateRequest, options?: any): AxiosPromise<CampaignResponse> {
            return localVarFp.campaignsControllerUpdate(gamixAppId, id, campaignUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload campaign user CSV
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsControllerUploadCSV(gamixAppId: string, id: string, importRequest: ImportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.campaignsControllerUploadCSV(gamixAppId, id, importRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignsApi - object-oriented interface
 * @export
 * @class CampaignsApi
 * @extends {BaseAPI}
 */
export class CampaignsApi extends BaseAPI {
    /**
     * 
     * @summary Create Campaign
     * @param {string} gamixAppId 
     * @param {CampaignCreateRequest} campaignCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerCreate(gamixAppId: string, campaignCreateRequest: CampaignCreateRequest, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerCreate(gamixAppId, campaignCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Campaigns
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send Campaign Report
     * @param {string} gamixAppId 
     * @param {CampaignReportRequest} campaignReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerGenerateReport(gamixAppId: string, campaignReportRequest: CampaignReportRequest, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerGenerateReport(gamixAppId, campaignReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Campaign By Id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Campaign By Booster Id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerGetByBoosterId(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerGetByBoosterId(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get campaign target count
     * @summary 
     * @param {string} gamixAppId 
     * @param {Array<CampaignsControllerGetTargetCountSourcesEnum>} sources 
     * @param {CampaignsControllerGetTargetCountTypeEnum} type 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [segmentId] 
     * @param {Array<string>} [retailerApps] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerGetTargetCount(gamixAppId: string, sources: Array<CampaignsControllerGetTargetCountSourcesEnum>, type: CampaignsControllerGetTargetCountTypeEnum, startDate?: string, endDate?: string, segmentId?: string, retailerApps?: Array<string>, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerGetTargetCount(gamixAppId, sources, type, startDate, endDate, segmentId, retailerApps, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Campaigns
     * @param {string} gamixAppId 
     * @param {string} [search] 
     * @param {Array<CampaignsControllerListCommunicationChannelsEnum>} [communicationChannels] 
     * @param {Array<CampaignsControllerListStatusEnum>} [status] 
     * @param {string} [sort] 
     * @param {CampaignsControllerListTypeEnum} [type] 
     * @param {string} [fromDateStart] 
     * @param {string} [fromDateEnd] 
     * @param {boolean} [active] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerList(gamixAppId: string, search?: string, communicationChannels?: Array<CampaignsControllerListCommunicationChannelsEnum>, status?: Array<CampaignsControllerListStatusEnum>, sort?: string, type?: CampaignsControllerListTypeEnum, fromDateStart?: string, fromDateEnd?: string, active?: boolean, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerList(gamixAppId, search, communicationChannels, status, sort, type, fromDateStart, fromDateEnd, active, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit the campaign
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerSubmit(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerSubmit(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Campaigns
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {CampaignUpdateRequest} campaignUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerUpdate(gamixAppId: string, id: string, campaignUpdateRequest: CampaignUpdateRequest, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerUpdate(gamixAppId, id, campaignUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload campaign user CSV
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {ImportRequest} importRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public campaignsControllerUploadCSV(gamixAppId: string, id: string, importRequest: ImportRequest, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).campaignsControllerUploadCSV(gamixAppId, id, importRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CampaignsControllerGetTargetCountSourcesEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;
export type CampaignsControllerGetTargetCountSourcesEnum = typeof CampaignsControllerGetTargetCountSourcesEnum[keyof typeof CampaignsControllerGetTargetCountSourcesEnum];
/**
 * @export
 */
export const CampaignsControllerGetTargetCountTypeEnum = {
    PurchasedWith: 'purchasedWith',
    NewCustomer: 'newCustomer',
    AbandonedCart: 'abandonedCart',
    All: 'all',
    UploadCsv: 'uploadCsv',
    Audience: 'audience'
} as const;
export type CampaignsControllerGetTargetCountTypeEnum = typeof CampaignsControllerGetTargetCountTypeEnum[keyof typeof CampaignsControllerGetTargetCountTypeEnum];
/**
 * @export
 */
export const CampaignsControllerListCommunicationChannelsEnum = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Widget: 'widget'
} as const;
export type CampaignsControllerListCommunicationChannelsEnum = typeof CampaignsControllerListCommunicationChannelsEnum[keyof typeof CampaignsControllerListCommunicationChannelsEnum];
/**
 * @export
 */
export const CampaignsControllerListStatusEnum = {
    Draft: 'draft',
    Live: 'live',
    Completed: 'completed',
    Scheduled: 'scheduled',
    Deleted: 'deleted',
    Ended: 'ended'
} as const;
export type CampaignsControllerListStatusEnum = typeof CampaignsControllerListStatusEnum[keyof typeof CampaignsControllerListStatusEnum];
/**
 * @export
 */
export const CampaignsControllerListTypeEnum = {
    Standard: 'standard',
    Gamified: 'gamified'
} as const;
export type CampaignsControllerListTypeEnum = typeof CampaignsControllerListTypeEnum[keyof typeof CampaignsControllerListTypeEnum];


/**
 * CartApi - axios parameter creator
 * @export
 */
export const CartApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Complete Cart
         * @param {string} gamixAppId 
         * @param {string} [id] 
         * @param {string} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartControllerComplete: async (gamixAppId: string, id?: string, customer?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('cartControllerComplete', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/cart/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (customer !== undefined) {
                localVarQueryParameter['customer'] = customer;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Or Update Cart
         * @param {string} gamixAppId 
         * @param {CartRequest} cartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartControllerCreateOrUpdate: async (gamixAppId: string, cartRequest: CartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('cartControllerCreateOrUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'cartRequest' is not null or undefined
            assertParamExists('cartControllerCreateOrUpdate', 'cartRequest', cartRequest)
            const localVarPath = `/v2/ecommerce/cart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Cart
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('cartControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartControllerDelete', 'id', id)
            const localVarPath = `/v2/ecommerce/cart/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send Abandoned Cart Report
         * @param {string} gamixAppId 
         * @param {CartReportRequest} cartReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartControllerGenerateReport: async (gamixAppId: string, cartReportRequest: CartReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('cartControllerGenerateReport', 'gamixAppId', gamixAppId)
            // verify required parameter 'cartReportRequest' is not null or undefined
            assertParamExists('cartControllerGenerateReport', 'cartReportRequest', cartReportRequest)
            const localVarPath = `/v2/ecommerce/cart/export/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cartReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CartApi - functional programming interface
 * @export
 */
export const CartApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CartApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Complete Cart
         * @param {string} gamixAppId 
         * @param {string} [id] 
         * @param {string} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartControllerComplete(gamixAppId: string, id?: string, customer?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartControllerComplete(gamixAppId, id, customer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartApi.cartControllerComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Or Update Cart
         * @param {string} gamixAppId 
         * @param {CartRequest} cartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartControllerCreateOrUpdate(gamixAppId: string, cartRequest: CartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartControllerCreateOrUpdate(gamixAppId, cartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartApi.cartControllerCreateOrUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Cart
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartApi.cartControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary send Abandoned Cart Report
         * @param {string} gamixAppId 
         * @param {CartReportRequest} cartReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartControllerGenerateReport(gamixAppId: string, cartReportRequest: CartReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartControllerGenerateReport(gamixAppId, cartReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartApi.cartControllerGenerateReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CartApi - factory interface
 * @export
 */
export const CartApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CartApiFp(configuration)
    return {
        /**
         * 
         * @summary Complete Cart
         * @param {string} gamixAppId 
         * @param {string} [id] 
         * @param {string} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartControllerComplete(gamixAppId: string, id?: string, customer?: string, options?: any): AxiosPromise<CartResponse> {
            return localVarFp.cartControllerComplete(gamixAppId, id, customer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Or Update Cart
         * @param {string} gamixAppId 
         * @param {CartRequest} cartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartControllerCreateOrUpdate(gamixAppId: string, cartRequest: CartRequest, options?: any): AxiosPromise<CartResponse> {
            return localVarFp.cartControllerCreateOrUpdate(gamixAppId, cartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Cart
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.cartControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send Abandoned Cart Report
         * @param {string} gamixAppId 
         * @param {CartReportRequest} cartReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartControllerGenerateReport(gamixAppId: string, cartReportRequest: CartReportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.cartControllerGenerateReport(gamixAppId, cartReportRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CartApi - object-oriented interface
 * @export
 * @class CartApi
 * @extends {BaseAPI}
 */
export class CartApi extends BaseAPI {
    /**
     * 
     * @summary Complete Cart
     * @param {string} gamixAppId 
     * @param {string} [id] 
     * @param {string} [customer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartControllerComplete(gamixAppId: string, id?: string, customer?: string, options?: RawAxiosRequestConfig) {
        return CartApiFp(this.configuration).cartControllerComplete(gamixAppId, id, customer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Or Update Cart
     * @param {string} gamixAppId 
     * @param {CartRequest} cartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartControllerCreateOrUpdate(gamixAppId: string, cartRequest: CartRequest, options?: RawAxiosRequestConfig) {
        return CartApiFp(this.configuration).cartControllerCreateOrUpdate(gamixAppId, cartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Cart
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CartApiFp(this.configuration).cartControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send Abandoned Cart Report
     * @param {string} gamixAppId 
     * @param {CartReportRequest} cartReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartControllerGenerateReport(gamixAppId: string, cartReportRequest: CartReportRequest, options?: RawAxiosRequestConfig) {
        return CartApiFp(this.configuration).cartControllerGenerateReport(gamixAppId, cartReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CashbackCampaignUsersApi - axios parameter creator
 * @export
 */
export const CashbackCampaignUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get active campaign user referee
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUsersControllerGetActiveCampaignUserReferee: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignUsersControllerGetActiveCampaignUserReferee', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/campaign-users/referee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Campaign user for specific campaign
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUsersControllerGetCampaignUser: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignUsersControllerGetCampaignUser', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('campaignUsersControllerGetCampaignUser', 'id', id)
            const localVarPath = `/v2/ecommerce/campaign-users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active campaign users by authorized user
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUsersControllerGetCampaignUsers: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('campaignUsersControllerGetCampaignUsers', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/campaign-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashbackCampaignUsersApi - functional programming interface
 * @export
 */
export const CashbackCampaignUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CashbackCampaignUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get active campaign user referee
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignUsersControllerGetActiveCampaignUserReferee(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignUsersByRefereeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignUsersControllerGetActiveCampaignUserReferee(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackCampaignUsersApi.campaignUsersControllerGetActiveCampaignUserReferee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Campaign user for specific campaign
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignUsersControllerGetCampaignUser(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignUsersControllerGetCampaignUser(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackCampaignUsersApi.campaignUsersControllerGetCampaignUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get active campaign users by authorized user
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignUsersControllerGetCampaignUsers(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignUsersControllerGetCampaignUsers(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackCampaignUsersApi.campaignUsersControllerGetCampaignUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CashbackCampaignUsersApi - factory interface
 * @export
 */
export const CashbackCampaignUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CashbackCampaignUsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get active campaign user referee
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUsersControllerGetActiveCampaignUserReferee(gamixAppId: string, options?: any): AxiosPromise<CampaignUsersByRefereeResponse> {
            return localVarFp.campaignUsersControllerGetActiveCampaignUserReferee(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Campaign user for specific campaign
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUsersControllerGetCampaignUser(gamixAppId: string, id: string, options?: any): AxiosPromise<CampaignUserResponse> {
            return localVarFp.campaignUsersControllerGetCampaignUser(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active campaign users by authorized user
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUsersControllerGetCampaignUsers(gamixAppId: string, options?: any): AxiosPromise<CampaignUsersResponse> {
            return localVarFp.campaignUsersControllerGetCampaignUsers(gamixAppId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CashbackCampaignUsersApi - object-oriented interface
 * @export
 * @class CashbackCampaignUsersApi
 * @extends {BaseAPI}
 */
export class CashbackCampaignUsersApi extends BaseAPI {
    /**
     * 
     * @summary Get active campaign user referee
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackCampaignUsersApi
     */
    public campaignUsersControllerGetActiveCampaignUserReferee(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return CashbackCampaignUsersApiFp(this.configuration).campaignUsersControllerGetActiveCampaignUserReferee(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Campaign user for specific campaign
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackCampaignUsersApi
     */
    public campaignUsersControllerGetCampaignUser(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CashbackCampaignUsersApiFp(this.configuration).campaignUsersControllerGetCampaignUser(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active campaign users by authorized user
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackCampaignUsersApi
     */
    public campaignUsersControllerGetCampaignUsers(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return CashbackCampaignUsersApiFp(this.configuration).campaignUsersControllerGetCampaignUsers(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CashbackPopupsApi - axios parameter creator
 * @export
 */
export const CashbackPopupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get By UTM Campaign
         * @param {string} gamixAppId 
         * @param {string} utmCampaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackPopupControllerGetCashbackPopup: async (gamixAppId: string, utmCampaign: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('cashbackPopupControllerGetCashbackPopup', 'gamixAppId', gamixAppId)
            // verify required parameter 'utmCampaign' is not null or undefined
            assertParamExists('cashbackPopupControllerGetCashbackPopup', 'utmCampaign', utmCampaign)
            const localVarPath = `/v2/ecommerce/app-cashback-popups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (utmCampaign !== undefined) {
                localVarQueryParameter['utmCampaign'] = utmCampaign;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashbackPopupsApi - functional programming interface
 * @export
 */
export const CashbackPopupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CashbackPopupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get By UTM Campaign
         * @param {string} gamixAppId 
         * @param {string} utmCampaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackPopupControllerGetCashbackPopup(gamixAppId: string, utmCampaign: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackPopupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackPopupControllerGetCashbackPopup(gamixAppId, utmCampaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackPopupsApi.cashbackPopupControllerGetCashbackPopup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CashbackPopupsApi - factory interface
 * @export
 */
export const CashbackPopupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CashbackPopupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get By UTM Campaign
         * @param {string} gamixAppId 
         * @param {string} utmCampaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackPopupControllerGetCashbackPopup(gamixAppId: string, utmCampaign: string, options?: any): AxiosPromise<CashbackPopupResponse> {
            return localVarFp.cashbackPopupControllerGetCashbackPopup(gamixAppId, utmCampaign, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CashbackPopupsApi - object-oriented interface
 * @export
 * @class CashbackPopupsApi
 * @extends {BaseAPI}
 */
export class CashbackPopupsApi extends BaseAPI {
    /**
     * 
     * @summary Get By UTM Campaign
     * @param {string} gamixAppId 
     * @param {string} utmCampaign 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackPopupsApi
     */
    public cashbackPopupControllerGetCashbackPopup(gamixAppId: string, utmCampaign: string, options?: RawAxiosRequestConfig) {
        return CashbackPopupsApiFp(this.configuration).cashbackPopupControllerGetCashbackPopup(gamixAppId, utmCampaign, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Category by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoriesControllerGetCategory: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('categoriesControllerGetCategory', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('categoriesControllerGetCategory', 'id', id)
            const localVarPath = `/v2/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Product Categories
         * @param {string} gamixAppId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoriesControllerListCategories: async (gamixAppId: string, search?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('categoriesControllerListCategories', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Category by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categoriesControllerGetCategory(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesControllerGetCategory(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.categoriesControllerGetCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Product Categories
         * @param {string} gamixAppId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categoriesControllerListCategories(gamixAppId: string, search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesControllerListCategories(gamixAppId, search, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesApi.categoriesControllerListCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Category by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoriesControllerGetCategory(gamixAppId: string, id: string, options?: any): AxiosPromise<CategoryResponse> {
            return localVarFp.categoriesControllerGetCategory(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Product Categories
         * @param {string} gamixAppId 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoriesControllerListCategories(gamixAppId: string, search?: string, limit?: number, skip?: number, options?: any): AxiosPromise<CategoriesResponse> {
            return localVarFp.categoriesControllerListCategories(gamixAppId, search, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Get Category by id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public categoriesControllerGetCategory(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).categoriesControllerGetCategory(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Product Categories
     * @param {string} gamixAppId 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public categoriesControllerListCategories(gamixAppId: string, search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).categoriesControllerListCategories(gamixAppId, search, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsControllerIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async alertsControllerIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.alertsControllerIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.alertsControllerIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appControllerHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appControllerHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.appControllerHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsControllerIndex(options?: any): AxiosPromise<void> {
            return localVarFp.alertsControllerIndex(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerHealthCheck(options?: any): AxiosPromise<void> {
            return localVarFp.appControllerHealthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public alertsControllerIndex(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).alertsControllerIndex(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public appControllerHealthCheck(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).appControllerHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiscountCashbackValidatorApi - axios parameter creator
 * @export
 */
export const DiscountCashbackValidatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Discount codes
         * @param {string} gamixAppId 
         * @param {DiscountCashbackValidatorRequest} discountCashbackValidatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCashbackValidatorControllerCreateDiscountCashbackValidator: async (gamixAppId: string, discountCashbackValidatorRequest: DiscountCashbackValidatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountCashbackValidatorControllerCreateDiscountCashbackValidator', 'gamixAppId', gamixAppId)
            // verify required parameter 'discountCashbackValidatorRequest' is not null or undefined
            assertParamExists('discountCashbackValidatorControllerCreateDiscountCashbackValidator', 'discountCashbackValidatorRequest', discountCashbackValidatorRequest)
            const localVarPath = `/v2/ecommerce/discount-validator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discountCashbackValidatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Discount codes
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {DiscountCashbackValidatorRequest} discountCashbackValidatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCashbackValidatorControllerUpdateDiscountCashbackValidator: async (gamixAppId: string, id: string, discountCashbackValidatorRequest: DiscountCashbackValidatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountCashbackValidatorControllerUpdateDiscountCashbackValidator', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('discountCashbackValidatorControllerUpdateDiscountCashbackValidator', 'id', id)
            // verify required parameter 'discountCashbackValidatorRequest' is not null or undefined
            assertParamExists('discountCashbackValidatorControllerUpdateDiscountCashbackValidator', 'discountCashbackValidatorRequest', discountCashbackValidatorRequest)
            const localVarPath = `/v2/ecommerce/discount-validator/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discountCashbackValidatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Discount codes CSV
         * @param {string} gamixAppId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCashbackValidatorControllerUploadCSV: async (gamixAppId: string, importRequest: ImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountCashbackValidatorControllerUploadCSV', 'gamixAppId', gamixAppId)
            // verify required parameter 'importRequest' is not null or undefined
            assertParamExists('discountCashbackValidatorControllerUploadCSV', 'importRequest', importRequest)
            const localVarPath = `/v2/ecommerce/discount-validator/upload-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountCashbackValidatorApi - functional programming interface
 * @export
 */
export const DiscountCashbackValidatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountCashbackValidatorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Discount codes
         * @param {string} gamixAppId 
         * @param {DiscountCashbackValidatorRequest} discountCashbackValidatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountCashbackValidatorControllerCreateDiscountCashbackValidator(gamixAppId: string, discountCashbackValidatorRequest: DiscountCashbackValidatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountCashbackValidatorControllerCreateDiscountCashbackValidator(gamixAppId, discountCashbackValidatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountCashbackValidatorApi.discountCashbackValidatorControllerCreateDiscountCashbackValidator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Discount codes
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {DiscountCashbackValidatorRequest} discountCashbackValidatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountCashbackValidatorControllerUpdateDiscountCashbackValidator(gamixAppId: string, id: string, discountCashbackValidatorRequest: DiscountCashbackValidatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountCashbackValidatorControllerUpdateDiscountCashbackValidator(gamixAppId, id, discountCashbackValidatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountCashbackValidatorApi.discountCashbackValidatorControllerUpdateDiscountCashbackValidator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Discount codes CSV
         * @param {string} gamixAppId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountCashbackValidatorControllerUploadCSV(gamixAppId: string, importRequest: ImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountCashbackValidatorControllerUploadCSV(gamixAppId, importRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountCashbackValidatorApi.discountCashbackValidatorControllerUploadCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscountCashbackValidatorApi - factory interface
 * @export
 */
export const DiscountCashbackValidatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountCashbackValidatorApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Discount codes
         * @param {string} gamixAppId 
         * @param {DiscountCashbackValidatorRequest} discountCashbackValidatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCashbackValidatorControllerCreateDiscountCashbackValidator(gamixAppId: string, discountCashbackValidatorRequest: DiscountCashbackValidatorRequest, options?: any): AxiosPromise<void> {
            return localVarFp.discountCashbackValidatorControllerCreateDiscountCashbackValidator(gamixAppId, discountCashbackValidatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Discount codes
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {DiscountCashbackValidatorRequest} discountCashbackValidatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCashbackValidatorControllerUpdateDiscountCashbackValidator(gamixAppId: string, id: string, discountCashbackValidatorRequest: DiscountCashbackValidatorRequest, options?: any): AxiosPromise<void> {
            return localVarFp.discountCashbackValidatorControllerUpdateDiscountCashbackValidator(gamixAppId, id, discountCashbackValidatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Discount codes CSV
         * @param {string} gamixAppId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCashbackValidatorControllerUploadCSV(gamixAppId: string, importRequest: ImportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.discountCashbackValidatorControllerUploadCSV(gamixAppId, importRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiscountCashbackValidatorApi - object-oriented interface
 * @export
 * @class DiscountCashbackValidatorApi
 * @extends {BaseAPI}
 */
export class DiscountCashbackValidatorApi extends BaseAPI {
    /**
     * 
     * @summary Create Discount codes
     * @param {string} gamixAppId 
     * @param {DiscountCashbackValidatorRequest} discountCashbackValidatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCashbackValidatorApi
     */
    public discountCashbackValidatorControllerCreateDiscountCashbackValidator(gamixAppId: string, discountCashbackValidatorRequest: DiscountCashbackValidatorRequest, options?: RawAxiosRequestConfig) {
        return DiscountCashbackValidatorApiFp(this.configuration).discountCashbackValidatorControllerCreateDiscountCashbackValidator(gamixAppId, discountCashbackValidatorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Discount codes
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {DiscountCashbackValidatorRequest} discountCashbackValidatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCashbackValidatorApi
     */
    public discountCashbackValidatorControllerUpdateDiscountCashbackValidator(gamixAppId: string, id: string, discountCashbackValidatorRequest: DiscountCashbackValidatorRequest, options?: RawAxiosRequestConfig) {
        return DiscountCashbackValidatorApiFp(this.configuration).discountCashbackValidatorControllerUpdateDiscountCashbackValidator(gamixAppId, id, discountCashbackValidatorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Discount codes CSV
     * @param {string} gamixAppId 
     * @param {ImportRequest} importRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCashbackValidatorApi
     */
    public discountCashbackValidatorControllerUploadCSV(gamixAppId: string, importRequest: ImportRequest, options?: RawAxiosRequestConfig) {
        return DiscountCashbackValidatorApiFp(this.configuration).discountCashbackValidatorControllerUploadCSV(gamixAppId, importRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiscountsApi - axios parameter creator
 * @export
 */
export const DiscountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary export discounts data
         * @param {string} gamixAppId 
         * @param {DiscountExportRequest} discountExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerExportData: async (gamixAppId: string, discountExportRequest: DiscountExportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountsControllerExportData', 'gamixAppId', gamixAppId)
            // verify required parameter 'discountExportRequest' is not null or undefined
            assertParamExists('discountsControllerExportData', 'discountExportRequest', discountExportRequest)
            const localVarPath = `/v2/ecommerce/discounts/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discountExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Discount By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('discountsControllerGet', 'id', id)
            const localVarPath = `/v2/ecommerce/discounts/discount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cashback Summary For User
         * @param {string} gamixAppId 
         * @param {string} userId User identifier
         * @param {number} amount Order amount
         * @param {DiscountsControllerGetCashbackSummaryOrderSourceEnum} [orderSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerGetCashbackSummary: async (gamixAppId: string, userId: string, amount: number, orderSource?: DiscountsControllerGetCashbackSummaryOrderSourceEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountsControllerGetCashbackSummary', 'gamixAppId', gamixAppId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('discountsControllerGetCashbackSummary', 'userId', userId)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('discountsControllerGetCashbackSummary', 'amount', amount)
            const localVarPath = `/v2/ecommerce/discounts/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (orderSource !== undefined) {
                localVarQueryParameter['orderSource'] = orderSource;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cashback Summary by user
         * @param {string} gamixAppId 
         * @param {number} amount Order amount
         * @param {DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum} [orderSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerGetCashbackSummaryByUser: async (gamixAppId: string, amount: number, orderSource?: DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountsControllerGetCashbackSummaryByUser', 'gamixAppId', gamixAppId)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('discountsControllerGetCashbackSummaryByUser', 'amount', amount)
            const localVarPath = `/v2/ecommerce/discounts/user/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (orderSource !== undefined) {
                localVarQueryParameter['orderSource'] = orderSource;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get discounts totals for analytics
         * @param {string} gamixAppId 
         * @param {string} minCreatedAt 
         * @param {string} maxCreatedAt 
         * @param {Array<DiscountsControllerGetTotalsSourcesEnum>} sources 
         * @param {Array<string>} [salesRepGroups] 
         * @param {Array<string>} [salesRepIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerGetTotals: async (gamixAppId: string, minCreatedAt: string, maxCreatedAt: string, sources: Array<DiscountsControllerGetTotalsSourcesEnum>, salesRepGroups?: Array<string>, salesRepIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountsControllerGetTotals', 'gamixAppId', gamixAppId)
            // verify required parameter 'minCreatedAt' is not null or undefined
            assertParamExists('discountsControllerGetTotals', 'minCreatedAt', minCreatedAt)
            // verify required parameter 'maxCreatedAt' is not null or undefined
            assertParamExists('discountsControllerGetTotals', 'maxCreatedAt', maxCreatedAt)
            // verify required parameter 'sources' is not null or undefined
            assertParamExists('discountsControllerGetTotals', 'sources', sources)
            const localVarPath = `/v2/ecommerce/discounts/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minCreatedAt !== undefined) {
                localVarQueryParameter['minCreatedAt'] = (minCreatedAt as any instanceof Date) ?
                    (minCreatedAt as any).toISOString() :
                    minCreatedAt;
            }

            if (maxCreatedAt !== undefined) {
                localVarQueryParameter['maxCreatedAt'] = (maxCreatedAt as any instanceof Date) ?
                    (maxCreatedAt as any).toISOString() :
                    maxCreatedAt;
            }

            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }

            if (salesRepGroups) {
                localVarQueryParameter['salesRepGroups'] = salesRepGroups;
            }

            if (salesRepIds) {
                localVarQueryParameter['salesRepIds'] = salesRepIds;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Discounts
         * @param {string} gamixAppId 
         * @param {DiscountsControllerListDiscountStatusEnum} [discountStatus] 
         * @param {DiscountsControllerListSourceEnum} [source] 
         * @param {string} [sort] 
         * @param {string} [code] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerList: async (gamixAppId: string, discountStatus?: DiscountsControllerListDiscountStatusEnum, source?: DiscountsControllerListSourceEnum, sort?: string, code?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/discounts/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (discountStatus !== undefined) {
                localVarQueryParameter['discountStatus'] = discountStatus;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Discounts
         * @param {string} gamixAppId 
         * @param {DiscountsControllerListByAdminDiscountStatusEnum} [discountStatus] 
         * @param {DiscountsControllerListByAdminSourceEnum} [source] 
         * @param {string} [sort] 
         * @param {string} [code] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerListByAdmin: async (gamixAppId: string, discountStatus?: DiscountsControllerListByAdminDiscountStatusEnum, source?: DiscountsControllerListByAdminSourceEnum, sort?: string, code?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountsControllerListByAdmin', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/discounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (discountStatus !== undefined) {
                localVarQueryParameter['discountStatus'] = discountStatus;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Discount By Id
         * @param {string} gamixAppId 
         * @param {string} discountId 
         * @param {UpdateRequest} updateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerUpdateDiscount: async (gamixAppId: string, discountId: string, updateRequest: UpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('discountsControllerUpdateDiscount', 'gamixAppId', gamixAppId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('discountsControllerUpdateDiscount', 'discountId', discountId)
            // verify required parameter 'updateRequest' is not null or undefined
            assertParamExists('discountsControllerUpdateDiscount', 'updateRequest', updateRequest)
            const localVarPath = `/v2/ecommerce/discounts/{discountId}`
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply discount to items
         * @param {string} gamixAppId 
         * @param {ApplyDiscountRequest} applyDiscountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualDiscountsControllerApply: async (gamixAppId: string, applyDiscountRequest: ApplyDiscountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('manualDiscountsControllerApply', 'gamixAppId', gamixAppId)
            // verify required parameter 'applyDiscountRequest' is not null or undefined
            assertParamExists('manualDiscountsControllerApply', 'applyDiscountRequest', applyDiscountRequest)
            const localVarPath = `/v2/ecommerce/discounts/manual/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyDiscountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear cart discounts
         * @param {string} gamixAppId 
         * @param {ClearDiscountRequest} clearDiscountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualDiscountsControllerClear: async (gamixAppId: string, clearDiscountRequest: ClearDiscountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('manualDiscountsControllerClear', 'gamixAppId', gamixAppId)
            // verify required parameter 'clearDiscountRequest' is not null or undefined
            assertParamExists('manualDiscountsControllerClear', 'clearDiscountRequest', clearDiscountRequest)
            const localVarPath = `/v2/ecommerce/discounts/manual/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clearDiscountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountsApi - functional programming interface
 * @export
 */
export const DiscountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary export discounts data
         * @param {string} gamixAppId 
         * @param {DiscountExportRequest} discountExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountsControllerExportData(gamixAppId: string, discountExportRequest: DiscountExportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountsControllerExportData(gamixAppId, discountExportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.discountsControllerExportData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Discount By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.discountsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cashback Summary For User
         * @param {string} gamixAppId 
         * @param {string} userId User identifier
         * @param {number} amount Order amount
         * @param {DiscountsControllerGetCashbackSummaryOrderSourceEnum} [orderSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountsControllerGetCashbackSummary(gamixAppId: string, userId: string, amount: number, orderSource?: DiscountsControllerGetCashbackSummaryOrderSourceEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountsControllerGetCashbackSummary(gamixAppId, userId, amount, orderSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.discountsControllerGetCashbackSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cashback Summary by user
         * @param {string} gamixAppId 
         * @param {number} amount Order amount
         * @param {DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum} [orderSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountsControllerGetCashbackSummaryByUser(gamixAppId: string, amount: number, orderSource?: DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountsControllerGetCashbackSummaryByUser(gamixAppId, amount, orderSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.discountsControllerGetCashbackSummaryByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get discounts totals for analytics
         * @param {string} gamixAppId 
         * @param {string} minCreatedAt 
         * @param {string} maxCreatedAt 
         * @param {Array<DiscountsControllerGetTotalsSourcesEnum>} sources 
         * @param {Array<string>} [salesRepGroups] 
         * @param {Array<string>} [salesRepIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountsControllerGetTotals(gamixAppId: string, minCreatedAt: string, maxCreatedAt: string, sources: Array<DiscountsControllerGetTotalsSourcesEnum>, salesRepGroups?: Array<string>, salesRepIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountsTotalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountsControllerGetTotals(gamixAppId, minCreatedAt, maxCreatedAt, sources, salesRepGroups, salesRepIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.discountsControllerGetTotals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Discounts
         * @param {string} gamixAppId 
         * @param {DiscountsControllerListDiscountStatusEnum} [discountStatus] 
         * @param {DiscountsControllerListSourceEnum} [source] 
         * @param {string} [sort] 
         * @param {string} [code] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountsControllerList(gamixAppId: string, discountStatus?: DiscountsControllerListDiscountStatusEnum, source?: DiscountsControllerListSourceEnum, sort?: string, code?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountsControllerList(gamixAppId, discountStatus, source, sort, code, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.discountsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Discounts
         * @param {string} gamixAppId 
         * @param {DiscountsControllerListByAdminDiscountStatusEnum} [discountStatus] 
         * @param {DiscountsControllerListByAdminSourceEnum} [source] 
         * @param {string} [sort] 
         * @param {string} [code] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountsControllerListByAdmin(gamixAppId: string, discountStatus?: DiscountsControllerListByAdminDiscountStatusEnum, source?: DiscountsControllerListByAdminSourceEnum, sort?: string, code?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountsPopulatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountsControllerListByAdmin(gamixAppId, discountStatus, source, sort, code, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.discountsControllerListByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Discount By Id
         * @param {string} gamixAppId 
         * @param {string} discountId 
         * @param {UpdateRequest} updateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountsControllerUpdateDiscount(gamixAppId: string, discountId: string, updateRequest: UpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountsControllerUpdateDiscount(gamixAppId, discountId, updateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.discountsControllerUpdateDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Apply discount to items
         * @param {string} gamixAppId 
         * @param {ApplyDiscountRequest} applyDiscountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manualDiscountsControllerApply(gamixAppId: string, applyDiscountRequest: ApplyDiscountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manualDiscountsControllerApply(gamixAppId, applyDiscountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.manualDiscountsControllerApply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Clear cart discounts
         * @param {string} gamixAppId 
         * @param {ClearDiscountRequest} clearDiscountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manualDiscountsControllerClear(gamixAppId: string, clearDiscountRequest: ClearDiscountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manualDiscountsControllerClear(gamixAppId, clearDiscountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.manualDiscountsControllerClear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscountsApi - factory interface
 * @export
 */
export const DiscountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountsApiFp(configuration)
    return {
        /**
         * 
         * @summary export discounts data
         * @param {string} gamixAppId 
         * @param {DiscountExportRequest} discountExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerExportData(gamixAppId: string, discountExportRequest: DiscountExportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.discountsControllerExportData(gamixAppId, discountExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Discount By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<DiscountResponse> {
            return localVarFp.discountsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cashback Summary For User
         * @param {string} gamixAppId 
         * @param {string} userId User identifier
         * @param {number} amount Order amount
         * @param {DiscountsControllerGetCashbackSummaryOrderSourceEnum} [orderSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerGetCashbackSummary(gamixAppId: string, userId: string, amount: number, orderSource?: DiscountsControllerGetCashbackSummaryOrderSourceEnum, options?: any): AxiosPromise<CashbackSummaryResponse> {
            return localVarFp.discountsControllerGetCashbackSummary(gamixAppId, userId, amount, orderSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cashback Summary by user
         * @param {string} gamixAppId 
         * @param {number} amount Order amount
         * @param {DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum} [orderSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerGetCashbackSummaryByUser(gamixAppId: string, amount: number, orderSource?: DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum, options?: any): AxiosPromise<CashbackSummaryResponse> {
            return localVarFp.discountsControllerGetCashbackSummaryByUser(gamixAppId, amount, orderSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get discounts totals for analytics
         * @param {string} gamixAppId 
         * @param {string} minCreatedAt 
         * @param {string} maxCreatedAt 
         * @param {Array<DiscountsControllerGetTotalsSourcesEnum>} sources 
         * @param {Array<string>} [salesRepGroups] 
         * @param {Array<string>} [salesRepIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerGetTotals(gamixAppId: string, minCreatedAt: string, maxCreatedAt: string, sources: Array<DiscountsControllerGetTotalsSourcesEnum>, salesRepGroups?: Array<string>, salesRepIds?: Array<string>, options?: any): AxiosPromise<DiscountsTotalsResponse> {
            return localVarFp.discountsControllerGetTotals(gamixAppId, minCreatedAt, maxCreatedAt, sources, salesRepGroups, salesRepIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Discounts
         * @param {string} gamixAppId 
         * @param {DiscountsControllerListDiscountStatusEnum} [discountStatus] 
         * @param {DiscountsControllerListSourceEnum} [source] 
         * @param {string} [sort] 
         * @param {string} [code] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerList(gamixAppId: string, discountStatus?: DiscountsControllerListDiscountStatusEnum, source?: DiscountsControllerListSourceEnum, sort?: string, code?: string, limit?: number, skip?: number, options?: any): AxiosPromise<DiscountsResponse> {
            return localVarFp.discountsControllerList(gamixAppId, discountStatus, source, sort, code, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Discounts
         * @param {string} gamixAppId 
         * @param {DiscountsControllerListByAdminDiscountStatusEnum} [discountStatus] 
         * @param {DiscountsControllerListByAdminSourceEnum} [source] 
         * @param {string} [sort] 
         * @param {string} [code] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerListByAdmin(gamixAppId: string, discountStatus?: DiscountsControllerListByAdminDiscountStatusEnum, source?: DiscountsControllerListByAdminSourceEnum, sort?: string, code?: string, limit?: number, skip?: number, options?: any): AxiosPromise<DiscountsPopulatedResponse> {
            return localVarFp.discountsControllerListByAdmin(gamixAppId, discountStatus, source, sort, code, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Discount By Id
         * @param {string} gamixAppId 
         * @param {string} discountId 
         * @param {UpdateRequest} updateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountsControllerUpdateDiscount(gamixAppId: string, discountId: string, updateRequest: UpdateRequest, options?: any): AxiosPromise<DiscountResponse> {
            return localVarFp.discountsControllerUpdateDiscount(gamixAppId, discountId, updateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply discount to items
         * @param {string} gamixAppId 
         * @param {ApplyDiscountRequest} applyDiscountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualDiscountsControllerApply(gamixAppId: string, applyDiscountRequest: ApplyDiscountRequest, options?: any): AxiosPromise<void> {
            return localVarFp.manualDiscountsControllerApply(gamixAppId, applyDiscountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clear cart discounts
         * @param {string} gamixAppId 
         * @param {ClearDiscountRequest} clearDiscountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualDiscountsControllerClear(gamixAppId: string, clearDiscountRequest: ClearDiscountRequest, options?: any): AxiosPromise<void> {
            return localVarFp.manualDiscountsControllerClear(gamixAppId, clearDiscountRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiscountsApi - object-oriented interface
 * @export
 * @class DiscountsApi
 * @extends {BaseAPI}
 */
export class DiscountsApi extends BaseAPI {
    /**
     * 
     * @summary export discounts data
     * @param {string} gamixAppId 
     * @param {DiscountExportRequest} discountExportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public discountsControllerExportData(gamixAppId: string, discountExportRequest: DiscountExportRequest, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).discountsControllerExportData(gamixAppId, discountExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Discount By Id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public discountsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).discountsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cashback Summary For User
     * @param {string} gamixAppId 
     * @param {string} userId User identifier
     * @param {number} amount Order amount
     * @param {DiscountsControllerGetCashbackSummaryOrderSourceEnum} [orderSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public discountsControllerGetCashbackSummary(gamixAppId: string, userId: string, amount: number, orderSource?: DiscountsControllerGetCashbackSummaryOrderSourceEnum, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).discountsControllerGetCashbackSummary(gamixAppId, userId, amount, orderSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cashback Summary by user
     * @param {string} gamixAppId 
     * @param {number} amount Order amount
     * @param {DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum} [orderSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public discountsControllerGetCashbackSummaryByUser(gamixAppId: string, amount: number, orderSource?: DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).discountsControllerGetCashbackSummaryByUser(gamixAppId, amount, orderSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get discounts totals for analytics
     * @param {string} gamixAppId 
     * @param {string} minCreatedAt 
     * @param {string} maxCreatedAt 
     * @param {Array<DiscountsControllerGetTotalsSourcesEnum>} sources 
     * @param {Array<string>} [salesRepGroups] 
     * @param {Array<string>} [salesRepIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public discountsControllerGetTotals(gamixAppId: string, minCreatedAt: string, maxCreatedAt: string, sources: Array<DiscountsControllerGetTotalsSourcesEnum>, salesRepGroups?: Array<string>, salesRepIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).discountsControllerGetTotals(gamixAppId, minCreatedAt, maxCreatedAt, sources, salesRepGroups, salesRepIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Discounts
     * @param {string} gamixAppId 
     * @param {DiscountsControllerListDiscountStatusEnum} [discountStatus] 
     * @param {DiscountsControllerListSourceEnum} [source] 
     * @param {string} [sort] 
     * @param {string} [code] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public discountsControllerList(gamixAppId: string, discountStatus?: DiscountsControllerListDiscountStatusEnum, source?: DiscountsControllerListSourceEnum, sort?: string, code?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).discountsControllerList(gamixAppId, discountStatus, source, sort, code, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Discounts
     * @param {string} gamixAppId 
     * @param {DiscountsControllerListByAdminDiscountStatusEnum} [discountStatus] 
     * @param {DiscountsControllerListByAdminSourceEnum} [source] 
     * @param {string} [sort] 
     * @param {string} [code] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public discountsControllerListByAdmin(gamixAppId: string, discountStatus?: DiscountsControllerListByAdminDiscountStatusEnum, source?: DiscountsControllerListByAdminSourceEnum, sort?: string, code?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).discountsControllerListByAdmin(gamixAppId, discountStatus, source, sort, code, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Discount By Id
     * @param {string} gamixAppId 
     * @param {string} discountId 
     * @param {UpdateRequest} updateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public discountsControllerUpdateDiscount(gamixAppId: string, discountId: string, updateRequest: UpdateRequest, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).discountsControllerUpdateDiscount(gamixAppId, discountId, updateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply discount to items
     * @param {string} gamixAppId 
     * @param {ApplyDiscountRequest} applyDiscountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public manualDiscountsControllerApply(gamixAppId: string, applyDiscountRequest: ApplyDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).manualDiscountsControllerApply(gamixAppId, applyDiscountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clear cart discounts
     * @param {string} gamixAppId 
     * @param {ClearDiscountRequest} clearDiscountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public manualDiscountsControllerClear(gamixAppId: string, clearDiscountRequest: ClearDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).manualDiscountsControllerClear(gamixAppId, clearDiscountRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DiscountsControllerGetCashbackSummaryOrderSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;
export type DiscountsControllerGetCashbackSummaryOrderSourceEnum = typeof DiscountsControllerGetCashbackSummaryOrderSourceEnum[keyof typeof DiscountsControllerGetCashbackSummaryOrderSourceEnum];
/**
 * @export
 */
export const DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;
export type DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum = typeof DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum[keyof typeof DiscountsControllerGetCashbackSummaryByUserOrderSourceEnum];
/**
 * @export
 */
export const DiscountsControllerGetTotalsSourcesEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;
export type DiscountsControllerGetTotalsSourcesEnum = typeof DiscountsControllerGetTotalsSourcesEnum[keyof typeof DiscountsControllerGetTotalsSourcesEnum];
/**
 * @export
 */
export const DiscountsControllerListDiscountStatusEnum = {
    Used: 'used',
    Valid: 'valid',
    Expired: 'expired',
    Returned: 'returned',
    Cancelled: 'cancelled',
    Pending: 'pending'
} as const;
export type DiscountsControllerListDiscountStatusEnum = typeof DiscountsControllerListDiscountStatusEnum[keyof typeof DiscountsControllerListDiscountStatusEnum];
/**
 * @export
 */
export const DiscountsControllerListSourceEnum = {
    OnlineOrder: 'onlineOrder',
    OfflineOrder: 'offlineOrder',
    WelcomeGift: 'WelcomeGift',
    Campaign: 'campaign',
    Points: 'points',
    Flows: 'flows'
} as const;
export type DiscountsControllerListSourceEnum = typeof DiscountsControllerListSourceEnum[keyof typeof DiscountsControllerListSourceEnum];
/**
 * @export
 */
export const DiscountsControllerListByAdminDiscountStatusEnum = {
    Used: 'used',
    Valid: 'valid',
    Expired: 'expired',
    Returned: 'returned',
    Cancelled: 'cancelled',
    Pending: 'pending'
} as const;
export type DiscountsControllerListByAdminDiscountStatusEnum = typeof DiscountsControllerListByAdminDiscountStatusEnum[keyof typeof DiscountsControllerListByAdminDiscountStatusEnum];
/**
 * @export
 */
export const DiscountsControllerListByAdminSourceEnum = {
    OnlineOrder: 'onlineOrder',
    OfflineOrder: 'offlineOrder',
    WelcomeGift: 'WelcomeGift',
    Campaign: 'campaign',
    Points: 'points',
    Flows: 'flows'
} as const;
export type DiscountsControllerListByAdminSourceEnum = typeof DiscountsControllerListByAdminSourceEnum[keyof typeof DiscountsControllerListByAdminSourceEnum];


/**
 * FreeShippingCodesApi - axios parameter creator
 * @export
 */
export const FreeShippingCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get free shipping code by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeShippingCodesControllerGetById: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('freeShippingCodesControllerGetById', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('freeShippingCodesControllerGetById', 'id', id)
            const localVarPath = `/v2/free-shipping/codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list free shipping codes for user
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeShippingCodesControllerListByUser: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('freeShippingCodesControllerListByUser', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/free-shipping/codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary redeem free shipping code
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeShippingCodesControllerRedeem: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('freeShippingCodesControllerRedeem', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/free-shipping/codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update free shipping code
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {FreeShippingCodeUpdateRequest} freeShippingCodeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeShippingCodesControllerUpdate: async (gamixAppId: string, id: string, freeShippingCodeUpdateRequest: FreeShippingCodeUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('freeShippingCodesControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('freeShippingCodesControllerUpdate', 'id', id)
            // verify required parameter 'freeShippingCodeUpdateRequest' is not null or undefined
            assertParamExists('freeShippingCodesControllerUpdate', 'freeShippingCodeUpdateRequest', freeShippingCodeUpdateRequest)
            const localVarPath = `/v2/free-shipping/codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(freeShippingCodeUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FreeShippingCodesApi - functional programming interface
 * @export
 */
export const FreeShippingCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FreeShippingCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get free shipping code by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freeShippingCodesControllerGetById(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeShippingCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freeShippingCodesControllerGetById(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FreeShippingCodesApi.freeShippingCodesControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list free shipping codes for user
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freeShippingCodesControllerListByUser(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeShippingCodesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freeShippingCodesControllerListByUser(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FreeShippingCodesApi.freeShippingCodesControllerListByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary redeem free shipping code
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freeShippingCodesControllerRedeem(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeShippingCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freeShippingCodesControllerRedeem(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FreeShippingCodesApi.freeShippingCodesControllerRedeem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update free shipping code
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {FreeShippingCodeUpdateRequest} freeShippingCodeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freeShippingCodesControllerUpdate(gamixAppId: string, id: string, freeShippingCodeUpdateRequest: FreeShippingCodeUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeShippingCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freeShippingCodesControllerUpdate(gamixAppId, id, freeShippingCodeUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FreeShippingCodesApi.freeShippingCodesControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FreeShippingCodesApi - factory interface
 * @export
 */
export const FreeShippingCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FreeShippingCodesApiFp(configuration)
    return {
        /**
         * 
         * @summary get free shipping code by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeShippingCodesControllerGetById(gamixAppId: string, id: string, options?: any): AxiosPromise<FreeShippingCodeResponse> {
            return localVarFp.freeShippingCodesControllerGetById(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list free shipping codes for user
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeShippingCodesControllerListByUser(gamixAppId: string, options?: any): AxiosPromise<FreeShippingCodesResponse> {
            return localVarFp.freeShippingCodesControllerListByUser(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary redeem free shipping code
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeShippingCodesControllerRedeem(gamixAppId: string, options?: any): AxiosPromise<FreeShippingCodeResponse> {
            return localVarFp.freeShippingCodesControllerRedeem(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update free shipping code
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {FreeShippingCodeUpdateRequest} freeShippingCodeUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeShippingCodesControllerUpdate(gamixAppId: string, id: string, freeShippingCodeUpdateRequest: FreeShippingCodeUpdateRequest, options?: any): AxiosPromise<FreeShippingCodeResponse> {
            return localVarFp.freeShippingCodesControllerUpdate(gamixAppId, id, freeShippingCodeUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FreeShippingCodesApi - object-oriented interface
 * @export
 * @class FreeShippingCodesApi
 * @extends {BaseAPI}
 */
export class FreeShippingCodesApi extends BaseAPI {
    /**
     * 
     * @summary get free shipping code by id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreeShippingCodesApi
     */
    public freeShippingCodesControllerGetById(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return FreeShippingCodesApiFp(this.configuration).freeShippingCodesControllerGetById(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list free shipping codes for user
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreeShippingCodesApi
     */
    public freeShippingCodesControllerListByUser(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return FreeShippingCodesApiFp(this.configuration).freeShippingCodesControllerListByUser(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary redeem free shipping code
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreeShippingCodesApi
     */
    public freeShippingCodesControllerRedeem(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return FreeShippingCodesApiFp(this.configuration).freeShippingCodesControllerRedeem(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update free shipping code
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {FreeShippingCodeUpdateRequest} freeShippingCodeUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreeShippingCodesApi
     */
    public freeShippingCodesControllerUpdate(gamixAppId: string, id: string, freeShippingCodeUpdateRequest: FreeShippingCodeUpdateRequest, options?: RawAxiosRequestConfig) {
        return FreeShippingCodesApiFp(this.configuration).freeShippingCodesControllerUpdate(gamixAppId, id, freeShippingCodeUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GlobalBrandsApi - axios parameter creator
 * @export
 */
export const GlobalBrandsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Global Brands
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalBrandsControllerList: async (search?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/ecommerce/global-brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalBrandsApi - functional programming interface
 * @export
 */
export const GlobalBrandsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalBrandsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Global Brands
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async globalBrandsControllerList(search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalBrandsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.globalBrandsControllerList(search, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalBrandsApi.globalBrandsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlobalBrandsApi - factory interface
 * @export
 */
export const GlobalBrandsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalBrandsApiFp(configuration)
    return {
        /**
         * 
         * @summary List Global Brands
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalBrandsControllerList(search?: string, limit?: number, skip?: number, options?: any): AxiosPromise<GlobalBrandsResponse> {
            return localVarFp.globalBrandsControllerList(search, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalBrandsApi - object-oriented interface
 * @export
 * @class GlobalBrandsApi
 * @extends {BaseAPI}
 */
export class GlobalBrandsApi extends BaseAPI {
    /**
     * 
     * @summary List Global Brands
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalBrandsApi
     */
    public globalBrandsControllerList(search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return GlobalBrandsApiFp(this.configuration).globalBrandsControllerList(search, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GlobalCategoriesApi - axios parameter creator
 * @export
 */
export const GlobalCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Global Categories
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalCategoriesControllerList: async (search?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/ecommerce/global-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalCategoriesApi - functional programming interface
 * @export
 */
export const GlobalCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Global Categories
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async globalCategoriesControllerList(search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.globalCategoriesControllerList(search, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalCategoriesApi.globalCategoriesControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlobalCategoriesApi - factory interface
 * @export
 */
export const GlobalCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalCategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary List Global Categories
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalCategoriesControllerList(search?: string, limit?: number, skip?: number, options?: any): AxiosPromise<GlobalCategoriesResponse> {
            return localVarFp.globalCategoriesControllerList(search, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalCategoriesApi - object-oriented interface
 * @export
 * @class GlobalCategoriesApi
 * @extends {BaseAPI}
 */
export class GlobalCategoriesApi extends BaseAPI {
    /**
     * 
     * @summary List Global Categories
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalCategoriesApi
     */
    public globalCategoriesControllerList(search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return GlobalCategoriesApiFp(this.configuration).globalCategoriesControllerList(search, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GlobalProductsApi - axios parameter creator
 * @export
 */
export const GlobalProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Global Products
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalProductsControllerList: async (search?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/ecommerce/global-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalProductsApi - functional programming interface
 * @export
 */
export const GlobalProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Global Products
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async globalProductsControllerList(search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.globalProductsControllerList(search, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalProductsApi.globalProductsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlobalProductsApi - factory interface
 * @export
 */
export const GlobalProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary List Global Products
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalProductsControllerList(search?: string, limit?: number, skip?: number, options?: any): AxiosPromise<GlobalProductsResponse> {
            return localVarFp.globalProductsControllerList(search, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalProductsApi - object-oriented interface
 * @export
 * @class GlobalProductsApi
 * @extends {BaseAPI}
 */
export class GlobalProductsApi extends BaseAPI {
    /**
     * 
     * @summary List Global Products
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalProductsApi
     */
    public globalProductsControllerList(search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return GlobalProductsApiFp(this.configuration).globalProductsControllerList(search, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImpressionsApi - axios parameter creator
 * @export
 */
export const ImpressionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Impression 
         * @param {string} gamixAppId 
         * @param {ImpressionCreateRequest} impressionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impressionsControllerCreate: async (gamixAppId: string, impressionCreateRequest: ImpressionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('impressionsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'impressionCreateRequest' is not null or undefined
            assertParamExists('impressionsControllerCreate', 'impressionCreateRequest', impressionCreateRequest)
            const localVarPath = `/v2/ecommerce/impressions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(impressionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Total getTotalViews
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impressionsControllerGet: async (gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('impressionsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'orderDateFrom' is not null or undefined
            assertParamExists('impressionsControllerGet', 'orderDateFrom', orderDateFrom)
            // verify required parameter 'orderDateTo' is not null or undefined
            assertParamExists('impressionsControllerGet', 'orderDateTo', orderDateTo)
            const localVarPath = `/v2/ecommerce/impressions/analytics/views`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brand !== undefined) {
                localVarQueryParameter['brand'] = brand;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (retailApp !== undefined) {
                localVarQueryParameter['retailApp'] = retailApp;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }

            if (orderDateFrom !== undefined) {
                localVarQueryParameter['orderDateFrom'] = orderDateFrom;
            }

            if (orderDateTo !== undefined) {
                localVarQueryParameter['orderDateTo'] = orderDateTo;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Total Clicks
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTotalClicksTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impressionsControllerGetTotalClicks: async (gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTotalClicksTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('impressionsControllerGetTotalClicks', 'gamixAppId', gamixAppId)
            // verify required parameter 'orderDateFrom' is not null or undefined
            assertParamExists('impressionsControllerGetTotalClicks', 'orderDateFrom', orderDateFrom)
            // verify required parameter 'orderDateTo' is not null or undefined
            assertParamExists('impressionsControllerGetTotalClicks', 'orderDateTo', orderDateTo)
            const localVarPath = `/v2/ecommerce/impressions/analytics/clicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brand !== undefined) {
                localVarQueryParameter['brand'] = brand;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (retailApp !== undefined) {
                localVarQueryParameter['retailApp'] = retailApp;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }

            if (orderDateFrom !== undefined) {
                localVarQueryParameter['orderDateFrom'] = orderDateFrom;
            }

            if (orderDateTo !== undefined) {
                localVarQueryParameter['orderDateTo'] = orderDateTo;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Total Sales
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTotalSalesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impressionsControllerGetTotalSales: async (gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTotalSalesTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('impressionsControllerGetTotalSales', 'gamixAppId', gamixAppId)
            // verify required parameter 'orderDateFrom' is not null or undefined
            assertParamExists('impressionsControllerGetTotalSales', 'orderDateFrom', orderDateFrom)
            // verify required parameter 'orderDateTo' is not null or undefined
            assertParamExists('impressionsControllerGetTotalSales', 'orderDateTo', orderDateTo)
            const localVarPath = `/v2/ecommerce/impressions/analytics/sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brand !== undefined) {
                localVarQueryParameter['brand'] = brand;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (retailApp !== undefined) {
                localVarQueryParameter['retailApp'] = retailApp;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }

            if (orderDateFrom !== undefined) {
                localVarQueryParameter['orderDateFrom'] = orderDateFrom;
            }

            if (orderDateTo !== undefined) {
                localVarQueryParameter['orderDateTo'] = orderDateTo;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImpressionsApi - functional programming interface
 * @export
 */
export const ImpressionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImpressionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Impression 
         * @param {string} gamixAppId 
         * @param {ImpressionCreateRequest} impressionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impressionsControllerCreate(gamixAppId: string, impressionCreateRequest: ImpressionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpressionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impressionsControllerCreate(gamixAppId, impressionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpressionsApi.impressionsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Total getTotalViews
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impressionsControllerGet(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewsResposne>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impressionsControllerGet(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpressionsApi.impressionsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Total Clicks
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTotalClicksTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impressionsControllerGetTotalClicks(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTotalClicksTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClicksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impressionsControllerGetTotalClicks(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpressionsApi.impressionsControllerGetTotalClicks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Total Sales
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTotalSalesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impressionsControllerGetTotalSales(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTotalSalesTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impressionsControllerGetTotalSales(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpressionsApi.impressionsControllerGetTotalSales']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImpressionsApi - factory interface
 * @export
 */
export const ImpressionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImpressionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Impression 
         * @param {string} gamixAppId 
         * @param {ImpressionCreateRequest} impressionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impressionsControllerCreate(gamixAppId: string, impressionCreateRequest: ImpressionCreateRequest, options?: any): AxiosPromise<ImpressionResponse> {
            return localVarFp.impressionsControllerCreate(gamixAppId, impressionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Total getTotalViews
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impressionsControllerGet(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTypeEnum, options?: any): AxiosPromise<ViewsResposne> {
            return localVarFp.impressionsControllerGet(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Total Clicks
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTotalClicksTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impressionsControllerGetTotalClicks(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTotalClicksTypeEnum, options?: any): AxiosPromise<ClicksResponse> {
            return localVarFp.impressionsControllerGetTotalClicks(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Total Sales
         * @param {string} gamixAppId 
         * @param {string} orderDateFrom 
         * @param {string} orderDateTo 
         * @param {string} [brand] 
         * @param {string} [productId] 
         * @param {string} [retailApp] 
         * @param {string} [campaignId] 
         * @param {ImpressionsControllerGetTotalSalesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impressionsControllerGetTotalSales(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTotalSalesTypeEnum, options?: any): AxiosPromise<SalesResponse> {
            return localVarFp.impressionsControllerGetTotalSales(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImpressionsApi - object-oriented interface
 * @export
 * @class ImpressionsApi
 * @extends {BaseAPI}
 */
export class ImpressionsApi extends BaseAPI {
    /**
     * 
     * @summary Create Impression 
     * @param {string} gamixAppId 
     * @param {ImpressionCreateRequest} impressionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpressionsApi
     */
    public impressionsControllerCreate(gamixAppId: string, impressionCreateRequest: ImpressionCreateRequest, options?: RawAxiosRequestConfig) {
        return ImpressionsApiFp(this.configuration).impressionsControllerCreate(gamixAppId, impressionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Total getTotalViews
     * @param {string} gamixAppId 
     * @param {string} orderDateFrom 
     * @param {string} orderDateTo 
     * @param {string} [brand] 
     * @param {string} [productId] 
     * @param {string} [retailApp] 
     * @param {string} [campaignId] 
     * @param {ImpressionsControllerGetTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpressionsApi
     */
    public impressionsControllerGet(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTypeEnum, options?: RawAxiosRequestConfig) {
        return ImpressionsApiFp(this.configuration).impressionsControllerGet(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Total Clicks
     * @param {string} gamixAppId 
     * @param {string} orderDateFrom 
     * @param {string} orderDateTo 
     * @param {string} [brand] 
     * @param {string} [productId] 
     * @param {string} [retailApp] 
     * @param {string} [campaignId] 
     * @param {ImpressionsControllerGetTotalClicksTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpressionsApi
     */
    public impressionsControllerGetTotalClicks(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTotalClicksTypeEnum, options?: RawAxiosRequestConfig) {
        return ImpressionsApiFp(this.configuration).impressionsControllerGetTotalClicks(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Total Sales
     * @param {string} gamixAppId 
     * @param {string} orderDateFrom 
     * @param {string} orderDateTo 
     * @param {string} [brand] 
     * @param {string} [productId] 
     * @param {string} [retailApp] 
     * @param {string} [campaignId] 
     * @param {ImpressionsControllerGetTotalSalesTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpressionsApi
     */
    public impressionsControllerGetTotalSales(gamixAppId: string, orderDateFrom: string, orderDateTo: string, brand?: string, productId?: string, retailApp?: string, campaignId?: string, type?: ImpressionsControllerGetTotalSalesTypeEnum, options?: RawAxiosRequestConfig) {
        return ImpressionsApiFp(this.configuration).impressionsControllerGetTotalSales(gamixAppId, orderDateFrom, orderDateTo, brand, productId, retailApp, campaignId, type, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ImpressionsControllerGetTypeEnum = {
    View: 'view',
    Click: 'click',
    Convergence: 'convergence'
} as const;
export type ImpressionsControllerGetTypeEnum = typeof ImpressionsControllerGetTypeEnum[keyof typeof ImpressionsControllerGetTypeEnum];
/**
 * @export
 */
export const ImpressionsControllerGetTotalClicksTypeEnum = {
    View: 'view',
    Click: 'click',
    Convergence: 'convergence'
} as const;
export type ImpressionsControllerGetTotalClicksTypeEnum = typeof ImpressionsControllerGetTotalClicksTypeEnum[keyof typeof ImpressionsControllerGetTotalClicksTypeEnum];
/**
 * @export
 */
export const ImpressionsControllerGetTotalSalesTypeEnum = {
    View: 'view',
    Click: 'click',
    Convergence: 'convergence'
} as const;
export type ImpressionsControllerGetTotalSalesTypeEnum = typeof ImpressionsControllerGetTotalSalesTypeEnum[keyof typeof ImpressionsControllerGetTotalSalesTypeEnum];


/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create inventory
         * @param {string} gamixAppId 
         * @param {CreateInventoryRequest} createInventoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryControllerCreate: async (gamixAppId: string, createInventoryRequest: CreateInventoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('inventoryControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'createInventoryRequest' is not null or undefined
            assertParamExists('inventoryControllerCreate', 'createInventoryRequest', createInventoryRequest)
            const localVarPath = `/v2/ecommerce/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInventoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create inventory
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('inventoryControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('inventoryControllerDelete', 'id', id)
            const localVarPath = `/v2/ecommerce/inventory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get inventory by app
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryControllerGetByApp: async (gamixAppId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('inventoryControllerGetByApp', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create inventory
         * @param {string} gamixAppId 
         * @param {CreateInventoryRequest} createInventoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryControllerCreate(gamixAppId: string, createInventoryRequest: CreateInventoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerCreate(gamixAppId, createInventoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.inventoryControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create inventory
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.inventoryControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get inventory by app
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryControllerGetByApp(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerGetByApp(gamixAppId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.inventoryControllerGetByApp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryApiFp(configuration)
    return {
        /**
         * 
         * @summary create inventory
         * @param {string} gamixAppId 
         * @param {CreateInventoryRequest} createInventoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryControllerCreate(gamixAppId: string, createInventoryRequest: CreateInventoryRequest, options?: any): AxiosPromise<InventoryResponse> {
            return localVarFp.inventoryControllerCreate(gamixAppId, createInventoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create inventory
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<InventoryResponse> {
            return localVarFp.inventoryControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get inventory by app
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryControllerGetByApp(gamixAppId: string, limit?: number, skip?: number, options?: any): AxiosPromise<InventoryListResponse> {
            return localVarFp.inventoryControllerGetByApp(gamixAppId, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
    /**
     * 
     * @summary create inventory
     * @param {string} gamixAppId 
     * @param {CreateInventoryRequest} createInventoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public inventoryControllerCreate(gamixAppId: string, createInventoryRequest: CreateInventoryRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).inventoryControllerCreate(gamixAppId, createInventoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create inventory
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public inventoryControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).inventoryControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get inventory by app
     * @param {string} gamixAppId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public inventoryControllerGetByApp(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).inventoryControllerGetByApp(gamixAppId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LiveSellingApi - axios parameter creator
 * @export
 */
export const LiveSellingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Live Selling
         * @param {string} gamixAppId 
         * @param {LiveSellingCreateRequest} liveSellingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerCreate: async (gamixAppId: string, liveSellingCreateRequest: LiveSellingCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('liveSellingControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'liveSellingCreateRequest' is not null or undefined
            assertParamExists('liveSellingControllerCreate', 'liveSellingCreateRequest', liveSellingCreateRequest)
            const localVarPath = `/v2/live-selling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(liveSellingCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('liveSellingControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('liveSellingControllerDelete', 'id', id)
            const localVarPath = `/v2/live-selling/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('liveSellingControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('liveSellingControllerGet', 'id', id)
            const localVarPath = `/v2/live-selling/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Live Selling
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerList: async (gamixAppId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('liveSellingControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/live-selling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {LiveSellingUpdateRequest} liveSellingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerUpdate: async (gamixAppId: string, id: string, liveSellingUpdateRequest: LiveSellingUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('liveSellingControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('liveSellingControllerUpdate', 'id', id)
            // verify required parameter 'liveSellingUpdateRequest' is not null or undefined
            assertParamExists('liveSellingControllerUpdate', 'liveSellingUpdateRequest', liveSellingUpdateRequest)
            const localVarPath = `/v2/live-selling/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(liveSellingUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LiveSellingApi - functional programming interface
 * @export
 */
export const LiveSellingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LiveSellingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Live Selling
         * @param {string} gamixAppId 
         * @param {LiveSellingCreateRequest} liveSellingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liveSellingControllerCreate(gamixAppId: string, liveSellingCreateRequest: LiveSellingCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveSellingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.liveSellingControllerCreate(gamixAppId, liveSellingCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiveSellingApi.liveSellingControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liveSellingControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.liveSellingControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiveSellingApi.liveSellingControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liveSellingControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveSellingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.liveSellingControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiveSellingApi.liveSellingControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Live Selling
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liveSellingControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveSellingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.liveSellingControllerList(gamixAppId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiveSellingApi.liveSellingControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {LiveSellingUpdateRequest} liveSellingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liveSellingControllerUpdate(gamixAppId: string, id: string, liveSellingUpdateRequest: LiveSellingUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveSellingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.liveSellingControllerUpdate(gamixAppId, id, liveSellingUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiveSellingApi.liveSellingControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LiveSellingApi - factory interface
 * @export
 */
export const LiveSellingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LiveSellingApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Live Selling
         * @param {string} gamixAppId 
         * @param {LiveSellingCreateRequest} liveSellingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerCreate(gamixAppId: string, liveSellingCreateRequest: LiveSellingCreateRequest, options?: any): AxiosPromise<LiveSellingResponse> {
            return localVarFp.liveSellingControllerCreate(gamixAppId, liveSellingCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.liveSellingControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<LiveSellingResponse> {
            return localVarFp.liveSellingControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Live Selling
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerList(gamixAppId: string, limit?: number, skip?: number, options?: any): AxiosPromise<LiveSellingResponse> {
            return localVarFp.liveSellingControllerList(gamixAppId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Live Selling
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {LiveSellingUpdateRequest} liveSellingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveSellingControllerUpdate(gamixAppId: string, id: string, liveSellingUpdateRequest: LiveSellingUpdateRequest, options?: any): AxiosPromise<LiveSellingResponse> {
            return localVarFp.liveSellingControllerUpdate(gamixAppId, id, liveSellingUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LiveSellingApi - object-oriented interface
 * @export
 * @class LiveSellingApi
 * @extends {BaseAPI}
 */
export class LiveSellingApi extends BaseAPI {
    /**
     * 
     * @summary Create Live Selling
     * @param {string} gamixAppId 
     * @param {LiveSellingCreateRequest} liveSellingCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveSellingApi
     */
    public liveSellingControllerCreate(gamixAppId: string, liveSellingCreateRequest: LiveSellingCreateRequest, options?: RawAxiosRequestConfig) {
        return LiveSellingApiFp(this.configuration).liveSellingControllerCreate(gamixAppId, liveSellingCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Live Selling
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveSellingApi
     */
    public liveSellingControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return LiveSellingApiFp(this.configuration).liveSellingControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Live Selling
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveSellingApi
     */
    public liveSellingControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return LiveSellingApiFp(this.configuration).liveSellingControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Live Selling
     * @param {string} gamixAppId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveSellingApi
     */
    public liveSellingControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return LiveSellingApiFp(this.configuration).liveSellingControllerList(gamixAppId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Live Selling
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {LiveSellingUpdateRequest} liveSellingUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveSellingApi
     */
    public liveSellingControllerUpdate(gamixAppId: string, id: string, liveSellingUpdateRequest: LiveSellingUpdateRequest, options?: RawAxiosRequestConfig) {
        return LiveSellingApiFp(this.configuration).liveSellingControllerUpdate(gamixAppId, id, liveSellingUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OfflineOrdersApi - axios parameter creator
 * @export
 */
export const OfflineOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create offline order
         * @param {string} gamixAppId 
         * @param {string} userId 
         * @param {OfflineOrderCreatRequest} offlineOrderCreatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerCreate: async (gamixAppId: string, userId: string, offlineOrderCreatRequest: OfflineOrderCreatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('offlineOrdersControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('offlineOrdersControllerCreate', 'userId', userId)
            // verify required parameter 'offlineOrderCreatRequest' is not null or undefined
            assertParamExists('offlineOrdersControllerCreate', 'offlineOrderCreatRequest', offlineOrderCreatRequest)
            const localVarPath = `/v2/offline-orders/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offlineOrderCreatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Offline Orders
         * @param {string} gamixAppId 
         * @param {string} [user] Filter by user id
         * @param {string} [sort] Sort data field
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerList: async (gamixAppId: string, user?: string, sort?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('offlineOrdersControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/offline-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list Populated Purchases Details 
         * @param {string} gamixAppId 
         * @param {string} phoneNumber Phone number
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerListPopulated: async (gamixAppId: string, phoneNumber: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('offlineOrdersControllerListPopulated', 'gamixAppId', gamixAppId)
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('offlineOrdersControllerListPopulated', 'phoneNumber', phoneNumber)
            const localVarPath = `/v2/offline-orders/populated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary return Offline order by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {OfflineOrderDeleteRequest} offlineOrderDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerReturnOfflineOrder: async (gamixAppId: string, id: string, offlineOrderDeleteRequest: OfflineOrderDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('offlineOrdersControllerReturnOfflineOrder', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('offlineOrdersControllerReturnOfflineOrder', 'id', id)
            // verify required parameter 'offlineOrderDeleteRequest' is not null or undefined
            assertParamExists('offlineOrdersControllerReturnOfflineOrder', 'offlineOrderDeleteRequest', offlineOrderDeleteRequest)
            const localVarPath = `/v2/offline-orders/{id}/return`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offlineOrderDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Offline Order OTP request
         * @param {string} gamixAppId 
         * @param {OfflineOrderCreatRequest} offlineOrderCreatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerSendOTP: async (gamixAppId: string, offlineOrderCreatRequest: OfflineOrderCreatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('offlineOrdersControllerSendOTP', 'gamixAppId', gamixAppId)
            // verify required parameter 'offlineOrderCreatRequest' is not null or undefined
            assertParamExists('offlineOrdersControllerSendOTP', 'offlineOrderCreatRequest', offlineOrderCreatRequest)
            const localVarPath = `/v2/offline-orders/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offlineOrderCreatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {OfflineOrderUpdateRequest} offlineOrderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerUpdate: async (gamixAppId: string, id: string, offlineOrderUpdateRequest: OfflineOrderUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('offlineOrdersControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('offlineOrdersControllerUpdate', 'id', id)
            // verify required parameter 'offlineOrderUpdateRequest' is not null or undefined
            assertParamExists('offlineOrdersControllerUpdate', 'offlineOrderUpdateRequest', offlineOrderUpdateRequest)
            const localVarPath = `/v2/offline-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offlineOrderUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify Offline order OTP request
         * @param {string} gamixAppId 
         * @param {VerifyOfflineOrderOtpRequest} verifyOfflineOrderOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerVerify: async (gamixAppId: string, verifyOfflineOrderOtpRequest: VerifyOfflineOrderOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('offlineOrdersControllerVerify', 'gamixAppId', gamixAppId)
            // verify required parameter 'verifyOfflineOrderOtpRequest' is not null or undefined
            assertParamExists('offlineOrdersControllerVerify', 'verifyOfflineOrderOtpRequest', verifyOfflineOrderOtpRequest)
            const localVarPath = `/v2/offline-orders/otp/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOfflineOrderOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OfflineOrdersApi - functional programming interface
 * @export
 */
export const OfflineOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OfflineOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create offline order
         * @param {string} gamixAppId 
         * @param {string} userId 
         * @param {OfflineOrderCreatRequest} offlineOrderCreatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offlineOrdersControllerCreate(gamixAppId: string, userId: string, offlineOrderCreatRequest: OfflineOrderCreatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offlineOrdersControllerCreate(gamixAppId, userId, offlineOrderCreatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineOrdersApi.offlineOrdersControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Offline Orders
         * @param {string} gamixAppId 
         * @param {string} [user] Filter by user id
         * @param {string} [sort] Sort data field
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offlineOrdersControllerList(gamixAppId: string, user?: string, sort?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOfflineOrdersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offlineOrdersControllerList(gamixAppId, user, sort, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineOrdersApi.offlineOrdersControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list Populated Purchases Details 
         * @param {string} gamixAppId 
         * @param {string} phoneNumber Phone number
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offlineOrdersControllerListPopulated(gamixAppId: string, phoneNumber: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopulatedOfflineOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offlineOrdersControllerListPopulated(gamixAppId, phoneNumber, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineOrdersApi.offlineOrdersControllerListPopulated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary return Offline order by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {OfflineOrderDeleteRequest} offlineOrderDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offlineOrdersControllerReturnOfflineOrder(gamixAppId: string, id: string, offlineOrderDeleteRequest: OfflineOrderDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offlineOrdersControllerReturnOfflineOrder(gamixAppId, id, offlineOrderDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineOrdersApi.offlineOrdersControllerReturnOfflineOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Offline Order OTP request
         * @param {string} gamixAppId 
         * @param {OfflineOrderCreatRequest} offlineOrderCreatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offlineOrdersControllerSendOTP(gamixAppId: string, offlineOrderCreatRequest: OfflineOrderCreatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offlineOrdersControllerSendOTP(gamixAppId, offlineOrderCreatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineOrdersApi.offlineOrdersControllerSendOTP']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {OfflineOrderUpdateRequest} offlineOrderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offlineOrdersControllerUpdate(gamixAppId: string, id: string, offlineOrderUpdateRequest: OfflineOrderUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offlineOrdersControllerUpdate(gamixAppId, id, offlineOrderUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineOrdersApi.offlineOrdersControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify Offline order OTP request
         * @param {string} gamixAppId 
         * @param {VerifyOfflineOrderOtpRequest} verifyOfflineOrderOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offlineOrdersControllerVerify(gamixAppId: string, verifyOfflineOrderOtpRequest: VerifyOfflineOrderOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineOrderVerifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offlineOrdersControllerVerify(gamixAppId, verifyOfflineOrderOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineOrdersApi.offlineOrdersControllerVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OfflineOrdersApi - factory interface
 * @export
 */
export const OfflineOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OfflineOrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create offline order
         * @param {string} gamixAppId 
         * @param {string} userId 
         * @param {OfflineOrderCreatRequest} offlineOrderCreatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerCreate(gamixAppId: string, userId: string, offlineOrderCreatRequest: OfflineOrderCreatRequest, options?: any): AxiosPromise<void> {
            return localVarFp.offlineOrdersControllerCreate(gamixAppId, userId, offlineOrderCreatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Offline Orders
         * @param {string} gamixAppId 
         * @param {string} [user] Filter by user id
         * @param {string} [sort] Sort data field
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerList(gamixAppId: string, user?: string, sort?: string, limit?: number, skip?: number, options?: any): AxiosPromise<ListOfflineOrdersResponse> {
            return localVarFp.offlineOrdersControllerList(gamixAppId, user, sort, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list Populated Purchases Details 
         * @param {string} gamixAppId 
         * @param {string} phoneNumber Phone number
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerListPopulated(gamixAppId: string, phoneNumber: string, limit?: number, skip?: number, options?: any): AxiosPromise<PopulatedOfflineOrderResponse> {
            return localVarFp.offlineOrdersControllerListPopulated(gamixAppId, phoneNumber, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary return Offline order by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {OfflineOrderDeleteRequest} offlineOrderDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerReturnOfflineOrder(gamixAppId: string, id: string, offlineOrderDeleteRequest: OfflineOrderDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.offlineOrdersControllerReturnOfflineOrder(gamixAppId, id, offlineOrderDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Offline Order OTP request
         * @param {string} gamixAppId 
         * @param {OfflineOrderCreatRequest} offlineOrderCreatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerSendOTP(gamixAppId: string, offlineOrderCreatRequest: OfflineOrderCreatRequest, options?: any): AxiosPromise<GenerateOtpResponse> {
            return localVarFp.offlineOrdersControllerSendOTP(gamixAppId, offlineOrderCreatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {OfflineOrderUpdateRequest} offlineOrderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerUpdate(gamixAppId: string, id: string, offlineOrderUpdateRequest: OfflineOrderUpdateRequest, options?: any): AxiosPromise<OfflineOrderResponse> {
            return localVarFp.offlineOrdersControllerUpdate(gamixAppId, id, offlineOrderUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify Offline order OTP request
         * @param {string} gamixAppId 
         * @param {VerifyOfflineOrderOtpRequest} verifyOfflineOrderOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offlineOrdersControllerVerify(gamixAppId: string, verifyOfflineOrderOtpRequest: VerifyOfflineOrderOtpRequest, options?: any): AxiosPromise<OfflineOrderVerifyResponse> {
            return localVarFp.offlineOrdersControllerVerify(gamixAppId, verifyOfflineOrderOtpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OfflineOrdersApi - object-oriented interface
 * @export
 * @class OfflineOrdersApi
 * @extends {BaseAPI}
 */
export class OfflineOrdersApi extends BaseAPI {
    /**
     * 
     * @summary Create offline order
     * @param {string} gamixAppId 
     * @param {string} userId 
     * @param {OfflineOrderCreatRequest} offlineOrderCreatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineOrdersApi
     */
    public offlineOrdersControllerCreate(gamixAppId: string, userId: string, offlineOrderCreatRequest: OfflineOrderCreatRequest, options?: RawAxiosRequestConfig) {
        return OfflineOrdersApiFp(this.configuration).offlineOrdersControllerCreate(gamixAppId, userId, offlineOrderCreatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Offline Orders
     * @param {string} gamixAppId 
     * @param {string} [user] Filter by user id
     * @param {string} [sort] Sort data field
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineOrdersApi
     */
    public offlineOrdersControllerList(gamixAppId: string, user?: string, sort?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return OfflineOrdersApiFp(this.configuration).offlineOrdersControllerList(gamixAppId, user, sort, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list Populated Purchases Details 
     * @param {string} gamixAppId 
     * @param {string} phoneNumber Phone number
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineOrdersApi
     */
    public offlineOrdersControllerListPopulated(gamixAppId: string, phoneNumber: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return OfflineOrdersApiFp(this.configuration).offlineOrdersControllerListPopulated(gamixAppId, phoneNumber, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary return Offline order by id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {OfflineOrderDeleteRequest} offlineOrderDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineOrdersApi
     */
    public offlineOrdersControllerReturnOfflineOrder(gamixAppId: string, id: string, offlineOrderDeleteRequest: OfflineOrderDeleteRequest, options?: RawAxiosRequestConfig) {
        return OfflineOrdersApiFp(this.configuration).offlineOrdersControllerReturnOfflineOrder(gamixAppId, id, offlineOrderDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Offline Order OTP request
     * @param {string} gamixAppId 
     * @param {OfflineOrderCreatRequest} offlineOrderCreatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineOrdersApi
     */
    public offlineOrdersControllerSendOTP(gamixAppId: string, offlineOrderCreatRequest: OfflineOrderCreatRequest, options?: RawAxiosRequestConfig) {
        return OfflineOrdersApiFp(this.configuration).offlineOrdersControllerSendOTP(gamixAppId, offlineOrderCreatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Purchase
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {OfflineOrderUpdateRequest} offlineOrderUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineOrdersApi
     */
    public offlineOrdersControllerUpdate(gamixAppId: string, id: string, offlineOrderUpdateRequest: OfflineOrderUpdateRequest, options?: RawAxiosRequestConfig) {
        return OfflineOrdersApiFp(this.configuration).offlineOrdersControllerUpdate(gamixAppId, id, offlineOrderUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify Offline order OTP request
     * @param {string} gamixAppId 
     * @param {VerifyOfflineOrderOtpRequest} verifyOfflineOrderOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineOrdersApi
     */
    public offlineOrdersControllerVerify(gamixAppId: string, verifyOfflineOrderOtpRequest: VerifyOfflineOrderOtpRequest, options?: RawAxiosRequestConfig) {
        return OfflineOrdersApiFp(this.configuration).offlineOrdersControllerVerify(gamixAppId, verifyOfflineOrderOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnlineOrdersApi - axios parameter creator
 * @export
 */
export const OnlineOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Order
         * @param {string} gamixAppId 
         * @param {CustomOrderCreateRequest} customOrderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerCreate: async (gamixAppId: string, customOrderCreateRequest: CustomOrderCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('ordersControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'customOrderCreateRequest' is not null or undefined
            assertParamExists('ordersControllerCreate', 'customOrderCreateRequest', customOrderCreateRequest)
            const localVarPath = `/v2/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customOrderCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Order
         * @param {string} id 
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerDelete: async (id: string, gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ordersControllerDelete', 'id', id)
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('ordersControllerDelete', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary export orders data
         * @param {string} gamixAppId 
         * @param {OrdersExportRequest} ordersExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerExportData: async (gamixAppId: string, ordersExportRequest: OrdersExportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('ordersControllerExportData', 'gamixAppId', gamixAppId)
            // verify required parameter 'ordersExportRequest' is not null or undefined
            assertParamExists('ordersControllerExportData', 'ordersExportRequest', ordersExportRequest)
            const localVarPath = `/v2/orders/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} agent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerHookPerAgent: async (agent: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agent' is not null or undefined
            assertParamExists('ordersControllerHookPerAgent', 'agent', agent)
            const localVarPath = `/v2/orders/{agent}/hook`
                .replace(`{${"agent"}}`, encodeURIComponent(String(agent)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerHooks: async (appId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appId' is not null or undefined
            assertParamExists('ordersControllerHooks', 'appId', appId)
            const localVarPath = `/v2/orders/apps/{appId}/hooks`
                .replace(`{${"appId"}}`, encodeURIComponent(String(appId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Orders
         * @param {string} gamixAppId 
         * @param {OrdersControllerListSourceEnum} [source] 
         * @param {string} [user] 
         * @param {string} [metadataSource] 
         * @param {string} [sort] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerList: async (gamixAppId: string, source?: OrdersControllerListSourceEnum, user?: string, metadataSource?: string, sort?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('ordersControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (metadataSource !== undefined) {
                localVarQueryParameter['metadata.source'] = metadataSource;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnlineOrdersApi - functional programming interface
 * @export
 */
export const OnlineOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnlineOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Order
         * @param {string} gamixAppId 
         * @param {CustomOrderCreateRequest} customOrderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersControllerCreate(gamixAppId: string, customOrderCreateRequest: CustomOrderCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersControllerCreate(gamixAppId, customOrderCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineOrdersApi.ordersControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Order
         * @param {string} id 
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersControllerDelete(id: string, gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersControllerDelete(id, gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineOrdersApi.ordersControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary export orders data
         * @param {string} gamixAppId 
         * @param {OrdersExportRequest} ordersExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersControllerExportData(gamixAppId: string, ordersExportRequest: OrdersExportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersControllerExportData(gamixAppId, ordersExportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineOrdersApi.ordersControllerExportData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} agent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersControllerHookPerAgent(agent: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersControllerHookPerAgent(agent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineOrdersApi.ordersControllerHookPerAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersControllerHooks(appId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersControllerHooks(appId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineOrdersApi.ordersControllerHooks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Orders
         * @param {string} gamixAppId 
         * @param {OrdersControllerListSourceEnum} [source] 
         * @param {string} [user] 
         * @param {string} [metadataSource] 
         * @param {string} [sort] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersControllerList(gamixAppId: string, source?: OrdersControllerListSourceEnum, user?: string, metadataSource?: string, sort?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersPopulatedUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersControllerList(gamixAppId, source, user, metadataSource, sort, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlineOrdersApi.ordersControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnlineOrdersApi - factory interface
 * @export
 */
export const OnlineOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnlineOrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Order
         * @param {string} gamixAppId 
         * @param {CustomOrderCreateRequest} customOrderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerCreate(gamixAppId: string, customOrderCreateRequest: CustomOrderCreateRequest, options?: any): AxiosPromise<OrderResponse> {
            return localVarFp.ordersControllerCreate(gamixAppId, customOrderCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Order
         * @param {string} id 
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerDelete(id: string, gamixAppId: string, options?: any): AxiosPromise<OrdersResponse> {
            return localVarFp.ordersControllerDelete(id, gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary export orders data
         * @param {string} gamixAppId 
         * @param {OrdersExportRequest} ordersExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerExportData(gamixAppId: string, ordersExportRequest: OrdersExportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.ordersControllerExportData(gamixAppId, ordersExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} agent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerHookPerAgent(agent: string, options?: any): AxiosPromise<void> {
            return localVarFp.ordersControllerHookPerAgent(agent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerHooks(appId: string, options?: any): AxiosPromise<void> {
            return localVarFp.ordersControllerHooks(appId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Orders
         * @param {string} gamixAppId 
         * @param {OrdersControllerListSourceEnum} [source] 
         * @param {string} [user] 
         * @param {string} [metadataSource] 
         * @param {string} [sort] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersControllerList(gamixAppId: string, source?: OrdersControllerListSourceEnum, user?: string, metadataSource?: string, sort?: string, limit?: number, skip?: number, options?: any): AxiosPromise<OrdersPopulatedUsersResponse> {
            return localVarFp.ordersControllerList(gamixAppId, source, user, metadataSource, sort, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnlineOrdersApi - object-oriented interface
 * @export
 * @class OnlineOrdersApi
 * @extends {BaseAPI}
 */
export class OnlineOrdersApi extends BaseAPI {
    /**
     * 
     * @summary Create Order
     * @param {string} gamixAppId 
     * @param {CustomOrderCreateRequest} customOrderCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineOrdersApi
     */
    public ordersControllerCreate(gamixAppId: string, customOrderCreateRequest: CustomOrderCreateRequest, options?: RawAxiosRequestConfig) {
        return OnlineOrdersApiFp(this.configuration).ordersControllerCreate(gamixAppId, customOrderCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Order
     * @param {string} id 
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineOrdersApi
     */
    public ordersControllerDelete(id: string, gamixAppId: string, options?: RawAxiosRequestConfig) {
        return OnlineOrdersApiFp(this.configuration).ordersControllerDelete(id, gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary export orders data
     * @param {string} gamixAppId 
     * @param {OrdersExportRequest} ordersExportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineOrdersApi
     */
    public ordersControllerExportData(gamixAppId: string, ordersExportRequest: OrdersExportRequest, options?: RawAxiosRequestConfig) {
        return OnlineOrdersApiFp(this.configuration).ordersControllerExportData(gamixAppId, ordersExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} agent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineOrdersApi
     */
    public ordersControllerHookPerAgent(agent: string, options?: RawAxiosRequestConfig) {
        return OnlineOrdersApiFp(this.configuration).ordersControllerHookPerAgent(agent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineOrdersApi
     */
    public ordersControllerHooks(appId: string, options?: RawAxiosRequestConfig) {
        return OnlineOrdersApiFp(this.configuration).ordersControllerHooks(appId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Orders
     * @param {string} gamixAppId 
     * @param {OrdersControllerListSourceEnum} [source] 
     * @param {string} [user] 
     * @param {string} [metadataSource] 
     * @param {string} [sort] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlineOrdersApi
     */
    public ordersControllerList(gamixAppId: string, source?: OrdersControllerListSourceEnum, user?: string, metadataSource?: string, sort?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return OnlineOrdersApiFp(this.configuration).ordersControllerList(gamixAppId, source, user, metadataSource, sort, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const OrdersControllerListSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;
export type OrdersControllerListSourceEnum = typeof OrdersControllerListSourceEnum[keyof typeof OrdersControllerListSourceEnum];


/**
 * OrdersHubApi - axios parameter creator
 * @export
 */
export const OrdersHubApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create order
         * @param {string} gamixAppId 
         * @param {OrdersCreateRequest} ordersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerCreate: async (gamixAppId: string, ordersCreateRequest: OrdersCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'ordersCreateRequest' is not null or undefined
            assertParamExists('genericOrdersControllerCreate', 'ordersCreateRequest', ordersCreateRequest)
            const localVarPath = `/v2/ecommerce/orders-hub`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create order with otp
         * @param {string} gamixAppId 
         * @param {OrdersCreateRequest} ordersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerCreateOtp: async (gamixAppId: string, ordersCreateRequest: OrdersCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerCreateOtp', 'gamixAppId', gamixAppId)
            // verify required parameter 'ordersCreateRequest' is not null or undefined
            assertParamExists('genericOrdersControllerCreateOtp', 'ordersCreateRequest', ordersCreateRequest)
            const localVarPath = `/v2/ecommerce/orders-hub/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Order
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('genericOrdersControllerGet', 'id', id)
            const localVarPath = `/v2/ecommerce/orders-hub/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get orders charts data
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetChartsDataSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGetChartsData: async (gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetChartsDataSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerGetChartsData', 'gamixAppId', gamixAppId)
            // verify required parameter 'minOrderDate' is not null or undefined
            assertParamExists('genericOrdersControllerGetChartsData', 'minOrderDate', minOrderDate)
            // verify required parameter 'maxOrderDate' is not null or undefined
            assertParamExists('genericOrdersControllerGetChartsData', 'maxOrderDate', maxOrderDate)
            // verify required parameter 'sources' is not null or undefined
            assertParamExists('genericOrdersControllerGetChartsData', 'sources', sources)
            const localVarPath = `/v2/ecommerce/orders-hub/analytics/charts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minOrderDate !== undefined) {
                localVarQueryParameter['minOrderDate'] = (minOrderDate as any instanceof Date) ?
                    (minOrderDate as any).toISOString() :
                    minOrderDate;
            }

            if (maxOrderDate !== undefined) {
                localVarQueryParameter['maxOrderDate'] = (maxOrderDate as any instanceof Date) ?
                    (maxOrderDate as any).toISOString() :
                    maxOrderDate;
            }

            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }

            if (salesRepIds) {
                localVarQueryParameter['salesRepIds'] = salesRepIds;
            }

            if (salesRepGroups) {
                localVarQueryParameter['salesRepGroups'] = salesRepGroups;
            }

            if (timeZoneOffset !== undefined) {
                localVarQueryParameter['timeZoneOffset'] = timeZoneOffset;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer
         * @param {string} gamixAppId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGetCustomerDetails: async (gamixAppId: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerGetCustomerDetails', 'gamixAppId', gamixAppId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('genericOrdersControllerGetCustomerDetails', 'customerId', customerId)
            const localVarPath = `/v2/ecommerce/orders-hub/customer/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Orders Overview chart
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetOverviewDataSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGetOverviewData: async (gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetOverviewDataSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerGetOverviewData', 'gamixAppId', gamixAppId)
            // verify required parameter 'minOrderDate' is not null or undefined
            assertParamExists('genericOrdersControllerGetOverviewData', 'minOrderDate', minOrderDate)
            // verify required parameter 'maxOrderDate' is not null or undefined
            assertParamExists('genericOrdersControllerGetOverviewData', 'maxOrderDate', maxOrderDate)
            // verify required parameter 'sources' is not null or undefined
            assertParamExists('genericOrdersControllerGetOverviewData', 'sources', sources)
            const localVarPath = `/v2/ecommerce/orders-hub/analytics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minOrderDate !== undefined) {
                localVarQueryParameter['minOrderDate'] = (minOrderDate as any instanceof Date) ?
                    (minOrderDate as any).toISOString() :
                    minOrderDate;
            }

            if (maxOrderDate !== undefined) {
                localVarQueryParameter['maxOrderDate'] = (maxOrderDate as any instanceof Date) ?
                    (maxOrderDate as any).toISOString() :
                    maxOrderDate;
            }

            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }

            if (salesRepIds) {
                localVarQueryParameter['salesRepIds'] = salesRepIds;
            }

            if (salesRepGroups) {
                localVarQueryParameter['salesRepGroups'] = salesRepGroups;
            }

            if (timeZoneOffset !== undefined) {
                localVarQueryParameter['timeZoneOffset'] = timeZoneOffset;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sales statistics
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetSalesStatisticsSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGetSalesStatistics: async (gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetSalesStatisticsSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerGetSalesStatistics', 'gamixAppId', gamixAppId)
            // verify required parameter 'minOrderDate' is not null or undefined
            assertParamExists('genericOrdersControllerGetSalesStatistics', 'minOrderDate', minOrderDate)
            // verify required parameter 'maxOrderDate' is not null or undefined
            assertParamExists('genericOrdersControllerGetSalesStatistics', 'maxOrderDate', maxOrderDate)
            // verify required parameter 'sources' is not null or undefined
            assertParamExists('genericOrdersControllerGetSalesStatistics', 'sources', sources)
            const localVarPath = `/v2/ecommerce/orders-hub/analytics/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minOrderDate !== undefined) {
                localVarQueryParameter['minOrderDate'] = (minOrderDate as any instanceof Date) ?
                    (minOrderDate as any).toISOString() :
                    minOrderDate;
            }

            if (maxOrderDate !== undefined) {
                localVarQueryParameter['maxOrderDate'] = (maxOrderDate as any instanceof Date) ?
                    (maxOrderDate as any).toISOString() :
                    maxOrderDate;
            }

            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }

            if (salesRepIds) {
                localVarQueryParameter['salesRepIds'] = salesRepIds;
            }

            if (salesRepGroups) {
                localVarQueryParameter['salesRepGroups'] = salesRepGroups;
            }

            if (timeZoneOffset !== undefined) {
                localVarQueryParameter['timeZoneOffset'] = timeZoneOffset;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend OTP
         * @param {string} gamixAppId 
         * @param {OtpResendRequest} otpResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerResendOtp: async (gamixAppId: string, otpResendRequest: OtpResendRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerResendOtp', 'gamixAppId', gamixAppId)
            // verify required parameter 'otpResendRequest' is not null or undefined
            assertParamExists('genericOrdersControllerResendOtp', 'otpResendRequest', otpResendRequest)
            const localVarPath = `/v2/ecommerce/orders-hub/resend/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpResendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return order
         * @param {string} gamixAppId 
         * @param {OrdersReturnRequest} ordersReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerReturn: async (gamixAppId: string, ordersReturnRequest: OrdersReturnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerReturn', 'gamixAppId', gamixAppId)
            // verify required parameter 'ordersReturnRequest' is not null or undefined
            assertParamExists('genericOrdersControllerReturn', 'ordersReturnRequest', ordersReturnRequest)
            const localVarPath = `/v2/ecommerce/orders-hub/return`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerUploadCSV: async (gamixAppId: string, importRequest: ImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerUploadCSV', 'gamixAppId', gamixAppId)
            // verify required parameter 'importRequest' is not null or undefined
            assertParamExists('genericOrdersControllerUploadCSV', 'importRequest', importRequest)
            const localVarPath = `/v2/ecommerce/orders-hub/upload-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify OTP
         * @param {string} gamixAppId 
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerVerifyOtp: async (gamixAppId: string, verifyOtpRequest: VerifyOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('genericOrdersControllerVerifyOtp', 'gamixAppId', gamixAppId)
            // verify required parameter 'verifyOtpRequest' is not null or undefined
            assertParamExists('genericOrdersControllerVerifyOtp', 'verifyOtpRequest', verifyOtpRequest)
            const localVarPath = `/v2/ecommerce/orders-hub/verify/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersHubApi - functional programming interface
 * @export
 */
export const OrdersHubApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersHubApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create order
         * @param {string} gamixAppId 
         * @param {OrdersCreateRequest} ordersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerCreate(gamixAppId: string, ordersCreateRequest: OrdersCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerCreate(gamixAppId, ordersCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create order with otp
         * @param {string} gamixAppId 
         * @param {OrdersCreateRequest} ordersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerCreateOtp(gamixAppId: string, ordersCreateRequest: OrdersCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerCreateOtp(gamixAppId, ordersCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerCreateOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Order
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderPopulatedItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get orders charts data
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetChartsDataSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerGetChartsData(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetChartsDataSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersChartsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerGetChartsData(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerGetChartsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get customer
         * @param {string} gamixAppId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerGetCustomerDetails(gamixAppId: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerGetCustomerDetails(gamixAppId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerGetCustomerDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Orders Overview chart
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetOverviewDataSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerGetOverviewData(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetOverviewDataSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrdersOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerGetOverviewData(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerGetOverviewData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get sales statistics
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetSalesStatisticsSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerGetSalesStatistics(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetSalesStatisticsSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerGetSalesStatistics(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerGetSalesStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend OTP
         * @param {string} gamixAppId 
         * @param {OtpResendRequest} otpResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerResendOtp(gamixAppId: string, otpResendRequest: OtpResendRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerResendOtp(gamixAppId, otpResendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerResendOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return order
         * @param {string} gamixAppId 
         * @param {OrdersReturnRequest} ordersReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerReturn(gamixAppId: string, ordersReturnRequest: OrdersReturnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerReturn(gamixAppId, ordersReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerUploadCSV(gamixAppId: string, importRequest: ImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerUploadCSV(gamixAppId, importRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerUploadCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify OTP
         * @param {string} gamixAppId 
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericOrdersControllerVerifyOtp(gamixAppId: string, verifyOtpRequest: VerifyOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericOrdersControllerVerifyOtp(gamixAppId, verifyOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersHubApi.genericOrdersControllerVerifyOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrdersHubApi - factory interface
 * @export
 */
export const OrdersHubApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersHubApiFp(configuration)
    return {
        /**
         * 
         * @summary Create order
         * @param {string} gamixAppId 
         * @param {OrdersCreateRequest} ordersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerCreate(gamixAppId: string, ordersCreateRequest: OrdersCreateRequest, options?: any): AxiosPromise<OrderResponse> {
            return localVarFp.genericOrdersControllerCreate(gamixAppId, ordersCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create order with otp
         * @param {string} gamixAppId 
         * @param {OrdersCreateRequest} ordersCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerCreateOtp(gamixAppId: string, ordersCreateRequest: OrdersCreateRequest, options?: any): AxiosPromise<OtpResponse> {
            return localVarFp.genericOrdersControllerCreateOtp(gamixAppId, ordersCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Order
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<OrderPopulatedItemResponse> {
            return localVarFp.genericOrdersControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get orders charts data
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetChartsDataSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGetChartsData(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetChartsDataSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: any): AxiosPromise<OrdersChartsResponse> {
            return localVarFp.genericOrdersControllerGetChartsData(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer
         * @param {string} gamixAppId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGetCustomerDetails(gamixAppId: string, customerId: string, options?: any): AxiosPromise<CustomerResponse> {
            return localVarFp.genericOrdersControllerGetCustomerDetails(gamixAppId, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Orders Overview chart
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetOverviewDataSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGetOverviewData(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetOverviewDataSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: any): AxiosPromise<OrdersOverviewResponse> {
            return localVarFp.genericOrdersControllerGetOverviewData(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sales statistics
         * @summary 
         * @param {string} gamixAppId 
         * @param {string} minOrderDate 
         * @param {string} maxOrderDate 
         * @param {Array<GenericOrdersControllerGetSalesStatisticsSourcesEnum>} sources 
         * @param {Array<string>} [salesRepIds] 
         * @param {Array<string>} [salesRepGroups] 
         * @param {number} [timeZoneOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerGetSalesStatistics(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetSalesStatisticsSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: any): AxiosPromise<SalesStatisticsResponse> {
            return localVarFp.genericOrdersControllerGetSalesStatistics(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend OTP
         * @param {string} gamixAppId 
         * @param {OtpResendRequest} otpResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerResendOtp(gamixAppId: string, otpResendRequest: OtpResendRequest, options?: any): AxiosPromise<OtpResponse> {
            return localVarFp.genericOrdersControllerResendOtp(gamixAppId, otpResendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return order
         * @param {string} gamixAppId 
         * @param {OrdersReturnRequest} ordersReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerReturn(gamixAppId: string, ordersReturnRequest: OrdersReturnRequest, options?: any): AxiosPromise<OrderResponse> {
            return localVarFp.genericOrdersControllerReturn(gamixAppId, ordersReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerUploadCSV(gamixAppId: string, importRequest: ImportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.genericOrdersControllerUploadCSV(gamixAppId, importRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify OTP
         * @param {string} gamixAppId 
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericOrdersControllerVerifyOtp(gamixAppId: string, verifyOtpRequest: VerifyOtpRequest, options?: any): AxiosPromise<OrderResponse> {
            return localVarFp.genericOrdersControllerVerifyOtp(gamixAppId, verifyOtpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrdersHubApi - object-oriented interface
 * @export
 * @class OrdersHubApi
 * @extends {BaseAPI}
 */
export class OrdersHubApi extends BaseAPI {
    /**
     * 
     * @summary Create order
     * @param {string} gamixAppId 
     * @param {OrdersCreateRequest} ordersCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerCreate(gamixAppId: string, ordersCreateRequest: OrdersCreateRequest, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerCreate(gamixAppId, ordersCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create order with otp
     * @param {string} gamixAppId 
     * @param {OrdersCreateRequest} ordersCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerCreateOtp(gamixAppId: string, ordersCreateRequest: OrdersCreateRequest, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerCreateOtp(gamixAppId, ordersCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Order
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get orders charts data
     * @summary 
     * @param {string} gamixAppId 
     * @param {string} minOrderDate 
     * @param {string} maxOrderDate 
     * @param {Array<GenericOrdersControllerGetChartsDataSourcesEnum>} sources 
     * @param {Array<string>} [salesRepIds] 
     * @param {Array<string>} [salesRepGroups] 
     * @param {number} [timeZoneOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerGetChartsData(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetChartsDataSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerGetChartsData(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer
     * @param {string} gamixAppId 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerGetCustomerDetails(gamixAppId: string, customerId: string, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerGetCustomerDetails(gamixAppId, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Orders Overview chart
     * @summary 
     * @param {string} gamixAppId 
     * @param {string} minOrderDate 
     * @param {string} maxOrderDate 
     * @param {Array<GenericOrdersControllerGetOverviewDataSourcesEnum>} sources 
     * @param {Array<string>} [salesRepIds] 
     * @param {Array<string>} [salesRepGroups] 
     * @param {number} [timeZoneOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerGetOverviewData(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetOverviewDataSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerGetOverviewData(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sales statistics
     * @summary 
     * @param {string} gamixAppId 
     * @param {string} minOrderDate 
     * @param {string} maxOrderDate 
     * @param {Array<GenericOrdersControllerGetSalesStatisticsSourcesEnum>} sources 
     * @param {Array<string>} [salesRepIds] 
     * @param {Array<string>} [salesRepGroups] 
     * @param {number} [timeZoneOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerGetSalesStatistics(gamixAppId: string, minOrderDate: string, maxOrderDate: string, sources: Array<GenericOrdersControllerGetSalesStatisticsSourcesEnum>, salesRepIds?: Array<string>, salesRepGroups?: Array<string>, timeZoneOffset?: number, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerGetSalesStatistics(gamixAppId, minOrderDate, maxOrderDate, sources, salesRepIds, salesRepGroups, timeZoneOffset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend OTP
     * @param {string} gamixAppId 
     * @param {OtpResendRequest} otpResendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerResendOtp(gamixAppId: string, otpResendRequest: OtpResendRequest, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerResendOtp(gamixAppId, otpResendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return order
     * @param {string} gamixAppId 
     * @param {OrdersReturnRequest} ordersReturnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerReturn(gamixAppId: string, ordersReturnRequest: OrdersReturnRequest, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerReturn(gamixAppId, ordersReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} gamixAppId 
     * @param {ImportRequest} importRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerUploadCSV(gamixAppId: string, importRequest: ImportRequest, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerUploadCSV(gamixAppId, importRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify OTP
     * @param {string} gamixAppId 
     * @param {VerifyOtpRequest} verifyOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersHubApi
     */
    public genericOrdersControllerVerifyOtp(gamixAppId: string, verifyOtpRequest: VerifyOtpRequest, options?: RawAxiosRequestConfig) {
        return OrdersHubApiFp(this.configuration).genericOrdersControllerVerifyOtp(gamixAppId, verifyOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GenericOrdersControllerGetChartsDataSourcesEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;
export type GenericOrdersControllerGetChartsDataSourcesEnum = typeof GenericOrdersControllerGetChartsDataSourcesEnum[keyof typeof GenericOrdersControllerGetChartsDataSourcesEnum];
/**
 * @export
 */
export const GenericOrdersControllerGetOverviewDataSourcesEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;
export type GenericOrdersControllerGetOverviewDataSourcesEnum = typeof GenericOrdersControllerGetOverviewDataSourcesEnum[keyof typeof GenericOrdersControllerGetOverviewDataSourcesEnum];
/**
 * @export
 */
export const GenericOrdersControllerGetSalesStatisticsSourcesEnum = {
    Online: 'online',
    Offline: 'offline',
    Omni: 'omni'
} as const;
export type GenericOrdersControllerGetSalesStatisticsSourcesEnum = typeof GenericOrdersControllerGetSalesStatisticsSourcesEnum[keyof typeof GenericOrdersControllerGetSalesStatisticsSourcesEnum];


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Product
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('productsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsControllerGet', 'id', id)
            const localVarPath = `/v2/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product By ExternalId
         * @param {string} gamixAppId 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetByExternalId: async (gamixAppId: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('productsControllerGetByExternalId', 'gamixAppId', gamixAppId)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('productsControllerGetByExternalId', 'externalId', externalId)
            const localVarPath = `/v2/products/external-id/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Products
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerList: async (gamixAppId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('productsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Popular Products
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {string} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerPopular: async (gamixAppId: string, limit: number, category?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('productsControllerPopular', 'gamixAppId', gamixAppId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('productsControllerPopular', 'limit', limit)
            const localVarPath = `/v2/products/popular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Popular Products Categories
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerPopularCategories: async (gamixAppId: string, limit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('productsControllerPopularCategories', 'gamixAppId', gamixAppId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('productsControllerPopularCategories', 'limit', limit)
            const localVarPath = `/v2/products/category/popular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Products Search
         * @param {string} gamixAppId 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerSearch: async (gamixAppId: string, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('productsControllerSearch', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/products/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sync Products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerSyncGlobalProperties: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/products/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerUpdate: async (appId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appId' is not null or undefined
            assertParamExists('productsControllerUpdate', 'appId', appId)
            const localVarPath = `/v2/products/apps/{appId}/hooks`
                .replace(`{${"appId"}}`, encodeURIComponent(String(appId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Product By ExternalId
         * @param {string} gamixAppId 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerUpdateByExternalId: async (gamixAppId: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('productsControllerUpdateByExternalId', 'gamixAppId', gamixAppId)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('productsControllerUpdateByExternalId', 'externalId', externalId)
            const localVarPath = `/v2/products/external-id/{externalId}/reload`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Product
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Product By ExternalId
         * @param {string} gamixAppId 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerGetByExternalId(gamixAppId: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerGetByExternalId(gamixAppId, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerGetByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Products
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerList(gamixAppId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Popular Products
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {string} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerPopular(gamixAppId: string, limit: number, category?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopularProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerPopular(gamixAppId, limit, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerPopular']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Popular Products Categories
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerPopularCategories(gamixAppId: string, limit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopularCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerPopularCategories(gamixAppId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerPopularCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Products Search
         * @param {string} gamixAppId 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerSearch(gamixAppId: string, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerSearch(gamixAppId, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary sync Products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerSyncGlobalProperties(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerSyncGlobalProperties(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerSyncGlobalProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerUpdate(appId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerUpdate(appId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Product By ExternalId
         * @param {string} gamixAppId 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerUpdateByExternalId(gamixAppId: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerUpdateByExternalId(gamixAppId, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productsControllerUpdateByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Product
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<ProductResponse> {
            return localVarFp.productsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Product By ExternalId
         * @param {string} gamixAppId 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetByExternalId(gamixAppId: string, externalId: string, options?: any): AxiosPromise<ProductResponse> {
            return localVarFp.productsControllerGetByExternalId(gamixAppId, externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Products
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: any): AxiosPromise<ProductsResponse> {
            return localVarFp.productsControllerList(gamixAppId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Popular Products
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {string} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerPopular(gamixAppId: string, limit: number, category?: string, options?: any): AxiosPromise<PopularProductsResponse> {
            return localVarFp.productsControllerPopular(gamixAppId, limit, category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Popular Products Categories
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerPopularCategories(gamixAppId: string, limit: number, options?: any): AxiosPromise<PopularCategoriesResponse> {
            return localVarFp.productsControllerPopularCategories(gamixAppId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Products Search
         * @param {string} gamixAppId 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerSearch(gamixAppId: string, keyword?: string, options?: any): AxiosPromise<ProductSearchResponse> {
            return localVarFp.productsControllerSearch(gamixAppId, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sync Products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerSyncGlobalProperties(options?: any): AxiosPromise<void> {
            return localVarFp.productsControllerSyncGlobalProperties(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerUpdate(appId: string, options?: any): AxiosPromise<void> {
            return localVarFp.productsControllerUpdate(appId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Product By ExternalId
         * @param {string} gamixAppId 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerUpdateByExternalId(gamixAppId: string, externalId: string, options?: any): AxiosPromise<ProductResponse> {
            return localVarFp.productsControllerUpdateByExternalId(gamixAppId, externalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @summary Get Product
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Product By ExternalId
     * @param {string} gamixAppId 
     * @param {string} externalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerGetByExternalId(gamixAppId: string, externalId: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerGetByExternalId(gamixAppId, externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Products
     * @param {string} gamixAppId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerList(gamixAppId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Popular Products
     * @param {string} gamixAppId 
     * @param {number} limit 
     * @param {string} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerPopular(gamixAppId: string, limit: number, category?: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerPopular(gamixAppId, limit, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Popular Products Categories
     * @param {string} gamixAppId 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerPopularCategories(gamixAppId: string, limit: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerPopularCategories(gamixAppId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Products Search
     * @param {string} gamixAppId 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerSearch(gamixAppId: string, keyword?: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerSearch(gamixAppId, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sync Products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerSyncGlobalProperties(options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerSyncGlobalProperties(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerUpdate(appId: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerUpdate(appId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Product By ExternalId
     * @param {string} gamixAppId 
     * @param {string} externalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerUpdateByExternalId(gamixAppId: string, externalId: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerUpdateByExternalId(gamixAppId, externalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProspectDiscountApi - axios parameter creator
 * @export
 */
export const ProspectDiscountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update Prospect Discount ignored Status
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prospectDiscountControllerIgnore: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('prospectDiscountControllerIgnore', 'token', token)
            const localVarPath = `/v2/ecommerce/prospect-discount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProspectDiscountApi - functional programming interface
 * @export
 */
export const ProspectDiscountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProspectDiscountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update Prospect Discount ignored Status
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prospectDiscountControllerIgnore(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prospectDiscountControllerIgnore(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProspectDiscountApi.prospectDiscountControllerIgnore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProspectDiscountApi - factory interface
 * @export
 */
export const ProspectDiscountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProspectDiscountApiFp(configuration)
    return {
        /**
         * 
         * @summary Update Prospect Discount ignored Status
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prospectDiscountControllerIgnore(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.prospectDiscountControllerIgnore(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProspectDiscountApi - object-oriented interface
 * @export
 * @class ProspectDiscountApi
 * @extends {BaseAPI}
 */
export class ProspectDiscountApi extends BaseAPI {
    /**
     * 
     * @summary Update Prospect Discount ignored Status
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProspectDiscountApi
     */
    public prospectDiscountControllerIgnore(token: string, options?: RawAxiosRequestConfig) {
        return ProspectDiscountApiFp(this.configuration).prospectDiscountControllerIgnore(token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PurchasesApi - axios parameter creator
 * @export
 */
export const PurchasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create App Purchase
         * @param {string} gamixAppId 
         * @param {AppPurchaseCreateRequest} appPurchaseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appPurchasesControllerCreate: async (gamixAppId: string, appPurchaseCreateRequest: AppPurchaseCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appPurchasesControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'appPurchaseCreateRequest' is not null or undefined
            assertParamExists('appPurchasesControllerCreate', 'appPurchaseCreateRequest', appPurchaseCreateRequest)
            const localVarPath = `/v2/purchases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appPurchaseCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete App Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appPurchasesControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appPurchasesControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appPurchasesControllerDelete', 'id', id)
            const localVarPath = `/v2/purchases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get App Purchase
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appPurchasesControllerGet: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appPurchasesControllerGet', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/purchases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update App Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppPurchaseUpdateRequest} appPurchaseUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appPurchasesControllerUpdate: async (gamixAppId: string, id: string, appPurchaseUpdateRequest: AppPurchaseUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appPurchasesControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appPurchasesControllerUpdate', 'id', id)
            // verify required parameter 'appPurchaseUpdateRequest' is not null or undefined
            assertParamExists('appPurchasesControllerUpdate', 'appPurchaseUpdateRequest', appPurchaseUpdateRequest)
            const localVarPath = `/v2/purchases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appPurchaseUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchasesApi - functional programming interface
 * @export
 */
export const PurchasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create App Purchase
         * @param {string} gamixAppId 
         * @param {AppPurchaseCreateRequest} appPurchaseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appPurchasesControllerCreate(gamixAppId: string, appPurchaseCreateRequest: AppPurchaseCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppPurchaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appPurchasesControllerCreate(gamixAppId, appPurchaseCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchasesApi.appPurchasesControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete App Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appPurchasesControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appPurchasesControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchasesApi.appPurchasesControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get App Purchase
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appPurchasesControllerGet(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppPurchaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appPurchasesControllerGet(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchasesApi.appPurchasesControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update App Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppPurchaseUpdateRequest} appPurchaseUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appPurchasesControllerUpdate(gamixAppId: string, id: string, appPurchaseUpdateRequest: AppPurchaseUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppPurchaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appPurchasesControllerUpdate(gamixAppId, id, appPurchaseUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchasesApi.appPurchasesControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PurchasesApi - factory interface
 * @export
 */
export const PurchasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchasesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create App Purchase
         * @param {string} gamixAppId 
         * @param {AppPurchaseCreateRequest} appPurchaseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appPurchasesControllerCreate(gamixAppId: string, appPurchaseCreateRequest: AppPurchaseCreateRequest, options?: any): AxiosPromise<AppPurchaseResponse> {
            return localVarFp.appPurchasesControllerCreate(gamixAppId, appPurchaseCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete App Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appPurchasesControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.appPurchasesControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get App Purchase
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appPurchasesControllerGet(gamixAppId: string, options?: any): AxiosPromise<AppPurchaseResponse> {
            return localVarFp.appPurchasesControllerGet(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update App Purchase
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppPurchaseUpdateRequest} appPurchaseUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appPurchasesControllerUpdate(gamixAppId: string, id: string, appPurchaseUpdateRequest: AppPurchaseUpdateRequest, options?: any): AxiosPromise<AppPurchaseResponse> {
            return localVarFp.appPurchasesControllerUpdate(gamixAppId, id, appPurchaseUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchasesApi - object-oriented interface
 * @export
 * @class PurchasesApi
 * @extends {BaseAPI}
 */
export class PurchasesApi extends BaseAPI {
    /**
     * 
     * @summary Create App Purchase
     * @param {string} gamixAppId 
     * @param {AppPurchaseCreateRequest} appPurchaseCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchasesApi
     */
    public appPurchasesControllerCreate(gamixAppId: string, appPurchaseCreateRequest: AppPurchaseCreateRequest, options?: RawAxiosRequestConfig) {
        return PurchasesApiFp(this.configuration).appPurchasesControllerCreate(gamixAppId, appPurchaseCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete App Purchase
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchasesApi
     */
    public appPurchasesControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return PurchasesApiFp(this.configuration).appPurchasesControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get App Purchase
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchasesApi
     */
    public appPurchasesControllerGet(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return PurchasesApiFp(this.configuration).appPurchasesControllerGet(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update App Purchase
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {AppPurchaseUpdateRequest} appPurchaseUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchasesApi
     */
    public appPurchasesControllerUpdate(gamixAppId: string, id: string, appPurchaseUpdateRequest: AppPurchaseUpdateRequest, options?: RawAxiosRequestConfig) {
        return PurchasesApiFp(this.configuration).appPurchasesControllerUpdate(gamixAppId, id, appPurchaseUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RedeemAPIApi - axios parameter creator
 * @export
 */
export const RedeemAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating discount codes.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerCreateArchiveApiConfig: async (gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('redeemApiControllerCreateArchiveApiConfig', 'gamixAppId', gamixAppId)
            // verify required parameter 'redeemApiDetailCreateRequest' is not null or undefined
            assertParamExists('redeemApiControllerCreateArchiveApiConfig', 'redeemApiDetailCreateRequest', redeemApiDetailCreateRequest)
            const localVarPath = `/v2/ecommerce/integrations/redeem-api/discount/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemApiDetailCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating promotions.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerCreatePromotionApiConfig: async (gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('redeemApiControllerCreatePromotionApiConfig', 'gamixAppId', gamixAppId)
            // verify required parameter 'redeemApiDetailCreateRequest' is not null or undefined
            assertParamExists('redeemApiControllerCreatePromotionApiConfig', 'redeemApiDetailCreateRequest', redeemApiDetailCreateRequest)
            const localVarPath = `/v2/ecommerce/integrations/redeem-api/promotion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemApiDetailCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating discount codes.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerCreateRedeemApiConfig: async (gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('redeemApiControllerCreateRedeemApiConfig', 'gamixAppId', gamixAppId)
            // verify required parameter 'redeemApiDetailCreateRequest' is not null or undefined
            assertParamExists('redeemApiControllerCreateRedeemApiConfig', 'redeemApiDetailCreateRequest', redeemApiDetailCreateRequest)
            const localVarPath = `/v2/ecommerce/integrations/redeem-api/discount/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemApiDetailCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get  Redeem API
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerGet: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('redeemApiControllerGet', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/integrations/redeem-api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update  Redeem API
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ApiDetailUpdateRequest} apiDetailUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerUpdate: async (gamixAppId: string, id: string, apiDetailUpdateRequest: ApiDetailUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('redeemApiControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redeemApiControllerUpdate', 'id', id)
            // verify required parameter 'apiDetailUpdateRequest' is not null or undefined
            assertParamExists('redeemApiControllerUpdate', 'apiDetailUpdateRequest', apiDetailUpdateRequest)
            const localVarPath = `/v2/ecommerce/integrations/redeem-api/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDetailUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedeemAPIApi - functional programming interface
 * @export
 */
export const RedeemAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RedeemAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating discount codes.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemApiControllerCreateArchiveApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemApiControllerCreateArchiveApiConfig(gamixAppId, redeemApiDetailCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RedeemAPIApi.redeemApiControllerCreateArchiveApiConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating promotions.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemApiControllerCreatePromotionApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemApiControllerCreatePromotionApiConfig(gamixAppId, redeemApiDetailCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RedeemAPIApi.redeemApiControllerCreatePromotionApiConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating discount codes.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemApiControllerCreateRedeemApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemApiControllerCreateRedeemApiConfig(gamixAppId, redeemApiDetailCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RedeemAPIApi.redeemApiControllerCreateRedeemApiConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get  Redeem API
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemApiControllerGet(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemApiControllerGet(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RedeemAPIApi.redeemApiControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update  Redeem API
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ApiDetailUpdateRequest} apiDetailUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemApiControllerUpdate(gamixAppId: string, id: string, apiDetailUpdateRequest: ApiDetailUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemApiControllerUpdate(gamixAppId, id, apiDetailUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RedeemAPIApi.redeemApiControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RedeemAPIApi - factory interface
 * @export
 */
export const RedeemAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RedeemAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating discount codes.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerCreateArchiveApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: any): AxiosPromise<ApiDetailsResponse> {
            return localVarFp.redeemApiControllerCreateArchiveApiConfig(gamixAppId, redeemApiDetailCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating promotions.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerCreatePromotionApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: any): AxiosPromise<ApiDetailsResponse> {
            return localVarFp.redeemApiControllerCreatePromotionApiConfig(gamixAppId, redeemApiDetailCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This endpoint allows you to save an API endpoint for creating discount codes.
         * @param {string} gamixAppId 
         * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerCreateRedeemApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: any): AxiosPromise<ApiDetailsResponse> {
            return localVarFp.redeemApiControllerCreateRedeemApiConfig(gamixAppId, redeemApiDetailCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get  Redeem API
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerGet(gamixAppId: string, options?: any): AxiosPromise<ApiDetailResponse> {
            return localVarFp.redeemApiControllerGet(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update  Redeem API
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ApiDetailUpdateRequest} apiDetailUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemApiControllerUpdate(gamixAppId: string, id: string, apiDetailUpdateRequest: ApiDetailUpdateRequest, options?: any): AxiosPromise<ApiDetailResponse> {
            return localVarFp.redeemApiControllerUpdate(gamixAppId, id, apiDetailUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RedeemAPIApi - object-oriented interface
 * @export
 * @class RedeemAPIApi
 * @extends {BaseAPI}
 */
export class RedeemAPIApi extends BaseAPI {
    /**
     * 
     * @summary This endpoint allows you to save an API endpoint for creating discount codes.
     * @param {string} gamixAppId 
     * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemAPIApi
     */
    public redeemApiControllerCreateArchiveApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: RawAxiosRequestConfig) {
        return RedeemAPIApiFp(this.configuration).redeemApiControllerCreateArchiveApiConfig(gamixAppId, redeemApiDetailCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This endpoint allows you to save an API endpoint for creating promotions.
     * @param {string} gamixAppId 
     * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemAPIApi
     */
    public redeemApiControllerCreatePromotionApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: RawAxiosRequestConfig) {
        return RedeemAPIApiFp(this.configuration).redeemApiControllerCreatePromotionApiConfig(gamixAppId, redeemApiDetailCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This endpoint allows you to save an API endpoint for creating discount codes.
     * @param {string} gamixAppId 
     * @param {RedeemApiDetailCreateRequest} redeemApiDetailCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemAPIApi
     */
    public redeemApiControllerCreateRedeemApiConfig(gamixAppId: string, redeemApiDetailCreateRequest: RedeemApiDetailCreateRequest, options?: RawAxiosRequestConfig) {
        return RedeemAPIApiFp(this.configuration).redeemApiControllerCreateRedeemApiConfig(gamixAppId, redeemApiDetailCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get  Redeem API
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemAPIApi
     */
    public redeemApiControllerGet(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return RedeemAPIApiFp(this.configuration).redeemApiControllerGet(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update  Redeem API
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {ApiDetailUpdateRequest} apiDetailUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemAPIApi
     */
    public redeemApiControllerUpdate(gamixAppId: string, id: string, apiDetailUpdateRequest: ApiDetailUpdateRequest, options?: RawAxiosRequestConfig) {
        return RedeemAPIApiFp(this.configuration).redeemApiControllerUpdate(gamixAppId, id, apiDetailUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesRepGroupsApi - axios parameter creator
 * @export
 */
export const SalesRepGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create sales reps group
         * @param {string} gamixAppId 
         * @param {SalesRepGroupCreateRequest} salesRepGroupCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepGroupsControllerCreate: async (gamixAppId: string, salesRepGroupCreateRequest: SalesRepGroupCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepGroupsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'salesRepGroupCreateRequest' is not null or undefined
            assertParamExists('salesRepGroupsControllerCreate', 'salesRepGroupCreateRequest', salesRepGroupCreateRequest)
            const localVarPath = `/v2/ecommerce/sales-reps-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesRepGroupCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get sales reps groups
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepGroupsControllerGetById: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepGroupsControllerGetById', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('salesRepGroupsControllerGetById', 'id', id)
            const localVarPath = `/v2/ecommerce/sales-reps-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list sales reps groups
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepGroupsControllerList: async (gamixAppId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepGroupsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/sales-reps-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update salesRep group
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {SalesRepGroupUpdateRequest} salesRepGroupUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepGroupsControllerUpdate: async (gamixAppId: string, id: string, salesRepGroupUpdateRequest: SalesRepGroupUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepGroupsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('salesRepGroupsControllerUpdate', 'id', id)
            // verify required parameter 'salesRepGroupUpdateRequest' is not null or undefined
            assertParamExists('salesRepGroupsControllerUpdate', 'salesRepGroupUpdateRequest', salesRepGroupUpdateRequest)
            const localVarPath = `/v2/ecommerce/sales-reps-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesRepGroupUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesRepGroupsApi - functional programming interface
 * @export
 */
export const SalesRepGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesRepGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create sales reps group
         * @param {string} gamixAppId 
         * @param {SalesRepGroupCreateRequest} salesRepGroupCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepGroupsControllerCreate(gamixAppId: string, salesRepGroupCreateRequest: SalesRepGroupCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepGroupsControllerCreate(gamixAppId, salesRepGroupCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepGroupsApi.salesRepGroupsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get sales reps groups
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepGroupsControllerGetById(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepGroupsControllerGetById(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepGroupsApi.salesRepGroupsControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list sales reps groups
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepGroupsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepGroupsControllerList(gamixAppId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepGroupsApi.salesRepGroupsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update salesRep group
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {SalesRepGroupUpdateRequest} salesRepGroupUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepGroupsControllerUpdate(gamixAppId: string, id: string, salesRepGroupUpdateRequest: SalesRepGroupUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepGroupsControllerUpdate(gamixAppId, id, salesRepGroupUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepGroupsApi.salesRepGroupsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesRepGroupsApi - factory interface
 * @export
 */
export const SalesRepGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesRepGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary create sales reps group
         * @param {string} gamixAppId 
         * @param {SalesRepGroupCreateRequest} salesRepGroupCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepGroupsControllerCreate(gamixAppId: string, salesRepGroupCreateRequest: SalesRepGroupCreateRequest, options?: any): AxiosPromise<SalesRepGroupResponse> {
            return localVarFp.salesRepGroupsControllerCreate(gamixAppId, salesRepGroupCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get sales reps groups
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepGroupsControllerGetById(gamixAppId: string, id: string, options?: any): AxiosPromise<SalesRepGroupsResponse> {
            return localVarFp.salesRepGroupsControllerGetById(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list sales reps groups
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepGroupsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: any): AxiosPromise<SalesRepGroupsResponse> {
            return localVarFp.salesRepGroupsControllerList(gamixAppId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update salesRep group
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {SalesRepGroupUpdateRequest} salesRepGroupUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepGroupsControllerUpdate(gamixAppId: string, id: string, salesRepGroupUpdateRequest: SalesRepGroupUpdateRequest, options?: any): AxiosPromise<SalesRepGroupResponse> {
            return localVarFp.salesRepGroupsControllerUpdate(gamixAppId, id, salesRepGroupUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesRepGroupsApi - object-oriented interface
 * @export
 * @class SalesRepGroupsApi
 * @extends {BaseAPI}
 */
export class SalesRepGroupsApi extends BaseAPI {
    /**
     * 
     * @summary create sales reps group
     * @param {string} gamixAppId 
     * @param {SalesRepGroupCreateRequest} salesRepGroupCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepGroupsApi
     */
    public salesRepGroupsControllerCreate(gamixAppId: string, salesRepGroupCreateRequest: SalesRepGroupCreateRequest, options?: RawAxiosRequestConfig) {
        return SalesRepGroupsApiFp(this.configuration).salesRepGroupsControllerCreate(gamixAppId, salesRepGroupCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get sales reps groups
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepGroupsApi
     */
    public salesRepGroupsControllerGetById(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SalesRepGroupsApiFp(this.configuration).salesRepGroupsControllerGetById(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list sales reps groups
     * @param {string} gamixAppId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepGroupsApi
     */
    public salesRepGroupsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return SalesRepGroupsApiFp(this.configuration).salesRepGroupsControllerList(gamixAppId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update salesRep group
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {SalesRepGroupUpdateRequest} salesRepGroupUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepGroupsApi
     */
    public salesRepGroupsControllerUpdate(gamixAppId: string, id: string, salesRepGroupUpdateRequest: SalesRepGroupUpdateRequest, options?: RawAxiosRequestConfig) {
        return SalesRepGroupsApiFp(this.configuration).salesRepGroupsControllerUpdate(gamixAppId, id, salesRepGroupUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesRepsApi - axios parameter creator
 * @export
 */
export const SalesRepsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add a sales rep to the group
         * @param {string} gamixAppId 
         * @param {Array<SalesRepAddRequest>} salesRepAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerAdd: async (gamixAppId: string, salesRepAddRequest: Array<SalesRepAddRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepsControllerAdd', 'gamixAppId', gamixAppId)
            // verify required parameter 'salesRepAddRequest' is not null or undefined
            assertParamExists('salesRepsControllerAdd', 'salesRepAddRequest', salesRepAddRequest)
            const localVarPath = `/v2/ecommerce/sales-reps/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesRepAddRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create sales rep
         * @param {string} gamixAppId 
         * @param {SalesRepCreateRequest} salesRepCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerCreate: async (gamixAppId: string, salesRepCreateRequest: SalesRepCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'salesRepCreateRequest' is not null or undefined
            assertParamExists('salesRepsControllerCreate', 'salesRepCreateRequest', salesRepCreateRequest)
            const localVarPath = `/v2/ecommerce/sales-reps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesRepCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete sales rep
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepsControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('salesRepsControllerDelete', 'id', id)
            const localVarPath = `/v2/ecommerce/sales-reps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get sales reps by id 
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('salesRepsControllerGet', 'id', id)
            const localVarPath = `/v2/ecommerce/sales-reps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list sales reps of an admin 
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerList: async (gamixAppId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/sales-reps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list sales reps by group 
         * @param {string} gamixAppId 
         * @param {Array<string>} [group] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerListAll: async (gamixAppId: string, group?: Array<string>, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepsControllerListAll', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/sales-reps/list/by-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (group) {
                localVarQueryParameter['group'] = group;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sales rep admin group
         * @param {string} gamixAppId 
         * @param {string} adminId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerListByAdminId: async (gamixAppId: string, adminId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepsControllerListByAdminId', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('salesRepsControllerListByAdminId', 'adminId', adminId)
            const localVarPath = `/v2/ecommerce/sales-reps/group/{adminId}`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sales rep
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {SalesRepUpdateRequest} salesRepUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerUpdate: async (gamixAppId: string, id: string, salesRepUpdateRequest: SalesRepUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('salesRepsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('salesRepsControllerUpdate', 'id', id)
            // verify required parameter 'salesRepUpdateRequest' is not null or undefined
            assertParamExists('salesRepsControllerUpdate', 'salesRepUpdateRequest', salesRepUpdateRequest)
            const localVarPath = `/v2/ecommerce/sales-reps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesRepUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesRepsApi - functional programming interface
 * @export
 */
export const SalesRepsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesRepsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add a sales rep to the group
         * @param {string} gamixAppId 
         * @param {Array<SalesRepAddRequest>} salesRepAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepsControllerAdd(gamixAppId: string, salesRepAddRequest: Array<SalesRepAddRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepsControllerAdd(gamixAppId, salesRepAddRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepsApi.salesRepsControllerAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create sales rep
         * @param {string} gamixAppId 
         * @param {SalesRepCreateRequest} salesRepCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepsControllerCreate(gamixAppId: string, salesRepCreateRequest: SalesRepCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepsControllerCreate(gamixAppId, salesRepCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepsApi.salesRepsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete sales rep
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepsControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepsApi.salesRepsControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get sales reps by id 
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepsApi.salesRepsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list sales reps of an admin 
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepsControllerList(gamixAppId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepsApi.salesRepsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list sales reps by group 
         * @param {string} gamixAppId 
         * @param {Array<string>} [group] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepsControllerListAll(gamixAppId: string, group?: Array<string>, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepsControllerListAll(gamixAppId, group, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepsApi.salesRepsControllerListAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sales rep admin group
         * @param {string} gamixAppId 
         * @param {string} adminId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepsControllerListByAdminId(gamixAppId: string, adminId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepsControllerListByAdminId(gamixAppId, adminId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepsApi.salesRepsControllerListByAdminId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update sales rep
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {SalesRepUpdateRequest} salesRepUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRepsControllerUpdate(gamixAppId: string, id: string, salesRepUpdateRequest: SalesRepUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesRepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRepsControllerUpdate(gamixAppId, id, salesRepUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesRepsApi.salesRepsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesRepsApi - factory interface
 * @export
 */
export const SalesRepsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesRepsApiFp(configuration)
    return {
        /**
         * 
         * @summary add a sales rep to the group
         * @param {string} gamixAppId 
         * @param {Array<SalesRepAddRequest>} salesRepAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerAdd(gamixAppId: string, salesRepAddRequest: Array<SalesRepAddRequest>, options?: any): AxiosPromise<SalesRepsResponse> {
            return localVarFp.salesRepsControllerAdd(gamixAppId, salesRepAddRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create sales rep
         * @param {string} gamixAppId 
         * @param {SalesRepCreateRequest} salesRepCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerCreate(gamixAppId: string, salesRepCreateRequest: SalesRepCreateRequest, options?: any): AxiosPromise<SalesRepResponse> {
            return localVarFp.salesRepsControllerCreate(gamixAppId, salesRepCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete sales rep
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.salesRepsControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get sales reps by id 
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<SalesRepResponse> {
            return localVarFp.salesRepsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list sales reps of an admin 
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: any): AxiosPromise<SalesRepListResponse> {
            return localVarFp.salesRepsControllerList(gamixAppId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list sales reps by group 
         * @param {string} gamixAppId 
         * @param {Array<string>} [group] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerListAll(gamixAppId: string, group?: Array<string>, limit?: number, skip?: number, options?: any): AxiosPromise<SalesRepListResponse> {
            return localVarFp.salesRepsControllerListAll(gamixAppId, group, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sales rep admin group
         * @param {string} gamixAppId 
         * @param {string} adminId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerListByAdminId(gamixAppId: string, adminId: string, limit?: number, skip?: number, options?: any): AxiosPromise<SalesRepListResponse> {
            return localVarFp.salesRepsControllerListByAdminId(gamixAppId, adminId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sales rep
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {SalesRepUpdateRequest} salesRepUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRepsControllerUpdate(gamixAppId: string, id: string, salesRepUpdateRequest: SalesRepUpdateRequest, options?: any): AxiosPromise<SalesRepResponse> {
            return localVarFp.salesRepsControllerUpdate(gamixAppId, id, salesRepUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesRepsApi - object-oriented interface
 * @export
 * @class SalesRepsApi
 * @extends {BaseAPI}
 */
export class SalesRepsApi extends BaseAPI {
    /**
     * 
     * @summary add a sales rep to the group
     * @param {string} gamixAppId 
     * @param {Array<SalesRepAddRequest>} salesRepAddRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepsApi
     */
    public salesRepsControllerAdd(gamixAppId: string, salesRepAddRequest: Array<SalesRepAddRequest>, options?: RawAxiosRequestConfig) {
        return SalesRepsApiFp(this.configuration).salesRepsControllerAdd(gamixAppId, salesRepAddRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create sales rep
     * @param {string} gamixAppId 
     * @param {SalesRepCreateRequest} salesRepCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepsApi
     */
    public salesRepsControllerCreate(gamixAppId: string, salesRepCreateRequest: SalesRepCreateRequest, options?: RawAxiosRequestConfig) {
        return SalesRepsApiFp(this.configuration).salesRepsControllerCreate(gamixAppId, salesRepCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete sales rep
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepsApi
     */
    public salesRepsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SalesRepsApiFp(this.configuration).salesRepsControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get sales reps by id 
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepsApi
     */
    public salesRepsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SalesRepsApiFp(this.configuration).salesRepsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list sales reps of an admin 
     * @param {string} gamixAppId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepsApi
     */
    public salesRepsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return SalesRepsApiFp(this.configuration).salesRepsControllerList(gamixAppId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list sales reps by group 
     * @param {string} gamixAppId 
     * @param {Array<string>} [group] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepsApi
     */
    public salesRepsControllerListAll(gamixAppId: string, group?: Array<string>, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return SalesRepsApiFp(this.configuration).salesRepsControllerListAll(gamixAppId, group, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sales rep admin group
     * @param {string} gamixAppId 
     * @param {string} adminId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepsApi
     */
    public salesRepsControllerListByAdminId(gamixAppId: string, adminId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return SalesRepsApiFp(this.configuration).salesRepsControllerListByAdminId(gamixAppId, adminId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sales rep
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {SalesRepUpdateRequest} salesRepUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesRepsApi
     */
    public salesRepsControllerUpdate(gamixAppId: string, id: string, salesRepUpdateRequest: SalesRepUpdateRequest, options?: RawAxiosRequestConfig) {
        return SalesRepsApiFp(this.configuration).salesRepsControllerUpdate(gamixAppId, id, salesRepUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TotvsBonusApi - axios parameter creator
 * @export
 */
export const TotvsBonusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary return order
         * @param {CancelBonusRequest} cancelBonusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsBonusControllerCancel: async (cancelBonusRequest: CancelBonusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelBonusRequest' is not null or undefined
            assertParamExists('totvsBonusControllerCancel', 'cancelBonusRequest', cancelBonusRequest)
            const localVarPath = `/v2/totvs/bonuses/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelBonusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary finalize order with bonus
         * @param {FinalizeBonusRequest} finalizeBonusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsBonusControllerFinalize: async (finalizeBonusRequest: FinalizeBonusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'finalizeBonusRequest' is not null or undefined
            assertParamExists('totvsBonusControllerFinalize', 'finalizeBonusRequest', finalizeBonusRequest)
            const localVarPath = `/v2/totvs/bonuses/finalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalizeBonusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get applicable discount
         * @param {BonusInitialRequest} bonusInitialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsBonusControllerGetApplicableBonus: async (bonusInitialRequest: BonusInitialRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bonusInitialRequest' is not null or undefined
            assertParamExists('totvsBonusControllerGetApplicableBonus', 'bonusInitialRequest', bonusInitialRequest)
            const localVarPath = `/v2/totvs/bonuses/bonus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bonusInitialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TotvsBonusApi - functional programming interface
 * @export
 */
export const TotvsBonusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TotvsBonusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary return order
         * @param {CancelBonusRequest} cancelBonusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totvsBonusControllerCancel(cancelBonusRequest: CancelBonusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelBonusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totvsBonusControllerCancel(cancelBonusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsBonusApi.totvsBonusControllerCancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary finalize order with bonus
         * @param {FinalizeBonusRequest} finalizeBonusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totvsBonusControllerFinalize(finalizeBonusRequest: FinalizeBonusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinalizeBonusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totvsBonusControllerFinalize(finalizeBonusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsBonusApi.totvsBonusControllerFinalize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get applicable discount
         * @param {BonusInitialRequest} bonusInitialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totvsBonusControllerGetApplicableBonus(bonusInitialRequest: BonusInitialRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBonusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totvsBonusControllerGetApplicableBonus(bonusInitialRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsBonusApi.totvsBonusControllerGetApplicableBonus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TotvsBonusApi - factory interface
 * @export
 */
export const TotvsBonusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TotvsBonusApiFp(configuration)
    return {
        /**
         * 
         * @summary return order
         * @param {CancelBonusRequest} cancelBonusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsBonusControllerCancel(cancelBonusRequest: CancelBonusRequest, options?: any): AxiosPromise<CancelBonusResponse> {
            return localVarFp.totvsBonusControllerCancel(cancelBonusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary finalize order with bonus
         * @param {FinalizeBonusRequest} finalizeBonusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsBonusControllerFinalize(finalizeBonusRequest: FinalizeBonusRequest, options?: any): AxiosPromise<FinalizeBonusResponse> {
            return localVarFp.totvsBonusControllerFinalize(finalizeBonusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get applicable discount
         * @param {BonusInitialRequest} bonusInitialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsBonusControllerGetApplicableBonus(bonusInitialRequest: BonusInitialRequest, options?: any): AxiosPromise<GetBonusResponse> {
            return localVarFp.totvsBonusControllerGetApplicableBonus(bonusInitialRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TotvsBonusApi - object-oriented interface
 * @export
 * @class TotvsBonusApi
 * @extends {BaseAPI}
 */
export class TotvsBonusApi extends BaseAPI {
    /**
     * 
     * @summary return order
     * @param {CancelBonusRequest} cancelBonusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsBonusApi
     */
    public totvsBonusControllerCancel(cancelBonusRequest: CancelBonusRequest, options?: RawAxiosRequestConfig) {
        return TotvsBonusApiFp(this.configuration).totvsBonusControllerCancel(cancelBonusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary finalize order with bonus
     * @param {FinalizeBonusRequest} finalizeBonusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsBonusApi
     */
    public totvsBonusControllerFinalize(finalizeBonusRequest: FinalizeBonusRequest, options?: RawAxiosRequestConfig) {
        return TotvsBonusApiFp(this.configuration).totvsBonusControllerFinalize(finalizeBonusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get applicable discount
     * @param {BonusInitialRequest} bonusInitialRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsBonusApi
     */
    public totvsBonusControllerGetApplicableBonus(bonusInitialRequest: BonusInitialRequest, options?: RawAxiosRequestConfig) {
        return TotvsBonusApiFp(this.configuration).totvsBonusControllerGetApplicableBonus(bonusInitialRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TotvsIdentificationApi - axios parameter creator
 * @export
 */
export const TotvsIdentificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticate totvs user - validate otp
         * @param {AuthenticationRequest} authenticationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identificationControllerAuthenticateIdentifiedUser: async (authenticationRequest: AuthenticationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authenticationRequest' is not null or undefined
            assertParamExists('identificationControllerAuthenticateIdentifiedUser', 'authenticationRequest', authenticationRequest)
            const localVarPath = `/v2/totvs/identifications/authentication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get totvs identification forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identificationControllerGetIdentificationForms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/totvs/identifications/forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Identify totvs user - send otp
         * @param {IdentificationRequest} identificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identificationControllerIdentifyUser: async (identificationRequest: IdentificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identificationRequest' is not null or undefined
            assertParamExists('identificationControllerIdentifyUser', 'identificationRequest', identificationRequest)
            const localVarPath = `/v2/totvs/identifications/identification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(identificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TotvsIdentificationApi - functional programming interface
 * @export
 */
export const TotvsIdentificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TotvsIdentificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticate totvs user - validate otp
         * @param {AuthenticationRequest} authenticationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identificationControllerAuthenticateIdentifiedUser(authenticationRequest: AuthenticationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAuthenticateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identificationControllerAuthenticateIdentifiedUser(authenticationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsIdentificationApi.identificationControllerAuthenticateIdentifiedUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get totvs identification forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identificationControllerGetIdentificationForms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentificationFormResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identificationControllerGetIdentificationForms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsIdentificationApi.identificationControllerGetIdentificationForms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Identify totvs user - send otp
         * @param {IdentificationRequest} identificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identificationControllerIdentifyUser(identificationRequest: IdentificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserIdentifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identificationControllerIdentifyUser(identificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsIdentificationApi.identificationControllerIdentifyUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TotvsIdentificationApi - factory interface
 * @export
 */
export const TotvsIdentificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TotvsIdentificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticate totvs user - validate otp
         * @param {AuthenticationRequest} authenticationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identificationControllerAuthenticateIdentifiedUser(authenticationRequest: AuthenticationRequest, options?: any): AxiosPromise<UserAuthenticateResponse> {
            return localVarFp.identificationControllerAuthenticateIdentifiedUser(authenticationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get totvs identification forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identificationControllerGetIdentificationForms(options?: any): AxiosPromise<IdentificationFormResponse> {
            return localVarFp.identificationControllerGetIdentificationForms(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Identify totvs user - send otp
         * @param {IdentificationRequest} identificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identificationControllerIdentifyUser(identificationRequest: IdentificationRequest, options?: any): AxiosPromise<UserIdentifyResponse> {
            return localVarFp.identificationControllerIdentifyUser(identificationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TotvsIdentificationApi - object-oriented interface
 * @export
 * @class TotvsIdentificationApi
 * @extends {BaseAPI}
 */
export class TotvsIdentificationApi extends BaseAPI {
    /**
     * 
     * @summary Authenticate totvs user - validate otp
     * @param {AuthenticationRequest} authenticationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsIdentificationApi
     */
    public identificationControllerAuthenticateIdentifiedUser(authenticationRequest: AuthenticationRequest, options?: RawAxiosRequestConfig) {
        return TotvsIdentificationApiFp(this.configuration).identificationControllerAuthenticateIdentifiedUser(authenticationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get totvs identification forms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsIdentificationApi
     */
    public identificationControllerGetIdentificationForms(options?: RawAxiosRequestConfig) {
        return TotvsIdentificationApiFp(this.configuration).identificationControllerGetIdentificationForms(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Identify totvs user - send otp
     * @param {IdentificationRequest} identificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsIdentificationApi
     */
    public identificationControllerIdentifyUser(identificationRequest: IdentificationRequest, options?: RawAxiosRequestConfig) {
        return TotvsIdentificationApiFp(this.configuration).identificationControllerIdentifyUser(identificationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TotvsOrderApi - axios parameter creator
 * @export
 */
export const TotvsOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get totvs campaign
         * @param {TotvsCampaignRequest} totvsCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsCampaignControllerGetCampaign: async (totvsCampaignRequest: TotvsCampaignRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'totvsCampaignRequest' is not null or undefined
            assertParamExists('totvsCampaignControllerGetCampaign', 'totvsCampaignRequest', totvsCampaignRequest)
            const localVarPath = `/v2/totvs/campaign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(totvsCampaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create totvs order
         * @param {TotvsOrderRequest} totvsOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsOrdersControllerOrder: async (totvsOrderRequest: TotvsOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'totvsOrderRequest' is not null or undefined
            assertParamExists('totvsOrdersControllerOrder', 'totvsOrderRequest', totvsOrderRequest)
            const localVarPath = `/v2/totvs/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(totvsOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TotvsOrderApi - functional programming interface
 * @export
 */
export const TotvsOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TotvsOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get totvs campaign
         * @param {TotvsCampaignRequest} totvsCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totvsCampaignControllerGetCampaign(totvsCampaignRequest: TotvsCampaignRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotvsCampaignResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totvsCampaignControllerGetCampaign(totvsCampaignRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsOrderApi.totvsCampaignControllerGetCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create totvs order
         * @param {TotvsOrderRequest} totvsOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totvsOrdersControllerOrder(totvsOrderRequest: TotvsOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotvsOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totvsOrdersControllerOrder(totvsOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsOrderApi.totvsOrdersControllerOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TotvsOrderApi - factory interface
 * @export
 */
export const TotvsOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TotvsOrderApiFp(configuration)
    return {
        /**
         * 
         * @summary Get totvs campaign
         * @param {TotvsCampaignRequest} totvsCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsCampaignControllerGetCampaign(totvsCampaignRequest: TotvsCampaignRequest, options?: any): AxiosPromise<TotvsCampaignResponse> {
            return localVarFp.totvsCampaignControllerGetCampaign(totvsCampaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create totvs order
         * @param {TotvsOrderRequest} totvsOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsOrdersControllerOrder(totvsOrderRequest: TotvsOrderRequest, options?: any): AxiosPromise<TotvsOrderResponse> {
            return localVarFp.totvsOrdersControllerOrder(totvsOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TotvsOrderApi - object-oriented interface
 * @export
 * @class TotvsOrderApi
 * @extends {BaseAPI}
 */
export class TotvsOrderApi extends BaseAPI {
    /**
     * 
     * @summary Get totvs campaign
     * @param {TotvsCampaignRequest} totvsCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsOrderApi
     */
    public totvsCampaignControllerGetCampaign(totvsCampaignRequest: TotvsCampaignRequest, options?: RawAxiosRequestConfig) {
        return TotvsOrderApiFp(this.configuration).totvsCampaignControllerGetCampaign(totvsCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create totvs order
     * @param {TotvsOrderRequest} totvsOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsOrderApi
     */
    public totvsOrdersControllerOrder(totvsOrderRequest: TotvsOrderRequest, options?: RawAxiosRequestConfig) {
        return TotvsOrderApiFp(this.configuration).totvsOrdersControllerOrder(totvsOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TotvsPartnerApi - axios parameter creator
 * @export
 */
export const TotvsPartnerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create totvs parnter
         * @param {PartnerRequest} partnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsPartnerControllerCreatePartner: async (partnerRequest: PartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerRequest' is not null or undefined
            assertParamExists('totvsPartnerControllerCreatePartner', 'partnerRequest', partnerRequest)
            const localVarPath = `/v2/totvs/partner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get totvs parnter
         * @param {PartnerRequest} partnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsPartnerControllerGetPartner: async (partnerRequest: PartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerRequest' is not null or undefined
            assertParamExists('totvsPartnerControllerGetPartner', 'partnerRequest', partnerRequest)
            const localVarPath = `/v2/totvs/partner/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication totvsHeader required
            await setApiKeyToObject(localVarHeaderParameter, "authorizationcode", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TotvsPartnerApi - functional programming interface
 * @export
 */
export const TotvsPartnerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TotvsPartnerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create totvs parnter
         * @param {PartnerRequest} partnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totvsPartnerControllerCreatePartner(partnerRequest: PartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totvsPartnerControllerCreatePartner(partnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsPartnerApi.totvsPartnerControllerCreatePartner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get totvs parnter
         * @param {PartnerRequest} partnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totvsPartnerControllerGetPartner(partnerRequest: PartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totvsPartnerControllerGetPartner(partnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TotvsPartnerApi.totvsPartnerControllerGetPartner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TotvsPartnerApi - factory interface
 * @export
 */
export const TotvsPartnerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TotvsPartnerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create totvs parnter
         * @param {PartnerRequest} partnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsPartnerControllerCreatePartner(partnerRequest: PartnerRequest, options?: any): AxiosPromise<PartnerResponse> {
            return localVarFp.totvsPartnerControllerCreatePartner(partnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get totvs parnter
         * @param {PartnerRequest} partnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totvsPartnerControllerGetPartner(partnerRequest: PartnerRequest, options?: any): AxiosPromise<PartnerResponse> {
            return localVarFp.totvsPartnerControllerGetPartner(partnerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TotvsPartnerApi - object-oriented interface
 * @export
 * @class TotvsPartnerApi
 * @extends {BaseAPI}
 */
export class TotvsPartnerApi extends BaseAPI {
    /**
     * 
     * @summary Create totvs parnter
     * @param {PartnerRequest} partnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsPartnerApi
     */
    public totvsPartnerControllerCreatePartner(partnerRequest: PartnerRequest, options?: RawAxiosRequestConfig) {
        return TotvsPartnerApiFp(this.configuration).totvsPartnerControllerCreatePartner(partnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get totvs parnter
     * @param {PartnerRequest} partnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotvsPartnerApi
     */
    public totvsPartnerControllerGetPartner(partnerRequest: PartnerRequest, options?: RawAxiosRequestConfig) {
        return TotvsPartnerApiFp(this.configuration).totvsPartnerControllerGetPartner(partnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserFreeShippingApi - axios parameter creator
 * @export
 */
export const UserFreeShippingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current user free shipping
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFreeShippingControllerGetActiveUserFreeShipping: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userFreeShippingControllerGetActiveUserFreeShipping', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/free-shipping/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List user free shipping
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFreeShippingControllerListByUser: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userFreeShippingControllerListByUser', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/free-shipping/users/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserFreeShippingApi - functional programming interface
 * @export
 */
export const UserFreeShippingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserFreeShippingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current user free shipping
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFreeShippingControllerGetActiveUserFreeShipping(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFreeShippingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFreeShippingControllerGetActiveUserFreeShipping(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserFreeShippingApi.userFreeShippingControllerGetActiveUserFreeShipping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List user free shipping
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFreeShippingControllerListByUser(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFreeShippingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFreeShippingControllerListByUser(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserFreeShippingApi.userFreeShippingControllerListByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserFreeShippingApi - factory interface
 * @export
 */
export const UserFreeShippingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserFreeShippingApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current user free shipping
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFreeShippingControllerGetActiveUserFreeShipping(gamixAppId: string, options?: any): AxiosPromise<UserFreeShippingResponse> {
            return localVarFp.userFreeShippingControllerGetActiveUserFreeShipping(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List user free shipping
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFreeShippingControllerListByUser(gamixAppId: string, options?: any): AxiosPromise<UserFreeShippingListResponse> {
            return localVarFp.userFreeShippingControllerListByUser(gamixAppId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserFreeShippingApi - object-oriented interface
 * @export
 * @class UserFreeShippingApi
 * @extends {BaseAPI}
 */
export class UserFreeShippingApi extends BaseAPI {
    /**
     * 
     * @summary Get current user free shipping
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFreeShippingApi
     */
    public userFreeShippingControllerGetActiveUserFreeShipping(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return UserFreeShippingApiFp(this.configuration).userFreeShippingControllerGetActiveUserFreeShipping(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List user free shipping
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFreeShippingApi
     */
    public userFreeShippingControllerListByUser(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return UserFreeShippingApiFp(this.configuration).userFreeShippingControllerListByUser(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserOrdersHubApi - axios parameter creator
 * @export
 */
export const UserOrdersHubApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get order totals by users
         * @param {string} gamixAppId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userOrdersControllerGetTotalByUser: async (gamixAppId: string, fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userOrdersControllerGetTotalByUser', 'gamixAppId', gamixAppId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('userOrdersControllerGetTotalByUser', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('userOrdersControllerGetTotalByUser', 'toDate', toDate)
            const localVarPath = `/v2/ecommerce/orders-hub/user/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserOrdersHubApi - functional programming interface
 * @export
 */
export const UserOrdersHubApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserOrdersHubApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get order totals by users
         * @param {string} gamixAppId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userOrdersControllerGetTotalByUser(gamixAppId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOrderTotalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userOrdersControllerGetTotalByUser(gamixAppId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrdersHubApi.userOrdersControllerGetTotalByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserOrdersHubApi - factory interface
 * @export
 */
export const UserOrdersHubApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserOrdersHubApiFp(configuration)
    return {
        /**
         * 
         * @summary Get order totals by users
         * @param {string} gamixAppId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userOrdersControllerGetTotalByUser(gamixAppId: string, fromDate: string, toDate: string, options?: any): AxiosPromise<UserOrderTotalResponse> {
            return localVarFp.userOrdersControllerGetTotalByUser(gamixAppId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserOrdersHubApi - object-oriented interface
 * @export
 * @class UserOrdersHubApi
 * @extends {BaseAPI}
 */
export class UserOrdersHubApi extends BaseAPI {
    /**
     * 
     * @summary Get order totals by users
     * @param {string} gamixAppId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserOrdersHubApi
     */
    public userOrdersControllerGetTotalByUser(gamixAppId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return UserOrdersHubApiFp(this.configuration).userOrdersControllerGetTotalByUser(gamixAppId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WelcomeGiftApi - axios parameter creator
 * @export
 */
export const WelcomeGiftApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create welcome gift configuration
         * @param {string} gamixAppId 
         * @param {CreateWelcomeGiftRequest} createWelcomeGiftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeGiftControllerCreate: async (gamixAppId: string, createWelcomeGiftRequest: CreateWelcomeGiftRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('welcomeGiftControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'createWelcomeGiftRequest' is not null or undefined
            assertParamExists('welcomeGiftControllerCreate', 'createWelcomeGiftRequest', createWelcomeGiftRequest)
            const localVarPath = `/v2/ecommerce/welcome-gift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWelcomeGiftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create welcome gift discount
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeGiftControllerCreateUserWelcomeGift: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('welcomeGiftControllerCreateUserWelcomeGift', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/welcome-gift/discount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get welcome gift configuration by app
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeGiftControllerGetByApp: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('welcomeGiftControllerGetByApp', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/ecommerce/welcome-gift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update welcome gift configuration
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateWelcomeGiftRequest} updateWelcomeGiftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeGiftControllerUpdate: async (gamixAppId: string, id: string, updateWelcomeGiftRequest: UpdateWelcomeGiftRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('welcomeGiftControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('welcomeGiftControllerUpdate', 'id', id)
            // verify required parameter 'updateWelcomeGiftRequest' is not null or undefined
            assertParamExists('welcomeGiftControllerUpdate', 'updateWelcomeGiftRequest', updateWelcomeGiftRequest)
            const localVarPath = `/v2/ecommerce/welcome-gift/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWelcomeGiftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WelcomeGiftApi - functional programming interface
 * @export
 */
export const WelcomeGiftApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WelcomeGiftApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create welcome gift configuration
         * @param {string} gamixAppId 
         * @param {CreateWelcomeGiftRequest} createWelcomeGiftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeGiftControllerCreate(gamixAppId: string, createWelcomeGiftRequest: CreateWelcomeGiftRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WelcomeGiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeGiftControllerCreate(gamixAppId, createWelcomeGiftRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WelcomeGiftApi.welcomeGiftControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create welcome gift discount
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeGiftControllerCreateUserWelcomeGift(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWelcomeGiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeGiftControllerCreateUserWelcomeGift(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WelcomeGiftApi.welcomeGiftControllerCreateUserWelcomeGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get welcome gift configuration by app
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeGiftControllerGetByApp(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WelcomeGiftGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeGiftControllerGetByApp(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WelcomeGiftApi.welcomeGiftControllerGetByApp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update welcome gift configuration
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateWelcomeGiftRequest} updateWelcomeGiftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeGiftControllerUpdate(gamixAppId: string, id: string, updateWelcomeGiftRequest: UpdateWelcomeGiftRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WelcomeGiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeGiftControllerUpdate(gamixAppId, id, updateWelcomeGiftRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WelcomeGiftApi.welcomeGiftControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WelcomeGiftApi - factory interface
 * @export
 */
export const WelcomeGiftApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WelcomeGiftApiFp(configuration)
    return {
        /**
         * 
         * @summary create welcome gift configuration
         * @param {string} gamixAppId 
         * @param {CreateWelcomeGiftRequest} createWelcomeGiftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeGiftControllerCreate(gamixAppId: string, createWelcomeGiftRequest: CreateWelcomeGiftRequest, options?: any): AxiosPromise<WelcomeGiftResponse> {
            return localVarFp.welcomeGiftControllerCreate(gamixAppId, createWelcomeGiftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create welcome gift discount
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeGiftControllerCreateUserWelcomeGift(gamixAppId: string, options?: any): AxiosPromise<UserWelcomeGiftResponse> {
            return localVarFp.welcomeGiftControllerCreateUserWelcomeGift(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get welcome gift configuration by app
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeGiftControllerGetByApp(gamixAppId: string, options?: any): AxiosPromise<WelcomeGiftGetResponse> {
            return localVarFp.welcomeGiftControllerGetByApp(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update welcome gift configuration
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateWelcomeGiftRequest} updateWelcomeGiftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeGiftControllerUpdate(gamixAppId: string, id: string, updateWelcomeGiftRequest: UpdateWelcomeGiftRequest, options?: any): AxiosPromise<WelcomeGiftResponse> {
            return localVarFp.welcomeGiftControllerUpdate(gamixAppId, id, updateWelcomeGiftRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WelcomeGiftApi - object-oriented interface
 * @export
 * @class WelcomeGiftApi
 * @extends {BaseAPI}
 */
export class WelcomeGiftApi extends BaseAPI {
    /**
     * 
     * @summary create welcome gift configuration
     * @param {string} gamixAppId 
     * @param {CreateWelcomeGiftRequest} createWelcomeGiftRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WelcomeGiftApi
     */
    public welcomeGiftControllerCreate(gamixAppId: string, createWelcomeGiftRequest: CreateWelcomeGiftRequest, options?: RawAxiosRequestConfig) {
        return WelcomeGiftApiFp(this.configuration).welcomeGiftControllerCreate(gamixAppId, createWelcomeGiftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create welcome gift discount
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WelcomeGiftApi
     */
    public welcomeGiftControllerCreateUserWelcomeGift(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return WelcomeGiftApiFp(this.configuration).welcomeGiftControllerCreateUserWelcomeGift(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get welcome gift configuration by app
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WelcomeGiftApi
     */
    public welcomeGiftControllerGetByApp(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return WelcomeGiftApiFp(this.configuration).welcomeGiftControllerGetByApp(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update welcome gift configuration
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {UpdateWelcomeGiftRequest} updateWelcomeGiftRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WelcomeGiftApi
     */
    public welcomeGiftControllerUpdate(gamixAppId: string, id: string, updateWelcomeGiftRequest: UpdateWelcomeGiftRequest, options?: RawAxiosRequestConfig) {
        return WelcomeGiftApiFp(this.configuration).welcomeGiftControllerUpdate(gamixAppId, id, updateWelcomeGiftRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



